export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Any: any;
  Date: any;
  DateTime: any;
  JSON: any;
  JSONObject: any;
  Money: any;
};

export type ActivateShopRequestDto = {
  supplierId?: InputMaybe<Scalars['ID']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type AddItemToCartInput = {
  cart_qty: Scalars['Int'];
  product_id: Scalars['ID'];
  profit: Scalars['Float'];
  profit_type?: InputMaybe<ProfitType>;
  user_id: Scalars['ID'];
};

export type AddPluginToUserRequestDto = {
  plugin_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type AddProductConditionToDiscountRequestDto = {
  discountId: Scalars['ID'];
  productCondition: DiscountProductConditionRequestDto;
};

export type AddProductsToCollectionInput = {
  collectionId: Scalars['ID'];
  productIds: Array<Scalars['ID']>;
};

export type AddSupplierAgreementTermsInput = {
  agreed_term?: InputMaybe<SupplierAgreementTerms>;
  supplier_id: Scalars['ID'];
};

export type AddSupplierLocationInput = {
  address: Scalars['String'];
  address_ext?: InputMaybe<Scalars['String']>;
  business_id: Scalars['ID'];
  city: Scalars['String'];
  gmap_data: Scalars['String'];
  lat: Scalars['String'];
  lng: Scalars['String'];
  name: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
  state_code: Scalars['String'];
  supplier_id?: InputMaybe<Scalars['ID']>;
};

export type Address = {
  __typename?: 'Address';
  area?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  landmark?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  area: Scalars['String'];
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  landmark?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
};

export type AgencyDetails = {
  __typename?: 'AgencyDetails';
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type AppBanner = {
  __typename?: 'AppBanner';
  banner_code?: Maybe<Scalars['String']>;
  collection: Catalog;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};

export type AppBannerFilter = {
  active?: InputMaybe<BooleanOperator>;
  country?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
};

export type AppBannerInput = {
  banner_code?: InputMaybe<Scalars['String']>;
  collection_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  url: Scalars['String'];
};

export type Auth = {
  __typename?: 'Auth';
  token: Scalars['String'];
  user: User;
};

export type AutogeneratedMainType = {
  __typename?: 'AutogeneratedMainType';
  agency_details?: Maybe<AgencyDetails>;
  currency_code?: Maybe<Scalars['String']>;
  currency_name?: Maybe<Scalars['String']>;
  currency_symbol?: Maybe<Scalars['String']>;
  discount?: Maybe<Scalars['Int']>;
  end_time?: Maybe<Scalars['Date']>;
  estimate_id?: Maybe<Scalars['String']>;
  estimate_type_details?: Maybe<EstimateTypeDetails>;
  full_price?: Maybe<Scalars['Int']>;
  time_string?: Maybe<Scalars['String']>;
  total_distance?: Maybe<Scalars['Float']>;
};

export enum BillingCycle {
  Annual = 'annual',
  Monthly = 'monthly'
}

export type BobAddress = {
  __typename?: 'BobAddress';
  city?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  entered_address?: Maybe<Scalars['String']>;
  gs_hash?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  lat?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  local_area?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  street_address?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
  zone_name?: Maybe<Scalars['String']>;
};

export type BobAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  entered_address?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  local_area?: InputMaybe<Scalars['String']>;
  street_address?: InputMaybe<Scalars['String']>;
  zone?: InputMaybe<Scalars['String']>;
};

export type BobBillingBillingTransaction = {
  __typename?: 'BobBillingBillingTransaction';
  account_code?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  payment?: Maybe<Scalars['String']>;
  payment_id?: Maybe<Scalars['String']>;
  payment_provider_id?: Maybe<Scalars['String']>;
  provider_doc_number?: Maybe<Scalars['String']>;
  shipment_id?: Maybe<Scalars['Int']>;
  shipment_reference?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  transaction_date?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  ua_doc_number?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['Float']>;
};

export type BobCancelShipmentRequestDto = {
  tracking_reference?: InputMaybe<Scalars['String']>;
};

export type BobChannel = {
  __typename?: 'BobChannel';
  account_id?: Maybe<Scalars['Int']>;
  channel_type?: Maybe<Scalars['String']>;
  channel_type_logo_square_url?: Maybe<Scalars['String']>;
  channel_type_logo_url?: Maybe<Scalars['String']>;
  channel_type_slug?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type BobCheckpoint = {
  __typename?: 'BobCheckpoint';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  status_friendly?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
  zone?: Maybe<Scalars['String']>;
};

export type BobCollectionAddressBook = {
  __typename?: 'BobCollectionAddressBook';
  account_id?: Maybe<Scalars['Int']>;
  additional_instructions?: Maybe<Scalars['String']>;
  address?: Maybe<BobAddress>;
  address_id?: Maybe<Scalars['Int']>;
  collect_after?: Maybe<Scalars['String']>;
  collect_before?: Maybe<Scalars['String']>;
  collection_lead_time?: Maybe<Scalars['Int']>;
  company?: Maybe<Scalars['String']>;
  contact_name?: Maybe<Scalars['String']>;
  contact_surname?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  custom_logo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  include_packing_slip?: Maybe<Scalars['Boolean']>;
  is_collection_address?: Maybe<Scalars['Boolean']>;
  is_default?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<BobOrderMeta>;
  mobile_number?: Maybe<Scalars['String']>;
  modified_by?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  request_collection_at?: Maybe<Scalars['String']>;
  shipping_label_email?: Maybe<Array<Maybe<Scalars['String']>>>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
};

export type BobCreateOrderRequestDto = {
  buyer_selected_shipping_cost: Scalars['Float'];
  buyer_selected_shipping_method: Scalars['String'];
  currency: Scalars['String'];
  customer_email: Scalars['String'];
  customer_name: Scalars['String'];
  customer_phone: Scalars['String'];
  customer_surname: Scalars['String'];
  delivery_address: BobAddressInput;
  order_items: Array<BobOrderItemInput>;
  payment_status: BobOrderPaymentStatus;
};

export type BobCreateShipmentRequestDto = {
  collection_address?: InputMaybe<BobAddressInput>;
  collection_after?: InputMaybe<Scalars['String']>;
  collection_before?: InputMaybe<Scalars['String']>;
  collection_contact_company?: InputMaybe<Scalars['String']>;
  collection_contact_email?: InputMaybe<Scalars['String']>;
  collection_contact_mobile_number?: InputMaybe<Scalars['String']>;
  collection_contact_name?: InputMaybe<Scalars['String']>;
  collection_min_date?: InputMaybe<Scalars['String']>;
  custom_tracking_reference?: InputMaybe<Scalars['String']>;
  declared_value?: InputMaybe<Scalars['Int']>;
  delivery_address?: InputMaybe<BobAddressInput>;
  delivery_contact_company?: InputMaybe<Scalars['String']>;
  delivery_contact_email?: InputMaybe<Scalars['String']>;
  delivery_contact_mobile_number?: InputMaybe<Scalars['String']>;
  delivery_contact_name?: InputMaybe<Scalars['String']>;
  instructions_collection?: InputMaybe<Scalars['String']>;
  instructions_delivery?: InputMaybe<Scalars['String']>;
  parcels?: InputMaybe<Array<InputMaybe<BobParcelInput>>>;
  provider_slug?: InputMaybe<Scalars['String']>;
  service_level_code?: InputMaybe<Scalars['String']>;
  timeout?: InputMaybe<Scalars['Int']>;
};

export type BobGetCourierRatesRequestDto = {
  collection_address: BobAddressInput;
  declared_value?: InputMaybe<Scalars['Int']>;
  delivery_address: BobAddressInput;
  parcels: Array<BobParcelInput>;
  providers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  service_levels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeout?: InputMaybe<Scalars['Int']>;
};

export type BobGetCourierRatesResponseDto = {
  __typename?: 'BobGetCourierRatesResponseDto';
  account_id?: Maybe<Scalars['Int']>;
  collection_address?: Maybe<BobAddress>;
  declared_value?: Maybe<Scalars['Int']>;
  delivery_address?: Maybe<BobAddress>;
  id?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_rate_requests?: Maybe<Array<Maybe<BobProviderRateRequest>>>;
  request_timeout?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['Int']>;
  total_submitted_weight_kg?: Maybe<Scalars['Float']>;
  webhook_url?: Maybe<Scalars['String']>;
};

export type BobGetOrderFulfillmentsRequestDto = {
  order_id?: InputMaybe<Scalars['Int']>;
};

export type BobGetOrderFulfillmentsResponseDto = {
  __typename?: 'BobGetOrderFulfillmentsResponseDto';
  count?: Maybe<Scalars['Int']>;
  order_fulfillments?: Maybe<Array<Maybe<BobOrderFulfillments>>>;
};

export type BobGetOrdersRequestDto = {
  /** Province */
  delivery_address_zone?: InputMaybe<Scalars['String']>;
  end_date?: InputMaybe<Scalars['Date']>;
  fulfillment_status?: InputMaybe<Scalars['String']>;
  has_delivery_address?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Scalars['String']>;
  order_by?: InputMaybe<Scalars['String']>;
  payment_status?: InputMaybe<BobOrderPaymentStatus>;
  start_date?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  tag_id?: InputMaybe<Scalars['Int']>;
  /** The reference of the fulfillment (shipment) created in the order */
  tracking_reference?: InputMaybe<Scalars['String']>;
};

export type BobGetOrdersResponseDto = {
  __typename?: 'BobGetOrdersResponseDto';
  count?: Maybe<Scalars['Int']>;
  orders?: Maybe<Array<Maybe<BobOrder>>>;
};

export type BobGetRateRequestsRequestDto = {
  id?: InputMaybe<Scalars['Int']>;
};

export type BobGetRateRequestsResponseDto = {
  __typename?: 'BobGetRateRequestsResponseDto';
  count?: Maybe<Scalars['Int']>;
  rate_requests?: Maybe<Array<Maybe<BobRateRequest>>>;
};

export type BobGetRatesAtCheckoutRequestDto = {
  collection_address: BobAddressInput;
  declared_value?: InputMaybe<Scalars['Int']>;
  delivery_address: BobAddressInput;
  handling_time?: InputMaybe<Scalars['Int']>;
  items: Array<BobRateItem>;
};

export type BobGetRatesAtCheckoutResponseDto = {
  __typename?: 'BobGetRatesAtCheckoutResponseDto';
  count?: Maybe<Scalars['Int']>;
  rates?: Maybe<Array<Maybe<BobRate>>>;
};

export type BobGetShipmentWaybillRequestDto = {
  paper_size?: InputMaybe<Scalars['String']>;
  show_email_address?: InputMaybe<Scalars['Boolean']>;
  show_order_items?: InputMaybe<Scalars['Boolean']>;
  tracking_references?: InputMaybe<Scalars['String']>;
  waybill_size?: InputMaybe<Scalars['String']>;
  waybills_per_shipment?: InputMaybe<Scalars['Int']>;
};

export type BobGetShipmentsRequestDto = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type BobGetShipmentsResponseDto = {
  __typename?: 'BobGetShipmentsResponseDto';
  count?: Maybe<Scalars['Int']>;
  shipments?: Maybe<Array<Maybe<BobShipment>>>;
};

export type BobGetTrackingEventsRequestDto = {
  tracking_reference?: InputMaybe<Scalars['String']>;
};

export type BobLiabilityCover = {
  __typename?: 'BobLiabilityCover';
  declared_value?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  provider_liability_cover?: Maybe<Scalars['Boolean']>;
};

export type BobOrder = {
  __typename?: 'BobOrder';
  account_id?: Maybe<Scalars['Int']>;
  archived_by_user?: Maybe<Scalars['String']>;
  buyer_selected_shipping_cost?: Maybe<Scalars['Float']>;
  buyer_selected_shipping_method?: Maybe<Scalars['String']>;
  channel?: Maybe<BobChannel>;
  channel_order_number?: Maybe<Scalars['String']>;
  channel_order_url?: Maybe<Scalars['String']>;
  channel_ref_id?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  created_by_user?: Maybe<BobUser>;
  currency?: Maybe<Scalars['String']>;
  customer_email?: Maybe<Scalars['String']>;
  customer_name?: Maybe<Scalars['String']>;
  customer_phone?: Maybe<Scalars['String']>;
  customer_surname?: Maybe<Scalars['String']>;
  date_placed_on_channel?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<BobAddress>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  fulfillment_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_modified_on_channel?: Maybe<Scalars['String']>;
  line_item_total?: Maybe<Scalars['Int']>;
  meta?: Maybe<BobOrderMeta>;
  note?: Maybe<Scalars['String']>;
  order_fulfillment_presets?: Maybe<BobOrderFulfillmentPreset>;
  order_fulfillments?: Maybe<Scalars['String']>;
  order_items?: Maybe<Array<Maybe<BobOrderItem>>>;
  payment_status?: Maybe<BobOrderPaymentStatus>;
  rate_request?: Maybe<BobRateRequest>;
  rate_request_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  taxes_included?: Maybe<Scalars['Boolean']>;
  time_archived?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  total_discount?: Maybe<Scalars['Int']>;
  total_fulfilled_qty?: Maybe<Scalars['Int']>;
  total_price?: Maybe<Scalars['Float']>;
  total_qty?: Maybe<Scalars['Int']>;
  total_tax?: Maybe<Scalars['Int']>;
  total_weight_kg?: Maybe<Scalars['Float']>;
};

export type BobOrderFulfillment = {
  __typename?: 'BobOrderFulfillment';
  account_id?: Maybe<Scalars['Int']>;
  batch_number?: Maybe<Scalars['String']>;
  channel_ref_id?: Maybe<Scalars['String']>;
  failed_reason?: Maybe<Scalars['String']>;
  fulfilled_by_user?: Maybe<BobUser>;
  fulfillment_provider?: Maybe<Scalars['String']>;
  fulfillment_service_level_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  items?: Maybe<Array<Maybe<BobOrderFulfillmentItem>>>;
  method?: Maybe<Scalars['String']>;
  method_id?: Maybe<Scalars['Int']>;
  method_reference?: Maybe<Scalars['String']>;
  method_status?: Maybe<Scalars['String']>;
  modified_by?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['Int']>;
};

export type BobOrderFulfillmentItem = {
  __typename?: 'BobOrderFulfillmentItem';
  id?: Maybe<Scalars['Int']>;
  order_fulfillment_id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['Int']>;
  order_item?: Maybe<BobOrderItem>;
  order_item_id?: Maybe<Scalars['Int']>;
  qty?: Maybe<Scalars['Int']>;
};

export type BobOrderFulfillmentPreset = {
  __typename?: 'BobOrderFulfillmentPreset';
  buyer_contact_number?: Maybe<Scalars['String']>;
  buyer_email?: Maybe<Scalars['String']>;
  buyer_name?: Maybe<Scalars['String']>;
  collection_address_book?: Maybe<BobCollectionAddressBook>;
  collection_address_book_id?: Maybe<Scalars['Int']>;
  collection_address_book_name?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_slug?: Maybe<Scalars['String']>;
  service_level_code?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BobOrderFulfillments = {
  __typename?: 'BobOrderFulfillments';
  buyer_collection?: Maybe<Scalars['String']>;
  order_fulfillment?: Maybe<BobOrderFulfillment>;
  shipment?: Maybe<BobShipment>;
};

export type BobOrderItem = {
  __typename?: 'BobOrderItem';
  channel_location?: Maybe<Scalars['String']>;
  channel_ref_id?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  fulfilled_qty?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  image_url?: Maybe<Scalars['String']>;
  qty?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['String']>;
  total_price?: Maybe<Scalars['Int']>;
  total_weight_kg?: Maybe<Scalars['Float']>;
  unit_price?: Maybe<Scalars['Int']>;
  unit_weight_kg?: Maybe<Scalars['Float']>;
  vendor?: Maybe<Scalars['String']>;
};

export type BobOrderItemInput = {
  channel_location?: InputMaybe<Scalars['String']>;
  channel_ref_id?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  fulfilled_qty?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  image_url?: InputMaybe<Scalars['String']>;
  qty?: InputMaybe<Scalars['Int']>;
  sku?: InputMaybe<Scalars['String']>;
  total_price?: InputMaybe<Scalars['Int']>;
  total_weight_kg?: InputMaybe<Scalars['Float']>;
  unit_price?: InputMaybe<Scalars['Int']>;
  unit_weight_kg?: InputMaybe<Scalars['Float']>;
  vendor?: InputMaybe<Scalars['String']>;
};

export type BobOrderMeta = {
  __typename?: 'BobOrderMeta';
  buyer_selected_shipping_method_codes?: Maybe<Scalars['String']>;
  original_address?: Maybe<Scalars['String']>;
};

export enum BobOrderPaymentStatus {
  Paid = 'paid',
  /** partially-paid */
  Unpaid = 'unpaid'
}

export type BobParcel = {
  __typename?: 'BobParcel';
  actual_height_cm?: Maybe<Scalars['String']>;
  actual_length_cm?: Maybe<Scalars['String']>;
  actual_weight_kg?: Maybe<Scalars['String']>;
  actual_width_cm?: Maybe<Scalars['String']>;
  custom_parcel_reference?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  is_additional?: Maybe<Scalars['String']>;
  package_id?: Maybe<Scalars['Int']>;
  provider_tracking_reference?: Maybe<Scalars['String']>;
  submitted_height_cm?: Maybe<Scalars['Float']>;
  submitted_length_cm?: Maybe<Scalars['Float']>;
  submitted_weight_kg?: Maybe<Scalars['Float']>;
  submitted_width_cm?: Maybe<Scalars['Float']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  tracking_reference?: Maybe<Scalars['String']>;
};

export type BobParcelInput = {
  custom_parcel_reference?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  submitted_height_cm?: InputMaybe<Scalars['Float']>;
  submitted_length_cm?: InputMaybe<Scalars['Float']>;
  submitted_weight_kg?: InputMaybe<Scalars['Float']>;
  submitted_width_cm?: InputMaybe<Scalars['Float']>;
};

export type BobProviderRateRequest = {
  __typename?: 'BobProviderRateRequest';
  failed_reason?: Maybe<Scalars['String']>;
  is_custom_account?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['Int']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_slug?: Maybe<Scalars['String']>;
  rate_response_id?: Maybe<Scalars['Int']>;
  responses?: Maybe<Array<Maybe<Scalars['Any']>>>;
  status?: Maybe<Scalars['String']>;
};

export type BobRate = {
  __typename?: 'BobRate';
  base_rate?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  liability_cover?: Maybe<BobLiabilityCover>;
  max_delivery_date?: Maybe<Scalars['String']>;
  min_delivery_date?: Maybe<Scalars['String']>;
  service_code?: Maybe<Scalars['String']>;
  service_name?: Maybe<Scalars['String']>;
  surcharges?: Maybe<Array<Maybe<Scalars['String']>>>;
  total_price?: Maybe<Scalars['Int']>;
};

export type BobRateItem = {
  description?: InputMaybe<Scalars['String']>;
  height_cm?: InputMaybe<Scalars['Float']>;
  length_cm?: InputMaybe<Scalars['Float']>;
  price?: InputMaybe<Scalars['Float']>;
  weight_kg?: InputMaybe<Scalars['Float']>;
  width_cm?: InputMaybe<Scalars['Float']>;
};

export type BobRateRequest = {
  __typename?: 'BobRateRequest';
  account?: Maybe<BobShipmentAccount>;
  account_id?: Maybe<Scalars['Int']>;
  collection_address?: Maybe<BobAddress>;
  declared_value?: Maybe<Scalars['Int']>;
  delivery_address?: Maybe<BobAddress>;
  id?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider_rate_requests?: Maybe<Array<Maybe<BobProviderRateRequest>>>;
  request_timeout?: Maybe<Scalars['String']>;
  surcharge?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['Int']>;
  total_submitted_weight_kg?: Maybe<Scalars['Float']>;
  webhook_url?: Maybe<Scalars['String']>;
};

export type BobShipment = {
  __typename?: 'BobShipment';
  account?: Maybe<BobShipmentAccount>;
  account_id?: Maybe<Scalars['Int']>;
  billing_transactions?: Maybe<Array<Maybe<BobBillingBillingTransaction>>>;
  charged_amount?: Maybe<Scalars['Float']>;
  charged_weight_kg?: Maybe<Scalars['Int']>;
  collected_date?: Maybe<Scalars['String']>;
  collection_address?: Maybe<BobAddress>;
  collection_address_id?: Maybe<Scalars['Int']>;
  collection_after?: Maybe<Scalars['String']>;
  collection_before?: Maybe<Scalars['String']>;
  collection_contact_email?: Maybe<Scalars['String']>;
  collection_contact_mobile_number?: Maybe<Scalars['String']>;
  collection_contact_name?: Maybe<Scalars['String']>;
  collection_min_date?: Maybe<Scalars['String']>;
  courier_confirmed_rate?: Maybe<Scalars['String']>;
  created_by?: Maybe<Scalars['Int']>;
  created_by_user?: Maybe<BobUser>;
  custom_account?: Maybe<Scalars['Boolean']>;
  custom_account_code?: Maybe<Scalars['String']>;
  custom_tracking_reference?: Maybe<Scalars['String']>;
  declared_value?: Maybe<Scalars['String']>;
  delivered_date?: Maybe<Scalars['String']>;
  delivery_address?: Maybe<BobAddress>;
  delivery_address_id?: Maybe<Scalars['Int']>;
  delivery_contact_email?: Maybe<Scalars['String']>;
  delivery_contact_mobile_number?: Maybe<Scalars['String']>;
  delivery_contact_name?: Maybe<Scalars['String']>;
  failed_reason?: Maybe<Scalars['String']>;
  has_provider_doc?: Maybe<Scalars['Boolean']>;
  health_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  last_response_code?: Maybe<Scalars['Int']>;
  manifest_id?: Maybe<Scalars['Int']>;
  meta?: Maybe<BobShipmentMeta>;
  modified_by?: Maybe<Scalars['Int']>;
  modified_by_user?: Maybe<Scalars['String']>;
  next_retry_time?: Maybe<Scalars['String']>;
  order_fulfillment?: Maybe<Scalars['String']>;
  order_fulfillment_id?: Maybe<Scalars['Int']>;
  parcel_count?: Maybe<Scalars['Int']>;
  parcels?: Maybe<Array<Maybe<BobParcel>>>;
  provider?: Maybe<BobShipmentProvider>;
  provider_id?: Maybe<Scalars['Int']>;
  provider_shipment_id?: Maybe<Scalars['String']>;
  provider_slug?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  rate_response_id?: Maybe<Scalars['Int']>;
  retry_count?: Maybe<Scalars['Int']>;
  service_level?: Maybe<BobShipmentServiceLevel>;
  service_level_code?: Maybe<Scalars['String']>;
  service_level_cut_off_time?: Maybe<Scalars['String']>;
  service_level_id?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  submission_status?: Maybe<Scalars['String']>;
  submitted_weight_kg?: Maybe<Scalars['Float']>;
  surcharge?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  timeout?: Maybe<Scalars['Int']>;
  tracking_expiry_date?: Maybe<Scalars['String']>;
  tracking_last_event_time?: Maybe<Scalars['String']>;
  tracking_reference?: Maybe<Scalars['String']>;
};

export type BobShipmentAccount = {
  __typename?: 'BobShipmentAccount';
  account_code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type BobShipmentMeta = {
  __typename?: 'BobShipmentMeta';
  collection_address_book_id?: Maybe<Scalars['Int']>;
  collection_reference?: Maybe<Scalars['String']>;
  estimated_collection_date?: Maybe<Scalars['String']>;
  estimated_delivery_date?: Maybe<Scalars['String']>;
  health_status_reason?: Maybe<Scalars['String']>;
  sl_collection_agent_id?: Maybe<Scalars['String']>;
  sl_collection_agent_zone?: Maybe<Scalars['String']>;
  sl_collection_branch?: Maybe<Scalars['String']>;
  sl_delivery_agent_id?: Maybe<Scalars['String']>;
  sl_delivery_agent_zone?: Maybe<Scalars['String']>;
  sl_delivery_branch?: Maybe<Scalars['String']>;
};

export type BobShipmentMovementEvent = {
  __typename?: 'BobShipmentMovementEvent';
  collected_time?: Maybe<Scalars['String']>;
  delivered_time?: Maybe<Scalars['String']>;
  in_transit_time?: Maybe<Scalars['String']>;
  out_for_delivery_time?: Maybe<Scalars['String']>;
};

export type BobShipmentProvider = {
  __typename?: 'BobShipmentProvider';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type BobShipmentServiceLevel = {
  __typename?: 'BobShipmentServiceLevel';
  code?: Maybe<Scalars['String']>;
  collection_cut_off_time?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  expected_delivery_time_hours?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type BobShipmentWaybill = {
  __typename?: 'BobShipmentWaybill';
  download_url?: Maybe<Scalars['String']>;
  file_history_id?: Maybe<Scalars['String']>;
  pdf_queued?: Maybe<Scalars['Boolean']>;
  shipments?: Maybe<Array<Maybe<BobShipment>>>;
  waybills_ready?: Maybe<Scalars['Boolean']>;
};

export type BobTrackingEvent = {
  __typename?: 'BobTrackingEvent';
  checkpoints?: Maybe<Array<Maybe<BobCheckpoint>>>;
  courier_logo?: Maybe<Scalars['String']>;
  courier_name?: Maybe<Scalars['String']>;
  courier_phone?: Maybe<Scalars['String']>;
  courier_slug?: Maybe<Scalars['String']>;
  custom_order_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  last_checkpoint_time?: Maybe<Scalars['String']>;
  merchant_logo?: Maybe<Scalars['String']>;
  merchant_name?: Maybe<Scalars['String']>;
  order_number?: Maybe<Scalars['String']>;
  service_level?: Maybe<Scalars['String']>;
  shipment_movement_events?: Maybe<BobShipmentMovementEvent>;
  shipment_time_created?: Maybe<Scalars['String']>;
  shipment_tracking_reference?: Maybe<Scalars['String']>;
  show_branding?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  status_friendly?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BobUser = {
  __typename?: 'BobUser';
  accepted_terms?: Maybe<Scalars['String']>;
  account_id?: Maybe<Scalars['Int']>;
  api_key?: Maybe<Scalars['String']>;
  created_by_user?: Maybe<BobUser>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  role_id?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  time_created?: Maybe<Scalars['String']>;
  time_modified?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BooleanOperator = {
  eq?: InputMaybe<Scalars['Boolean']>;
};

export type BreakDownItems = {
  __typename?: 'BreakDownItems';
  average: Scalars['Int'];
  excellent: Scalars['Int'];
  good: Scalars['Int'];
  poor: Scalars['Int'];
  veryGood: Scalars['Int'];
};

export type Campaign = {
  __typename?: 'Campaign';
  campaign_count?: Maybe<Scalars['Int']>;
  campaign_id: Scalars['String'];
  campaign_image_url?: Maybe<Scalars['String']>;
  campaign_text: Scalars['String'];
  campaign_type: Scalars['String'];
  category?: Maybe<Scalars['String']>;
  code_redemption_is_unlimited: Scalars['Boolean'];
  created_at?: Maybe<Scalars['Date']>;
  customer_count?: Maybe<Scalars['Int']>;
  days?: Maybe<Array<Maybe<Scalars['String']>>>;
  draft: Scalars['Boolean'];
  end_time: Scalars['Date'];
  expiration_date: Scalars['Date'];
  has_advance_time?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  leader_board_id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  per_customer_per_day?: Maybe<Scalars['Int']>;
  per_customer_per_month?: Maybe<Scalars['Int']>;
  per_customer_total_limit?: Maybe<Scalars['Int']>;
  start_date: Scalars['Date'];
  start_time: Scalars['Date'];
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type CampaignFilter = {
  campaign_count?: InputMaybe<NumberOperator>;
  campaign_id?: InputMaybe<StringOperator>;
  campaign_image_url?: InputMaybe<StringOperator>;
  campaign_text?: InputMaybe<StringOperator>;
  campaign_type?: InputMaybe<StringOperator>;
  category?: InputMaybe<StringOperator>;
  code_redemption_is_unlimited?: InputMaybe<BooleanOperator>;
  created_at?: InputMaybe<DateOperator>;
  customer_count?: InputMaybe<NumberOperator>;
  days?: InputMaybe<StringOperator>;
  draft?: InputMaybe<BooleanOperator>;
  end_time?: InputMaybe<DateOperator>;
  expiration_date?: InputMaybe<DateOperator>;
  has_advance_time?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  leader_board_id?: InputMaybe<StringOperator>;
  name?: InputMaybe<StringOperator>;
  per_customer_per_day?: InputMaybe<NumberOperator>;
  per_customer_per_month?: InputMaybe<NumberOperator>;
  per_customer_total_limit?: InputMaybe<NumberOperator>;
  start_date?: InputMaybe<DateOperator>;
  start_time?: InputMaybe<DateOperator>;
  status?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type Cart = {
  products: Array<CartProduct>;
};

export type CartFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  payment_id?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tracking_code?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type CartItem = {
  __typename?: 'CartItem';
  cart_qty?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  in_stock?: Maybe<Scalars['Boolean']>;
  product?: Maybe<Product>;
  product_id: Scalars['ID'];
  profit?: Maybe<Scalars['Float']>;
  profit_type?: Maybe<ProfitType>;
};

export type CartProduct = {
  productPrice: Scalars['String'];
  productQty: Scalars['Int'];
  productSKU: Scalars['String'];
  profitAdded: Scalars['String'];
  uuid: Scalars['String'];
};

export type CashRewardHistory = {
  __typename?: 'CashRewardHistory';
  amount: Scalars['Float'];
  created_at: Scalars['Date'];
  id: Scalars['ID'];
  previous_balance: Scalars['Float'];
  reference?: Maybe<Scalars['String']>;
  transaction_type: Scalars['String'];
};

export type CashRewardsFilter = {
  amount?: InputMaybe<MoneyOperator>;
  id?: InputMaybe<IdOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
};

export type Catalog = {
  __typename?: 'Catalog';
  banner: Scalars['String'];
  config?: Maybe<CollectionConfig>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFreeDelivery?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type CatalogCollection = {
  __typename?: 'CatalogCollection';
  catalog?: Maybe<Catalog>;
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']>;
};

export type CatalogConfigInput = {
  collection_id: Scalars['ID'];
  free_delivery_locations?: InputMaybe<Array<Scalars['ID']>>;
  id?: InputMaybe<Scalars['ID']>;
  is_free_delivery: Scalars['Boolean'];
  reduction_type?: InputMaybe<ReductionType>;
  reduction_value?: InputMaybe<Scalars['Float']>;
};

export type CatalogData = CatalogCollection | CategoryCollection | ProductCollection;

export type CatalogFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type CatalogInput = {
  banner: Scalars['String'];
  config?: InputMaybe<CatalogConfigInput>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type CatalogMedia = {
  __typename?: 'CatalogMedia';
  id?: Maybe<Scalars['ID']>;
  media?: Maybe<Scalars['String']>;
};

export enum CatalogType {
  Catalog = 'CATALOG',
  Category = 'CATEGORY',
  Product = 'PRODUCT'
}

export type CategoryCollection = {
  __typename?: 'CategoryCollection';
  category?: Maybe<ProductCategory>;
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']>;
};

export enum ChannelType {
  Sms = 'sms',
  Whatsapp = 'whatsapp'
}

export type ClaimCouponInput = {
  code: Scalars['String'];
  user_id: Scalars['ID'];
};

export type ClaimDiscountRequestDto = {
  discount_code: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};

export type CollectionConfig = {
  __typename?: 'CollectionConfig';
  /** this array carries location ids if the collection is restricted to certain locations */
  free_delivery_locations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  id: Scalars['ID'];
  is_free_delivery?: Maybe<Scalars['Boolean']>;
  /** The reduction type can be either percentage or amount */
  reduction_type?: Maybe<ReductionType>;
  /** The reduction value can be either a percentage or an amount depending on the reduction type */
  reduction_value?: Maybe<Scalars['Float']>;
};

export enum Condition {
  And = 'and',
  Or = 'or'
}

export enum ConditionalOperator {
  Any = 'Any',
  ArrayContainedBy = 'ArrayContainedBy',
  ArrayContains = 'ArrayContains',
  ArrayNotContainedBy = 'ArrayNotContainedBy',
  ArrayNotContains = 'ArrayNotContains',
  ArrayNotOverlap = 'ArrayNotOverlap',
  ArrayOverlap = 'ArrayOverlap',
  Between = 'Between',
  Equal = 'Equal',
  ILike = 'ILike',
  In = 'In',
  IsNotNull = 'IsNotNull',
  IsNull = 'IsNull',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  Like = 'Like',
  MoreThan = 'MoreThan',
  MoreThanOrEqual = 'MoreThanOrEqual',
  Not = 'Not',
  NotAny = 'NotAny',
  NotBetween = 'NotBetween',
  NotEqual = 'NotEqual',
  NotILike = 'NotILike',
  NotIn = 'NotIn',
  NotLessThan = 'NotLessThan',
  NotLessThanOrEqual = 'NotLessThanOrEqual',
  NotLike = 'NotLike',
  NotMoreThan = 'NotMoreThan',
  NotMoreThanOrEqual = 'NotMoreThanOrEqual',
  Raw = 'Raw'
}

export enum CountryCode {
  Gh = 'GH',
  Ng = 'NG',
  Za = 'ZA'
}

export type Coupon = {
  __typename?: 'Coupon';
  cash_rewards?: Maybe<Scalars['Float']>;
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expired: Scalars['Boolean'];
  expires_on?: Maybe<Scalars['DateTime']>;
  free_deliveries?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number_of_days?: Maybe<Scalars['Int']>;
  redemption?: Maybe<CouponRedemption>;
  start_date?: Maybe<Scalars['Date']>;
  type: CouponType;
  updatedAt: Scalars['DateTime'];
};

export type CouponFilter = {
  cash_rewards?: InputMaybe<NumberOperator>;
  code?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  expires_on?: InputMaybe<DateOperator>;
  free_deliveries?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  number_of_days?: InputMaybe<NumberOperator>;
  type?: InputMaybe<CouponType>;
  user_id?: InputMaybe<IdOperator>;
};

export type CouponInput = {
  cash_rewards?: InputMaybe<Scalars['Float']>;
  code: Scalars['String'];
  expires_on?: InputMaybe<Scalars['DateTime']>;
  free_deliveries?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  neverEnds: Scalars['Boolean'];
  number_of_days?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['Date'];
  type: CouponType;
};

export type CouponRedemption = {
  __typename?: 'CouponRedemption';
  cash_rewards_exhausted?: Maybe<Scalars['Float']>;
  coupon?: Maybe<Coupon>;
  free_delivery_exhausted?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
};

export type CouponRedemptionFilter = {
  user_id?: InputMaybe<IdOperator>;
};

export enum CouponType {
  CashRewards = 'cash_rewards',
  Combo = 'combo',
  FreeDelivery = 'free_delivery'
}

export type CreateCampaignInput = {
  campaign_count?: InputMaybe<Scalars['Int']>;
  campaign_id: Scalars['String'];
  campaign_image_url?: InputMaybe<Scalars['String']>;
  campaign_text: Scalars['String'];
  campaign_type: Scalars['String'];
  category?: InputMaybe<Scalars['String']>;
  code_redemption_is_unlimited: Scalars['Boolean'];
  customer_count?: InputMaybe<Scalars['Int']>;
  days?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draft: Scalars['Boolean'];
  end_time: Scalars['Date'];
  expiration_date: Scalars['Date'];
  has_advance_time?: InputMaybe<Scalars['Boolean']>;
  leader_board_id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  per_customer_per_day?: InputMaybe<Scalars['Int']>;
  per_customer_per_month?: InputMaybe<Scalars['Int']>;
  per_customer_total_limit?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['Date'];
  start_time: Scalars['Date'];
  status?: InputMaybe<Scalars['String']>;
};

export type CreateCustomerSubscriptionRequestDto = {
  billing_cycle: BillingCycle;
  subscription_id: Scalars['ID'];
  user_email: Scalars['String'];
  user_id: Scalars['ID'];
};

export type CreateDiscountRequestDto = {
  amount?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<UserType>;
  description: Scalars['String'];
  expiry_date: Scalars['String'];
  fixed_amount_allocation?: InputMaybe<FixedAmountAllocation>;
  is_draft: Scalars['Boolean'];
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locations_tagname?: InputMaybe<Scalars['String']>;
  percentage?: InputMaybe<Scalars['Float']>;
  product_condition?: InputMaybe<ProductCondition>;
  products?: InputMaybe<Array<Scalars['String']>>;
  redemptions_limit?: InputMaybe<Scalars['Int']>;
  start_date: Scalars['String'];
  type: DiscountType;
  user_id?: InputMaybe<Scalars['ID']>;
  valid_country: Scalars['String'];
};

export type CreatePluginRequestDto = {
  banner_image?: InputMaybe<Scalars['String']>;
  category: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  developer?: InputMaybe<Scalars['String']>;
  endpoint: Scalars['String'];
  logo: Scalars['String'];
  name: Scalars['String'];
};

export type CreateSharedProductRequestDto = {
  product_cost_price: Scalars['Float'];
  product_id: Scalars['ID'];
  profit_added_by_reseller: Scalars['Float'];
  shared_by: Scalars['ID'];
  total_selling_price: Scalars['Float'];
};

export type CreateSharedProductResponseDto = {
  __typename?: 'CreateSharedProductResponseDto';
  sharedProduct?: Maybe<SharedProduct>;
};

export type CreateShopRequestDto = {
  /** Profile image */
  avatar?: InputMaybe<Scalars['String']>;
  /** The public-facing contact email address for the shop. Customers will use this email to communicate with the shop owner. */
  contactEmail: Scalars['String'];
  /** Country code of where shop is located */
  country: CountryCode;
  /** Backdrop banner image */
  coverImage?: InputMaybe<Scalars['String']>;
  /** Currency code the shop will receive payouts in. */
  currency: CurrencyCode;
  deliveryAgent?: InputMaybe<DeliveryAgent>;
  deliveryOption?: InputMaybe<DeliveryOption>;
  description?: InputMaybe<Scalars['String']>;
  /** The shop owner's email address. Tendo will use this email address to communicate with the shop owner. */
  email: Scalars['String'];
  location?: InputMaybe<ShopLocationRequestDto>;
  /** Full name of shop */
  name: Scalars['String'];
  ownerId: Scalars['ID'];
  paymentOptions: Array<InputMaybe<PaymentOption>>;
  phone: Scalars['String'];
  /** Tags used to identify the shop */
  shopTags: Array<InputMaybe<Scalars['String']>>;
  shortUrl?: InputMaybe<Scalars['String']>;
  /** The host name only. Should NOT contain .mysoko.shop. */
  sokoWorldHostname: Scalars['String'];
  supplierId?: InputMaybe<Scalars['ID']>;
};

export type CreateShopResponseDto = {
  __typename?: 'CreateShopResponseDto';
  shopId?: Maybe<Scalars['ID']>;
};

export type CreateSubscriptionRequestDto = {
  annual_plan_cost: Scalars['Float'];
  monthly_plan_cost: Scalars['Float'];
  name: SubscriptionType;
};

export type CreateTopDealBannerInput = {
  url: Scalars['String'];
};

export enum CurrencyCode {
  Ghs = 'GHS',
  Ngn = 'NGN',
  Zar = 'ZAR'
}

export type Customer = {
  __typename?: 'Customer';
  address?: Maybe<Array<Maybe<CustomerAddress>>>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  reseller?: Maybe<User>;
};

export type CustomerAddress = {
  __typename?: 'CustomerAddress';
  area: Scalars['String'];
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  landmark?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['String']>;
  lng?: Maybe<Scalars['String']>;
};

export type CustomerAuthPayload = {
  __typename?: 'CustomerAuthPayload';
  token: Scalars['String'];
  user?: Maybe<Customer>;
};

export type CustomerFilter = {
  address?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type CustomerInput = {
  address?: InputMaybe<AddressInput>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  phone: Scalars['String'];
};

export type CustomerLoginInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type CustomerSubscription = {
  __typename?: 'CustomerSubscription';
  billing_cycle?: Maybe<BillingCycle>;
  created_at?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  next_billing_date?: Maybe<Scalars['Date']>;
  payment_history?: Maybe<Array<Maybe<SubscriptionPaymentHistory>>>;
  status?: Maybe<SubscriptionStatus>;
  subscription?: Maybe<Subscription>;
  subscription_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_email?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type CustomerSubscriptionFilter = {
  billing_cycle?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  next_billing_date?: InputMaybe<DateOperator>;
  status?: InputMaybe<StringOperator>;
  subscription_id?: InputMaybe<IdOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_email?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type CustomerSubscriptionInput = {
  billing_cycle: BillingCycle;
  created_at?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  next_billing_date: Scalars['Date'];
  status: SubscriptionStatus;
  subscription?: InputMaybe<SubscriptionInput>;
  subscription_id: Scalars['ID'];
  updated_at?: InputMaybe<Scalars['Date']>;
  user_email: Scalars['String'];
  user_id: Scalars['ID'];
};

export type DateOperator = {
  after?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['DateTime']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']>;
};

export type DateRange = {
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
};

export type DeliveredOrders = {
  __typename?: 'DeliveredOrders';
  cart_id?: Maybe<Scalars['ID']>;
  cart_number?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  date_to_credit?: Maybe<Scalars['Date']>;
  days_profit_has_delayed?: Maybe<Scalars['Int']>;
  deposit_refunded?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  order_id?: Maybe<Scalars['ID']>;
  order_number?: Maybe<Scalars['String']>;
  profit_added?: Maybe<Scalars['Float']>;
  profit_credit_status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type DeliveredOrdersFilter = {
  cart_id?: InputMaybe<IdOperator>;
  cart_number?: InputMaybe<StringOperator>;
  date_to_credit?: InputMaybe<DateOperator>;
  days_profit_has_delayed?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  order_id?: InputMaybe<IdOperator>;
  order_number?: InputMaybe<StringOperator>;
  profit_credit_status?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type Delivery = {
  __typename?: 'Delivery';
  country?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isPayOnline: Scalars['Boolean'];
  location: Scalars['String'];
  price: Scalars['Float'];
  remarks?: Maybe<Scalars['String']>;
};

export enum DeliveryAgent {
  Shop = 'SHOP',
  Tendo = 'TENDO'
}

export type DeliveryFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<StringOperator>;
  isPayOnline?: InputMaybe<BooleanOperator>;
  location?: InputMaybe<StringOperator>;
  price?: InputMaybe<NumberOperator>;
  remarks?: InputMaybe<StringOperator>;
};

export type DeliveryInput = {
  id?: InputMaybe<Scalars['ID']>;
  isPayOnline: Scalars['Boolean'];
  location: Scalars['String'];
  price: Scalars['Float'];
  remarks?: InputMaybe<Scalars['String']>;
};

export enum DeliveryOption {
  Manual = 'Manual',
  Swoove = 'Swoove'
}

export type DeliveryPricesInput = {
  address: Scalars['String'];
  destination?: InputMaybe<Latlng>;
  source?: InputMaybe<Latlng>;
};

export type DeliveryZone = {
  __typename?: 'DeliveryZone';
  base_price: Scalars['Float'];
  coordinates: Array<LatLng>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type DeliveryZonesFilter = {
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
};

export type DeliveryZonesInput = {
  base_price: Scalars['Float'];
  coordinates: Array<InputMaybe<Scalars['Any']>>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
};

export type Details = {
  dob?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type Discount = {
  __typename?: 'Discount';
  amount?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  created_by?: Maybe<UserType>;
  description: Scalars['String'];
  expiry_date: Scalars['String'];
  fixed_amount_allocation?: Maybe<FixedAmountAllocation>;
  has_expired?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  is_draft: Scalars['Boolean'];
  locations?: Maybe<Array<Maybe<Scalars['String']>>>;
  locations_tagname?: Maybe<Scalars['String']>;
  number_of_times_used?: Maybe<Scalars['Int']>;
  percentage?: Maybe<Scalars['Float']>;
  product_condition?: Maybe<ProductCondition>;
  products?: Maybe<Array<Maybe<Scalars['String']>>>;
  redemptions_limit?: Maybe<Scalars['Int']>;
  start_date: Scalars['String'];
  type: DiscountType;
  updated_at?: Maybe<Scalars['Date']>;
  user_id?: Maybe<Scalars['ID']>;
  valid_country: Scalars['String'];
};

export type DiscountFilter = {
  amount?: InputMaybe<NumberOperator>;
  code?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  created_by?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  expiry_date?: InputMaybe<DateOperator>;
  fixed_amount_allocation?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  is_draft?: InputMaybe<BooleanOperator>;
  locations?: InputMaybe<StringOperator>;
  number_of_times_used?: InputMaybe<NumberOperator>;
  percentage?: InputMaybe<NumberOperator>;
  redemptions_limit?: InputMaybe<NumberOperator>;
  start_date?: InputMaybe<DateOperator>;
  type?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_id?: InputMaybe<IdOperator>;
  valid_country?: InputMaybe<StringOperator>;
};

export type DiscountProductCondition = {
  __typename?: 'DiscountProductCondition';
  condition: ProductCondition;
  created_at?: Maybe<Scalars['Date']>;
  discount_id: Scalars['ID'];
  id: Scalars['ID'];
  product?: Maybe<Product>;
  product_sku: Scalars['String'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type DiscountProductConditionFilter = {
  condition?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  discount_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  product_sku?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type DiscountProductConditionRequestDto = {
  condition: ProductCondition;
  product_sku: Scalars['String'];
};

export enum DiscountType {
  FixedAmount = 'FIXED_AMOUNT',
  FreeDelivery = 'FREE_DELIVERY',
  Percentage = 'PERCENTAGE'
}

export type DiscountUseFilter = {
  country_code?: InputMaybe<StringOperator>;
  discount_code?: InputMaybe<StringOperator>;
  discount_id?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type DoesShopExistResponseDto = {
  __typename?: 'DoesShopExistResponseDto';
  shopExists?: Maybe<Scalars['Boolean']>;
};

export enum EftProviders {
  Ozow = 'ozow'
}

export type EstimateTypeDetails = {
  __typename?: 'EstimateTypeDetails';
  icon?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FeaturedCategories = {
  __typename?: 'FeaturedCategories';
  banners?: Maybe<Array<Maybe<Scalars['String']>>>;
  category?: Maybe<ProductCategory>;
  color?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type FeaturedCategoriesFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type FeaturedCategoryInput = {
  category_id: Scalars['ID'];
  id?: InputMaybe<Scalars['ID']>;
};

export type FetchShopifyShopInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopifyShopFilter>;
};

export type FetchShopifyShopsInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ShopifyShopFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type FetchUserInput = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};

export type FilterDto = {
  filters: Array<FilterMemberDto>;
  logicalOperator: LogicalOperator;
};

export type FilterMemberDto = {
  fields: Array<Scalars['String']>;
  operators: Array<ConditionalOperator>;
  values: Array<Scalars['String']>;
};

export type FindOptionsDto = {
  order?: InputMaybe<OrderByDto>;
  where?: InputMaybe<FilterDto>;
};

export enum FixedAmountAllocation {
  ProductSpecific = 'PRODUCT_SPECIFIC',
  TotalAmount = 'TOTAL_AMOUNT'
}

export type FlutterwaveCard = {
  __typename?: 'FlutterwaveCard';
  country: Scalars['String'];
  expiry: Scalars['String'];
  first_6digits: Scalars['String'];
  issuer: Scalars['String'];
  last_4digits: Scalars['String'];
  type: Scalars['String'];
};

export type FlutterwaveCheckUserBackgroundRequestDto = {
  /** This is the value being checked. */
  entity: Scalars['String'];
  /** This is the type of entity passed to the API. Expected types are PHONE_NUMBER, BVN and EMAIL_ADDRESS */
  type: Scalars['String'];
};

export type FlutterwaveCheckUserBackgroundResponseDto = {
  __typename?: 'FlutterwaveCheckUserBackgroundResponseDto';
  data: Scalars['Boolean'];
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FlutterwaveCustomer = {
  __typename?: 'FlutterwaveCustomer';
  created_at: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
};

export type FlutterwaveListBankBranchesData = {
  __typename?: 'FlutterwaveListBankBranchesData';
  bank_id: Scalars['Int'];
  bic: Scalars['String'];
  branch_code: Scalars['String'];
  branch_name: Scalars['String'];
  id: Scalars['ID'];
  swift_code: Scalars['String'];
};

export type FlutterwaveListBankBranchesRequestDto = {
  /** This is the Bank's unique ID, it is returned in the call to fetch banks as data.id. */
  id: Scalars['ID'];
};

export type FlutterwaveListBankBranchesResponseDto = {
  __typename?: 'FlutterwaveListBankBranchesResponseDto';
  data?: Maybe<Array<Maybe<FlutterwaveListBankBranchesData>>>;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FlutterwaveListBanksData = {
  __typename?: 'FlutterwaveListBanksData';
  code: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FlutterwaveListBanksRequestDto = {
  /** This is the country code of the Banks being queried. Expected values include: NG, GH, KE, UG, ZA or TZ. */
  country: Scalars['String'];
};

export type FlutterwaveListBanksResponseDto = {
  __typename?: 'FlutterwaveListBanksResponseDto';
  data?: Maybe<Array<Maybe<FlutterwaveListBanksData>>>;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FlutterwaveMobileMoneyInitialiseChargeMeta = {
  /** Cart object, JSON */
  cart: Scalars['JSON'];
  /** This could be the extra information you want to pass */
  flightID?: InputMaybe<Scalars['String']>;
  /** This could be any message you'd like to associate with this call */
  sideNote?: InputMaybe<Scalars['String']>;
};

export type FlutterwaveMobileMoneyInitialiseChargeRequestDto = {
  /** This is the amount to be charged. */
  amount: Scalars['Int'];
  /** IP - Internet Protocol. This represents the current IP address of the customer carrying out the transaction. */
  client_ip?: InputMaybe<Scalars['String']>;
  /** This is the specified currency to charge in. e.g GHS */
  currency: Scalars['String'];
  /** This is the fingerprint for the device being used. It can be generated using a library on whatever platform is being used. */
  device_fingerprint?: InputMaybe<Scalars['String']>;
  /** This is the email address of the customer */
  email: Scalars['String'];
  /** This is the name of the customer making the payment. */
  fullname?: InputMaybe<Scalars['String']>;
  /** This is used to include additional payment information. */
  meta?: InputMaybe<FlutterwaveMobileMoneyInitialiseChargeMeta>;
  /** This is the customer's mobile money network provider (possible values: mtn, vod,  'VOD', 'TGO', 'MTN',tgo) */
  network: Scalars['String'];
  /** This is the phone number linked to the customer's Bank account or mobile money account */
  phone_number: Scalars['String'];
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** This is a url you provide, we redirect to it after the customer completes payment and append the response to it as query parameters. */
  redirect_url?: InputMaybe<Scalars['String']>;
  /** This is a unique reference peculiar to the transaction being carried out. */
  tx_ref: Scalars['String'];
};

export type FlutterwaveMobileMoneyInitialiseChargeResponseDto = {
  __typename?: 'FlutterwaveMobileMoneyInitialiseChargeResponseDto';
  message: Scalars['String'];
  meta: FlutterwaveMobileMoneyInitialiseChargeResponseMeta;
  status: Scalars['String'];
};

export type FlutterwaveMobileMoneyInitialiseChargeResponseMeta = {
  __typename?: 'FlutterwaveMobileMoneyInitialiseChargeResponseMeta';
  authorization: FlutterwaveMobileMoneyInitialiseChargeResponseMetaAuthorisation;
};

export type FlutterwaveMobileMoneyInitialiseChargeResponseMetaAuthorisation = {
  __typename?: 'FlutterwaveMobileMoneyInitialiseChargeResponseMetaAuthorisation';
  mode: Scalars['String'];
  redirect: Scalars['String'];
};

export type FlutterwaveResolveAccountNumberData = {
  __typename?: 'FlutterwaveResolveAccountNumberData';
  account_name: Scalars['String'];
  account_number: Scalars['String'];
};

export type FlutterwaveResolveAccountNumberRequestDto = {
  /** This is the code for the Bank. You can get this code using the flutterwave/banks endpoint. */
  account_bank: Scalars['String'];
  /** This is the account number (could also be a Merchant ID or MPesa mobile number) to be resolved. If you are resolving a Flutterwave account or MPesa mobile number, You should pass the merchant ID or mobile number. */
  account_number: Scalars['String'];
  /** This is the country associated with the payment type. Expected values include NG, KE and US */
  country?: InputMaybe<Scalars['String']>;
  /** This is the payment type. This is only needed for resolving Mpesa mobile numbers. */
  type?: InputMaybe<Scalars['String']>;
};

export type FlutterwaveResolveAccountNumberResponseDto = {
  __typename?: 'FlutterwaveResolveAccountNumberResponseDto';
  data: FlutterwaveResolveAccountNumberData;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FlutterwaveResolveBvnDetailsData = {
  __typename?: 'FlutterwaveResolveBVNDetailsData';
  address?: Maybe<Scalars['String']>;
  bvn: Scalars['String'];
  date_of_birth: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  enrollment_bank: Scalars['String'];
  enrollment_branch: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  image_base_64?: Maybe<Scalars['String']>;
  last_name: Scalars['String'];
  lga_of_residence?: Maybe<Scalars['String']>;
  marital_status?: Maybe<Scalars['String']>;
  middle_name?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  phone_number: Scalars['String'];
  registration_date: Scalars['String'];
  state_of_residence?: Maybe<Scalars['String']>;
  watch_listed?: Maybe<Scalars['String']>;
};

export type FlutterwaveResolveBvnDetailsRequestDto = {
  /** This is a valid BVN you want to resolve. */
  bvn: Scalars['String'];
};

export type FlutterwaveResolveBvnDetailsResponseDto = {
  __typename?: 'FlutterwaveResolveBVNDetailsResponseDto';
  data: FlutterwaveResolveBvnDetailsData;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FlutterwaveResolveCardBinData = {
  __typename?: 'FlutterwaveResolveCardBINData';
  card_type: Scalars['String'];
  issuer_info: Scalars['String'];
  issuing_country: Scalars['String'];
};

export type FlutterwaveResolveCardBinRequestDto = {
  /** The first 6 six digits on a debit/credit card */
  bin: Scalars['String'];
};

export type FlutterwaveResolveCardBinResponseDto = {
  __typename?: 'FlutterwaveResolveCardBINResponseDto';
  data: FlutterwaveResolveCardBinData;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type FlutterwaveVerifyTransactionResponseData = {
  __typename?: 'FlutterwaveVerifyTransactionResponseData';
  account_id: Scalars['ID'];
  amount: Scalars['Int'];
  amount_settled: Scalars['Int'];
  app_fee: Scalars['Int'];
  auth_model: Scalars['String'];
  card: FlutterwaveCard;
  charged_amount: Scalars['Int'];
  created_at: Scalars['String'];
  currency: Scalars['String'];
  customer: FlutterwaveCustomer;
  device_fingerprint: Scalars['String'];
  flw_ref: Scalars['String'];
  id: Scalars['ID'];
  ip: Scalars['ID'];
  merchant_fee: Scalars['Int'];
  narration: Scalars['String'];
  payment_type: Scalars['String'];
  processor_response: Scalars['String'];
  status: Scalars['String'];
  tx_ref: Scalars['String'];
};

export type FlutterwaveVerifyTransactionResponseDto = {
  __typename?: 'FlutterwaveVerifyTransactionResponseDto';
  data?: Maybe<FlutterwaveVerifyTransactionResponseData>;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type ForexRate = {
  __typename?: 'ForexRate';
  createdAt?: Maybe<Scalars['Date']>;
  ghs?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  ngn?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Date']>;
  zar?: Maybe<Scalars['Float']>;
};

export type ForexRateFilter = {
  createdAt?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
};

export type ForexRateInput = {
  ghs?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  ngn?: InputMaybe<Scalars['Float']>;
  zar?: InputMaybe<Scalars['Float']>;
};

export type GetCustomerInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type GetPaymentByIdRequestDto = {
  id: Scalars['ID'];
};

export type GetPaymentByReferenceRequestDto = {
  reference: Scalars['String'];
};

export type GetPaymentResponseDto = {
  __typename?: 'GetPaymentResponseDto';
  payment?: Maybe<Payment>;
};

export type GetPaymentsResponseDto = {
  __typename?: 'GetPaymentsResponseDto';
  payments: Array<Maybe<Payment>>;
};

export type GetRehookLeaderboardInput = {
  /** Activity ID */
  activity_id?: InputMaybe<Scalars['String']>;
  /** Campaign ID */
  campaign_id: Scalars['String'];
  /** Page number (default: 1) */
  page?: InputMaybe<Scalars['Int']>;
  /** Rehook ID / Source ID of the customer */
  source_id?: InputMaybe<Scalars['String']>;
};

export type GetSalesRequestDto = {
  filter?: InputMaybe<SalesFilter>;
  pagination: Pagination;
};

export type GetSharedProductRequestDto = {
  shared_product_id: Scalars['ID'];
};

export type GetShopResponseDto = {
  __typename?: 'GetShopResponseDto';
  shop?: Maybe<Shop>;
};

export type GetShopsRequestDto = {
  filter?: InputMaybe<ShopFilter>;
  pagination: Pagination;
};

export type GetSupplierPickupLocationInput = {
  supplier_id: Scalars['String'];
};

export type GetTinggCheckoutAuthenticationRequestDto = {
  client_id: Scalars['String'];
  client_secret: Scalars['String'];
  grant_type: Scalars['String'];
};

export type GetTinggCheckoutAuthenticationResponseDto = {
  __typename?: 'GetTinggCheckoutAuthenticationResponseDto';
  access_token: Scalars['String'];
  expires_in: Scalars['Int'];
  refresh_token: Scalars['String'];
  token_type: Scalars['String'];
};

export type IdOperator = {
  eq?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<Scalars['ID']>>;
  notIn?: InputMaybe<Array<Scalars['ID']>>;
};

export type InitiateTinggCheckoutRequestDto = {
  /** Customer email the customer wished to pay for. */
  customer_email: Scalars['String'];
  /** Customer first name */
  customer_first_name: Scalars['String'];
  /** Customer last name */
  customer_last_name: Scalars['String'];
  /** Where we will redirect the customer to when the payment time passed above expires. */
  fail_redirect_url?: InputMaybe<Scalars['String']>;
  /** Merchant's invoice number. */
  invoice_number?: InputMaybe<Scalars['String']>;
  /** Mobile number for the customer. */
  msisdn: Scalars['String'];
  /** Amount you wish to start collecting for. */
  request_amount: Scalars['Float'];
  /** Shows the description of the item being purchased. */
  request_description?: InputMaybe<Scalars['String']>;
};

export type Instructions = {
  __typename?: 'Instructions';
  en?: Maybe<TinggCheckoutResponseLang>;
  sw?: Maybe<TinggCheckoutResponseLang>;
};

export type Latlng = {
  lat?: InputMaybe<Scalars['String']>;
  lng?: InputMaybe<Scalars['String']>;
};

export type LatLng = {
  __typename?: 'LatLng';
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type LatLngInput = {
  lat: Scalars['Float'];
  lng: Scalars['Float'];
};

export type Leaderboard = {
  __typename?: 'Leaderboard';
  points?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  reseller?: Maybe<User>;
  reward?: Maybe<Scalars['String']>;
  source_id: Scalars['ID'];
};

export type LoadProductToShopify = {
  combination_string?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  price?: InputMaybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  product_origin: Scalars['String'];
  qty: Scalars['Int'];
  sku: Scalars['String'];
  supplier_generic_name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  uuid: Scalars['String'];
};

export type LoadProductToShopifyInput = {
  integration_id?: InputMaybe<Scalars['ID']>;
  products?: InputMaybe<Array<LoadProductToShopify>>;
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type MakeTinggPaymentRequestDto = {
  customer_email: Scalars['String'];
  customer_first_name: Scalars['String'];
  customer_last_name: Scalars['String'];
  phone: Scalars['String'];
  reasonForPayment: ReasonForPayment;
  request_amount: Scalars['Float'];
};

export type MoneyOperator = {
  between?: InputMaybe<MoneyRange>;
  eq?: InputMaybe<Scalars['Money']>;
  gt?: InputMaybe<Scalars['Money']>;
  gte?: InputMaybe<Scalars['Money']>;
  lt?: InputMaybe<Scalars['Money']>;
  lte?: InputMaybe<Scalars['Money']>;
};

export type MoneyRange = {
  end: Scalars['Money'];
  start: Scalars['Money'];
};

export type Mutation = {
  __typename?: 'Mutation';
  accountRegister: Auth;
  activateShop: Scalars['Boolean'];
  addBusinessDocuments?: Maybe<Scalars['Boolean']>;
  addComment?: Maybe<Scalars['Boolean']>;
  addCommentsToProduct?: Maybe<Scalars['Boolean']>;
  addItemToCart?: Maybe<Scalars['Boolean']>;
  addPluginToUser?: Maybe<UserPlugin>;
  addProductConditionsToDiscount?: Maybe<Scalars['Boolean']>;
  addProductToShop?: Maybe<Scalars['Boolean']>;
  addProductToShopCollection?: Maybe<Scalars['Boolean']>;
  addProductsToCollection?: Maybe<Scalars['Boolean']>;
  addProductsToShopCollection?: Maybe<Scalars['Boolean']>;
  addProductstoDiscount?: Maybe<Scalars['Boolean']>;
  addSupplierAgreementTerms?: Maybe<Scalars['Boolean']>;
  addSupplierBusinessDetails?: Maybe<Scalars['Boolean']>;
  addSupplierDeviceToken?: Maybe<Scalars['Boolean']>;
  addSupplierLocation?: Maybe<SupplierLocation>;
  addSupplierPaymentDetails?: Maybe<Scalars['Boolean']>;
  addUserPaymentDetails?: Maybe<Scalars['Boolean']>;
  adjustWalletBalance: Scalars['Boolean'];
  allowResellingOfProduct?: Maybe<Scalars['Boolean']>;
  authenticateWithToken: SupplierAuthPayload;
  bobCancelShipment?: Maybe<BobShipment>;
  /** create new orders for accounts */
  bobCreateOrder?: Maybe<BobOrder>;
  bobCreateShipment?: Maybe<BobShipment>;
  bulkCreateProducts?: Maybe<Scalars['Boolean']>;
  cancelCustomerSubscription?: Maybe<CustomerSubscription>;
  changePassword?: Maybe<Scalars['Boolean']>;
  changeResellerSupplierShop?: Maybe<Scalars['Boolean']>;
  changeSupplierEmail?: Maybe<Scalars['Boolean']>;
  changeSupplierPassword?: Maybe<Scalars['Boolean']>;
  checkPasswordAvailability?: Maybe<Scalars['Boolean']>;
  checkTransactionStatus?: Maybe<Scalars['Boolean']>;
  claimCoupon?: Maybe<Scalars['Boolean']>;
  claimDiscount?: Maybe<Scalars['Boolean']>;
  clearCart?: Maybe<Scalars['Boolean']>;
  createAppBanner?: Maybe<Scalars['Boolean']>;
  createCampaign?: Maybe<Campaign>;
  createCatalog?: Maybe<Scalars['Boolean']>;
  createCollectionConfig?: Maybe<Scalars['Boolean']>;
  createCoupon?: Maybe<Scalars['Boolean']>;
  createCustomer?: Maybe<Customer>;
  createCustomerAddress?: Maybe<CustomerAddress>;
  createCustomerSubscription?: Maybe<CustomerSubscription>;
  createDeliveryLocation: Scalars['Boolean'];
  createDeliveryZone?: Maybe<Scalars['Boolean']>;
  createDiscount?: Maybe<Discount>;
  createFeaturedCategory?: Maybe<Scalars['Boolean']>;
  createOrder?: Maybe<Scalars['Boolean']>;
  createPayoutRequest?: Maybe<Scalars['Boolean']>;
  createPickUpLocation: Scalars['Boolean'];
  createPlugin?: Maybe<Plugin>;
  createProduct?: Maybe<Scalars['Boolean']>;
  createProductCategory?: Maybe<Scalars['Boolean']>;
  createProductShipment?: Maybe<Scalars['Boolean']>;
  createPromoBanner?: Maybe<Scalars['Boolean']>;
  createReview: Scalars['Boolean'];
  createSharedProduct: CreateSharedProductResponseDto;
  createShop: CreateShopResponseDto;
  createShopCollection?: Maybe<Scalars['Boolean']>;
  createSubscriptionPackage?: Maybe<SubscriptionPackage>;
  createSupplier?: Maybe<SupplierCreationResponse>;
  createSupplierCustomer?: Maybe<Customer>;
  createTerm: Scalars['Boolean'];
  createTopDeal?: Maybe<Scalars['Boolean']>;
  createTopDealBanner?: Maybe<Scalars['Boolean']>;
  createTrendingProduct?: Maybe<Scalars['Boolean']>;
  creditUserWalletWithDelayedOrders?: Maybe<Scalars['Boolean']>;
  creditWallet: Scalars['Boolean'];
  customerSignIn?: Maybe<CustomerAuthPayload>;
  customerSignUp?: Maybe<CustomerAuthPayload>;
  customerSupplierSignUp?: Maybe<CustomerAuthPayload>;
  debitWallet: Scalars['String'];
  deleteAppBanner?: Maybe<Scalars['Boolean']>;
  deleteCampaign?: Maybe<Scalars['Boolean']>;
  deleteCoupon?: Maybe<Scalars['Boolean']>;
  deleteDeliveryLocation: Scalars['Boolean'];
  deleteDeliveryZone?: Maybe<Scalars['Boolean']>;
  deleteDiscount?: Maybe<Scalars['Boolean']>;
  deleteFeaturedCategory?: Maybe<Scalars['Boolean']>;
  deletePayoutRequest?: Maybe<Scalars['Boolean']>;
  deletePickUpLocation: Scalars['Boolean'];
  deletePlugin?: Maybe<Scalars['Boolean']>;
  deleteTerm: Scalars['Boolean'];
  deleteTopDeal?: Maybe<Scalars['Boolean']>;
  deleteTrendingProduct?: Maybe<Scalars['Boolean']>;
  editProductStat?: Maybe<Scalars['Boolean']>;
  forgotPassword?: Maybe<Scalars['String']>;
  initiateWalletForUser?: Maybe<Wallet>;
  inviteResellerBySupplier?: Maybe<Scalars['Boolean']>;
  joinSupplierResellerNetwork?: Maybe<Scalars['Boolean']>;
  loadProductsToShopify?: Maybe<Scalars['Boolean']>;
  /** Make payment using the tingg infrastructure. */
  makePayment: Scalars['String'];
  makeRequestForProduct?: Maybe<Scalars['Boolean']>;
  markCouponAsExpired: Scalars['Boolean'];
  onPurchaseSharedProduct?: Maybe<OnPurchaseSharedProductResponseDto>;
  opsAttendToProduct?: Maybe<Scalars['Boolean']>;
  /**
   * This method is called when you want to generate a payment URL that will be included in an email or SMS.
   * If you are using this to generate a link that will get used in SMSes, emails or for QR codes you need to pass an extra Boolean variable in the post data object i.e.
   * GenerateShortUrl with a value of true.
   */
  ozowGeneratePaymentUrl: OzowGeneratePaymentUrlResponseDto;
  /** This method is called when you want to query transactions using Ozow's reference. */
  ozowGetTransaction?: Maybe<OzowTransactionResponseDto>;
  /** This method is called when you want to query transactions using the merchant's reference. This method can return multiple results as Ozow does not restrict the merchant from sending duplicate merchant references even though we do advise that a unique reference is sent per transaction. The number of results returned are limited to 10. */
  ozowGetTransactionByReference?: Maybe<Array<Maybe<OzowTransactionResponseDto>>>;
  /** This operation is called after the user confirms his purchase and has chosen Ozow as his preferred payment method */
  ozowPaymentRequest: OzowPaymentRequestResultDto;
  /**
   * The Pay with Bank feature allows customers pay through internet banking portal or by providing their bank account number and authenticating using an OTP sent to their phone or email.
   * This is different from Bank Transfers where customers transfer money into a bank account.
   *
   * If the selected bank is Kuda, you need to make use of phone and token instead of account_number in the bank object:
   */
  paystackBankInitialiseCharge: PaystackBankInitialiseChargeResponseDto;
  /** Create multiple transfer recipients in batches. A duplicate account number will lead to the retrieval of the existing record. */
  paystackBulkCreateTransferRecipient: PaystackBulkCreateTransferRecipientResponseDto;
  /** Creates a new recipient. A duplicate account number will lead to the retrieval of the existing record. */
  paystackCreateTransferRecipient: PaystackCreateTransferRecipientResponseDto;
  /** Deletes a transfer recipient (sets the transfer recipient to inactive) */
  paystackDeleteTransferRecipient: PaystackDeleteTransferRecipientResponseDto;
  /** EFT payments are an instant bank transfer payment method where customers pay merchants through their internet banking interfaces. When the developer specifies an EFT provider, we do a redirect to the providers platform where the customer provides their payment details after which the payment is authorized. */
  paystackEFTInitialiseCharge: PaystackEftInitialiseChargeResponseDto;
  /** Finalize an initiated transfer */
  paystackFinaliseTransfer: PaystackFinaliseTransferResponseDto;
  /** You need to disable the Transfers OTP requirement to use this endpoint. */
  paystackInitiateBulkTransfer: PaystackInitiateBulkTransferResponseDto;
  /** Status of transfer object returned will be pending if OTP is disabled. In the event that an OTP is required, status will read otp. */
  paystackInitiateTransfer: PaystackInitiateTransferResponseDto;
  /** The QR option generates a QR code that allow customers to use a supported mobile app to complete payments. */
  paystackQRInitialiseCharge: PaystackQrInitialiseChargeResponseDto;
  /** Initialize a transaction from your backend */
  paystackTransactionInitialise: PaystackTransactionInitialiseResponseDto;
  /**
   * This Payment method is specifically for Nigerian customers.
   * The Pay via USSD channel allows your Nigerian customers to pay you by dialling a USSD code on their mobile device. This code is usually in the form of * followed by some code and ending with #. The user is prompted to authenticate the transaction with a PIN and then it is confirmed.
   */
  paystackUSSDInitialiseCharge: PaystackUssdInitialiseChargeResponseDto;
  /** Update an existing recipient. An duplicate account number will lead to the retrieval of the existing record. */
  paystackUpdateTransferRecipient: PaystackUpdateTransferRecipientResponseDto;
  processManualProfitPayout?: Maybe<Scalars['Boolean']>;
  processOrder?: Maybe<Scalars['Boolean']>;
  processProfitPayout?: Maybe<Scalars['Boolean']>;
  publishOrUnpublishProduct?: Maybe<Scalars['Boolean']>;
  refundResellerSecurityDeposit?: Maybe<Scalars['Boolean']>;
  refundResellerSecurityDepositBulk?: Maybe<Scalars['Boolean']>;
  removeCatalog?: Maybe<Scalars['Boolean']>;
  removeCategory?: Maybe<Scalars['Boolean']>;
  removeCollectionConfig?: Maybe<Scalars['Boolean']>;
  removeCustomer?: Maybe<Scalars['Boolean']>;
  removeCustomerAddress?: Maybe<Scalars['Boolean']>;
  removeItemFromCart?: Maybe<Scalars['Boolean']>;
  removePluginFromUser?: Maybe<Scalars['Boolean']>;
  removeProduct?: Maybe<Scalars['Boolean']>;
  removeProductCategory?: Maybe<Scalars['Boolean']>;
  removeProductCombination?: Maybe<Scalars['Boolean']>;
  removeProductConditionsFromDiscount?: Maybe<Scalars['Boolean']>;
  removeProductFromCollection?: Maybe<Scalars['Boolean']>;
  removeProductFromShop?: Maybe<Scalars['Boolean']>;
  removeProductImage?: Maybe<Scalars['Boolean']>;
  removePromoBanner?: Maybe<Scalars['Boolean']>;
  removeResellerBySupplier?: Maybe<Scalars['Boolean']>;
  removeReview?: Maybe<Scalars['Boolean']>;
  removeShopCollection?: Maybe<Scalars['Boolean']>;
  removeShopifyShop?: Maybe<Scalars['Boolean']>;
  removeSupplier?: Maybe<Scalars['Boolean']>;
  removeTopDealsBanners?: Maybe<Scalars['Boolean']>;
  removeUser?: Maybe<Scalars['Boolean']>;
  removeVariation?: Maybe<Scalars['Boolean']>;
  requestChangeEmail?: Maybe<Scalars['Boolean']>;
  requestChangePhone?: Maybe<Scalars['Boolean']>;
  requestEmailVerification?: Maybe<Scalars['String']>;
  requestOTP: RequestOtpResponse;
  requestPhoneVerification?: Maybe<PhoneVerificationOutPut>;
  requestSupplierEmailVerification: Scalars['String'];
  requestSupplierOTP?: Maybe<RequestSupplierOtpResponse>;
  requestSupplierPhoneVerification: RequestSupplierPhoneVerificationResponse;
  resetPassword?: Maybe<Scalars['Boolean']>;
  resetSupplierPassword?: Maybe<Scalars['Boolean']>;
  retryProcessingItems?: Maybe<Scalars['Boolean']>;
  reverseProfit?: Maybe<Scalars['Boolean']>;
  reverseTransaction: Scalars['Boolean'];
  sendSupplierResetPasswordMail?: Maybe<Scalars['Boolean']>;
  setSupplierPickupLocation?: Maybe<Scalars['Boolean']>;
  setSupplierProductMarkup?: Maybe<Scalars['Boolean']>;
  setupAccount: RequestOtpResponse;
  supplierSignIn: SupplierAuthPayload;
  syncShopifyProducts?: Maybe<Scalars['Boolean']>;
  /** This is when the merchant wants to acknowledge the request with a final status or a delivered status. This is sent as a JSON POST request. */
  tinggAcknowledgement: TinggAcknowledgementResponseDto;
  /** This function is used by merchants to post a charge request i.e. request to debit amount from customer for the checkout request that was posted earlier in the request/initiate function. */
  tinggChargeRequest: TinggPollPaymentStatusResponseDto;
  /** For this experience the customer controls the payment experience from their end where the customer invokes our APIs in order to facilitate payment. To invoke the payment the customer first generates a token which the customer passes on the headers as described above. */
  tinggCheckoutCharge: Scalars['String'];
  /** For this experience the customer controls the payment experience from their end where the customer invokes our APIs in order to facilitate payment. To invoke the payment the customer first generates a token which the customer passes on the headers as described above. */
  tinggCheckoutRequest: TinggCheckoutResponseDto;
  /** This function will allow billers to charge their customers with a specified amount using both local cards (issued in your country of operations) and International cards. This is sent as a JSON POST request. */
  tinggDirectCardCharge: TinggDirectCardResponseDto;
  /** Call when payment failed after tingg direct card charge */
  tinggOnPaymentFailed: Scalars['Boolean'];
  /** Call when payment is successful after tingg direct card charge */
  tinggOnPaymentSuccessful: Scalars['Boolean'];
  /** Keep polling tinggQueryStatus until a success or failure response is returned */
  tinggPollPaymentStatus: TinggPollPaymentStatusResponseDto;
  /** The query status is used by the merchant if they want to query for the status of the request they raised. In this case this is a GET request where the merchant passes service_code and merchant_transaction_id as part of the query parameters */
  tinggQueryStatus: TinggQueryStatusResponseDto;
  /** This function allows a merchant to refund payments that were already acknowledged as received and processed successsfully */
  tinggRefund: TinggRefundResponseDto;
  tinggWebhook: TinggWebhookResponseDto;
  toggleCategoryState: Scalars['Boolean'];
  toggleFreeDelivery: Scalars['Boolean'];
  unshareProduct: Scalars['Boolean'];
  updateAppBanner?: Maybe<Scalars['Boolean']>;
  updateCampaign?: Maybe<Campaign>;
  updateCatalog?: Maybe<Scalars['Boolean']>;
  updateCollectionConfig?: Maybe<Scalars['Boolean']>;
  updateCoupon?: Maybe<Scalars['Boolean']>;
  updateCustomer?: Maybe<Scalars['Boolean']>;
  updateDeliveryLocation: Scalars['Boolean'];
  updateDeliveryZone?: Maybe<Scalars['Boolean']>;
  updateDiscount?: Maybe<Discount>;
  updateForexRate?: Maybe<Scalars['Boolean']>;
  updateOrderDetailsOps?: Maybe<Scalars['Boolean']>;
  updateOrderSKU?: Maybe<Scalars['Boolean']>;
  updatePayoutRequest?: Maybe<Scalars['Boolean']>;
  updatePickUpLocation: Scalars['Boolean'];
  updatePlugin?: Maybe<Scalars['Boolean']>;
  updateProduct?: Maybe<Scalars['Boolean']>;
  updateProductCategories?: Maybe<Scalars['Boolean']>;
  updateProductCategory?: Maybe<Scalars['Boolean']>;
  updateProductCategoryAndTags?: Maybe<Scalars['Boolean']>;
  updateProductCombination?: Maybe<Scalars['Boolean']>;
  updateProductInformation?: Maybe<Scalars['Boolean']>;
  updateProductInventory?: Maybe<Scalars['Boolean']>;
  updateProductLikeState?: Maybe<Scalars['Boolean']>;
  updateProductMedia?: Maybe<Scalars['Boolean']>;
  updateProductSaveState?: Maybe<Scalars['Boolean']>;
  updateProductShipment?: Maybe<Scalars['Boolean']>;
  updateProductStock?: Maybe<Scalars['Boolean']>;
  updatePromoBanner?: Maybe<Scalars['Boolean']>;
  updateShopCollection?: Maybe<Scalars['Boolean']>;
  updateShopDetails: UpdateShopDetailsResponseDto;
  updateSubscriptionPackage?: Maybe<SubscriptionPackage>;
  updateSupplier: Scalars['Boolean'];
  updateSupplierBusinessContact?: Maybe<Scalars['Boolean']>;
  updateSupplierBusinessDetails?: Maybe<Scalars['Boolean']>;
  updateSupplierDetails?: Maybe<Scalars['Boolean']>;
  updateSupplierGenericName?: Maybe<Scalars['Boolean']>;
  updateSupplierPayment?: Maybe<SupplierPaymentDetails>;
  updateSupplierProfile?: Maybe<Scalars['Boolean']>;
  updateTerm: Scalars['Boolean'];
  updateUserDetails?: Maybe<Scalars['Boolean']>;
  updateVariation?: Maybe<Scalars['Boolean']>;
  userLogin?: Maybe<Auth>;
  verifyAccountBalance: Scalars['Boolean'];
  verifyEmail?: Maybe<Scalars['Boolean']>;
  verifyOTP?: Maybe<Scalars['Boolean']>;
  verifyPayoutTransaction: Scalars['Boolean'];
  verifyProduct?: Maybe<Scalars['Boolean']>;
  verifySupplierAccount?: Maybe<Scalars['Boolean']>;
  verifySupplierBusiness?: Maybe<Scalars['Boolean']>;
  verifySupplierOTP?: Maybe<Scalars['Boolean']>;
};


export type MutationAccountRegisterArgs = {
  input?: InputMaybe<AccountRegisterInput>;
};


export type MutationActivateShopArgs = {
  data: ActivateShopRequestDto;
};


export type MutationAddBusinessDocumentsArgs = {
  input?: InputMaybe<AddBusinessDocumentInput>;
};


export type MutationAddCommentArgs = {
  input?: InputMaybe<AddCommentInput>;
};


export type MutationAddCommentsToProductArgs = {
  input?: InputMaybe<AddCommentsToProductInput>;
};


export type MutationAddItemToCartArgs = {
  input: AddItemToCartInput;
};


export type MutationAddPluginToUserArgs = {
  data: AddPluginToUserRequestDto;
};


export type MutationAddProductConditionsToDiscountArgs = {
  input: Array<AddProductConditionToDiscountRequestDto>;
};


export type MutationAddProductToShopArgs = {
  product_id: Scalars['ID'];
  profit_added: Scalars['Float'];
  shop_id: Scalars['ID'];
};


export type MutationAddProductToShopCollectionArgs = {
  collection_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationAddProductsToCollectionArgs = {
  input?: InputMaybe<AddProductsToCollectionInput>;
};


export type MutationAddProductsToShopCollectionArgs = {
  collection_id: Scalars['ID'];
  product_ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationAddProductstoDiscountArgs = {
  discountId: Scalars['ID'];
  productSKUs: Array<Scalars['String']>;
};


export type MutationAddSupplierAgreementTermsArgs = {
  input?: InputMaybe<AddSupplierAgreementTermsInput>;
};


export type MutationAddSupplierBusinessDetailsArgs = {
  input?: InputMaybe<SupplierBusinessInput>;
};


export type MutationAddSupplierDeviceTokenArgs = {
  input?: InputMaybe<SupplierAddDeviceTokenInput>;
};


export type MutationAddSupplierLocationArgs = {
  input?: InputMaybe<AddSupplierLocationInput>;
};


export type MutationAddSupplierPaymentDetailsArgs = {
  input?: InputMaybe<AddSupplierPaymentInput>;
};


export type MutationAddUserPaymentDetailsArgs = {
  input?: InputMaybe<UserPaymentInput>;
};


export type MutationAdjustWalletBalanceArgs = {
  user_id: Scalars['ID'];
};


export type MutationAllowResellingOfProductArgs = {
  id: Scalars['ID'];
};


export type MutationAuthenticateWithTokenArgs = {
  input?: InputMaybe<AuthenticateWithTokenInput>;
};


export type MutationBobCancelShipmentArgs = {
  data: BobCancelShipmentRequestDto;
};


export type MutationBobCreateOrderArgs = {
  data: BobCreateOrderRequestDto;
};


export type MutationBobCreateShipmentArgs = {
  data: BobCreateShipmentRequestDto;
};


export type MutationBulkCreateProductsArgs = {
  products?: InputMaybe<Array<InputMaybe<TempCreateProductInput>>>;
};


export type MutationCancelCustomerSubscriptionArgs = {
  user_id: Scalars['ID'];
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type MutationChangeResellerSupplierShopArgs = {
  reseller_id: Scalars['ID'];
  supplier_shop_id: Scalars['ID'];
};


export type MutationChangeSupplierEmailArgs = {
  input?: InputMaybe<SupplierEmailChangeInput>;
};


export type MutationChangeSupplierPasswordArgs = {
  input?: InputMaybe<SupplierPasswordChangeInput>;
};


export type MutationCheckPasswordAvailabilityArgs = {
  input?: InputMaybe<CheckPasswordAvailabilityInput>;
};


export type MutationCheckTransactionStatusArgs = {
  reference: Scalars['String'];
};


export type MutationClaimCouponArgs = {
  input: ClaimCouponInput;
};


export type MutationClaimDiscountArgs = {
  input: ClaimDiscountRequestDto;
};


export type MutationClearCartArgs = {
  user_id: Scalars['ID'];
};


export type MutationCreateAppBannerArgs = {
  input: AppBannerInput;
};


export type MutationCreateCampaignArgs = {
  data: CreateCampaignInput;
};


export type MutationCreateCatalogArgs = {
  input?: InputMaybe<CatalogInput>;
};


export type MutationCreateCollectionConfigArgs = {
  input?: InputMaybe<CatalogConfigInput>;
};


export type MutationCreateCouponArgs = {
  input: CouponInput;
};


export type MutationCreateCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type MutationCreateCustomerAddressArgs = {
  customer_id: Scalars['ID'];
  input?: InputMaybe<AddressInput>;
};


export type MutationCreateCustomerSubscriptionArgs = {
  input: CreateCustomerSubscriptionRequestDto;
};


export type MutationCreateDeliveryLocationArgs = {
  input: DeliveryInput;
};


export type MutationCreateDeliveryZoneArgs = {
  input?: InputMaybe<DeliveryZonesInput>;
};


export type MutationCreateDiscountArgs = {
  input: CreateDiscountRequestDto;
};


export type MutationCreateFeaturedCategoryArgs = {
  banners?: InputMaybe<Scalars['String']>;
  categoryId: Scalars['ID'];
  color: Scalars['String'];
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<OrderCreateInput>;
};


export type MutationCreatePayoutRequestArgs = {
  input?: InputMaybe<PayoutInput>;
};


export type MutationCreatePickUpLocationArgs = {
  input: PickUpInput;
};


export type MutationCreatePluginArgs = {
  data: CreatePluginRequestDto;
};


export type MutationCreateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationCreateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type MutationCreateProductShipmentArgs = {
  input?: InputMaybe<ProductShipmentInput>;
};


export type MutationCreatePromoBannerArgs = {
  input?: InputMaybe<PromoBannerInput>;
};


export type MutationCreateReviewArgs = {
  input: ReviewInput;
};


export type MutationCreateSharedProductArgs = {
  input: CreateSharedProductRequestDto;
};


export type MutationCreateShopArgs = {
  data: CreateShopRequestDto;
};


export type MutationCreateShopCollectionArgs = {
  input?: InputMaybe<ShopCollectionInput>;
};


export type MutationCreateSubscriptionPackageArgs = {
  input: CreateSubscriptionRequestDto;
};


export type MutationCreateSupplierArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type MutationCreateSupplierCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
  supplier_id: Scalars['ID'];
};


export type MutationCreateTermArgs = {
  input: TermInput;
};


export type MutationCreateTopDealArgs = {
  productId: Scalars['ID'];
};


export type MutationCreateTopDealBannerArgs = {
  input: CreateTopDealBannerInput;
};


export type MutationCreateTrendingProductArgs = {
  productId: Scalars['ID'];
};


export type MutationCreditUserWalletWithDelayedOrdersArgs = {
  orders: Array<InputMaybe<Scalars['ID']>>;
  paid_security_deposit?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreditWalletArgs = {
  amount: Scalars['Float'];
  reference: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  transaction_type?: InputMaybe<Scalars['String']>;
};


export type MutationCustomerSignInArgs = {
  input?: InputMaybe<CustomerLoginInput>;
};


export type MutationCustomerSignUpArgs = {
  input?: InputMaybe<CustomerInput>;
  user_id: Scalars['ID'];
};


export type MutationCustomerSupplierSignUpArgs = {
  input?: InputMaybe<CustomerInput>;
  supplier_id: Scalars['ID'];
};


export type MutationDebitWalletArgs = {
  amount: Scalars['Float'];
  user_id: Scalars['ID'];
};


export type MutationDeleteAppBannerArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type MutationDeleteCouponArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDeliveryZoneArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteFeaturedCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePayoutRequestArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePickUpLocationArgs = {
  id: Scalars['ID'];
};


export type MutationDeletePluginArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTermArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteTopDealArgs = {
  productId: Scalars['ID'];
};


export type MutationDeleteTrendingProductArgs = {
  productId: Scalars['ID'];
};


export type MutationEditProductStatArgs = {
  input: EditProductStatInput;
};


export type MutationForgotPasswordArgs = {
  input?: InputMaybe<ForgotPasswordInput>;
};


export type MutationInitiateWalletForUserArgs = {
  user_id: Scalars['ID'];
};


export type MutationInviteResellerBySupplierArgs = {
  email: Scalars['String'];
  supplier_id: Scalars['ID'];
  terms_id: Scalars['ID'];
};


export type MutationJoinSupplierResellerNetworkArgs = {
  reseller_id: Scalars['ID'];
  supplier_id: Scalars['ID'];
  terms_id: Scalars['ID'];
};


export type MutationLoadProductsToShopifyArgs = {
  input?: InputMaybe<LoadProductToShopifyInput>;
};


export type MutationMakePaymentArgs = {
  data?: InputMaybe<MakeTinggPaymentRequestDto>;
};


export type MutationMakeRequestForProductArgs = {
  input?: InputMaybe<MakeRequestForProduct>;
};


export type MutationMarkCouponAsExpiredArgs = {
  id: Scalars['ID'];
};


export type MutationOnPurchaseSharedProductArgs = {
  input?: InputMaybe<OnPurchaseSharedProductRequestDto>;
};


export type MutationOpsAttendToProductArgs = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  media?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationOzowGeneratePaymentUrlArgs = {
  generateShortUrl?: InputMaybe<Scalars['Boolean']>;
  input: OzowPaymentRequestDto;
};


export type MutationOzowGetTransactionArgs = {
  input: OzowGetTransactionRequestDto;
};


export type MutationOzowGetTransactionByReferenceArgs = {
  input: OzowGetTransactionByReferenceRequestDto;
};


export type MutationOzowPaymentRequestArgs = {
  data?: InputMaybe<OzowPaymentRequestDto>;
};


export type MutationPaystackBankInitialiseChargeArgs = {
  data: PaystackBankInitialiseChargeRequestDto;
};


export type MutationPaystackBulkCreateTransferRecipientArgs = {
  data: PaystackBulkCreateTransferRecipientRequestDto;
};


export type MutationPaystackCreateTransferRecipientArgs = {
  data: PaystackCreateTransferRecipientRequestDto;
};


export type MutationPaystackDeleteTransferRecipientArgs = {
  data: PaystackDeleteTransferRecipientRequestDto;
};


export type MutationPaystackEftInitialiseChargeArgs = {
  data: PaystackEftInitialiseChargeRequestDto;
};


export type MutationPaystackFinaliseTransferArgs = {
  data: PaystackFinaliseTransferRequestDto;
};


export type MutationPaystackInitiateBulkTransferArgs = {
  data: PaystackInitiateBulkTransferRequestDto;
};


export type MutationPaystackInitiateTransferArgs = {
  data: PaystackInitiateTransferRequestDto;
};


export type MutationPaystackQrInitialiseChargeArgs = {
  data: PaystackQrInitialiseChargeRequestDto;
};


export type MutationPaystackTransactionInitialiseArgs = {
  data: PaystackTransactionInitialiseRequestDto;
};


export type MutationPaystackUssdInitialiseChargeArgs = {
  data: PaystackUssdInitialiseChargeRequestDto;
};


export type MutationPaystackUpdateTransferRecipientArgs = {
  data: PaystackUpdateTransferRecipientRequestDto;
};


export type MutationProcessManualProfitPayoutArgs = {
  cart_number: Scalars['String'];
};


export type MutationProcessOrderArgs = {
  id: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};


export type MutationProcessProfitPayoutArgs = {
  orderId: Scalars['ID'];
};


export type MutationPublishOrUnpublishProductArgs = {
  id: Scalars['ID'];
  published: Scalars['Boolean'];
};


export type MutationRefundResellerSecurityDepositArgs = {
  paid?: InputMaybe<Scalars['Boolean']>;
  reference: Scalars['String'];
};


export type MutationRefundResellerSecurityDepositBulkArgs = {
  paid?: InputMaybe<Scalars['Boolean']>;
  references: Array<InputMaybe<Scalars['String']>>;
};


export type MutationRemoveCatalogArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCollectionConfigArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCustomerArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveCustomerAddressArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveItemFromCartArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePluginFromUserArgs = {
  filter: UserPluginFilter;
};


export type MutationRemoveProductArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveProductCategoryArgs = {
  category_id: Scalars['ID'];
  product_id: Scalars['ID'];
};


export type MutationRemoveProductCombinationArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveProductConditionsFromDiscountArgs = {
  productConditionIds: Array<Scalars['ID']>;
};


export type MutationRemoveProductFromCollectionArgs = {
  input?: InputMaybe<AddProductsToCollectionInput>;
};


export type MutationRemoveProductFromShopArgs = {
  product_id: Scalars['ID'];
  shop_id: Scalars['ID'];
};


export type MutationRemoveProductImageArgs = {
  id: Scalars['ID'];
};


export type MutationRemovePromoBannerArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveResellerBySupplierArgs = {
  reseller_id: Scalars['ID'];
  supplier_id: Scalars['ID'];
};


export type MutationRemoveReviewArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveShopCollectionArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveShopifyShopArgs = {
  supplier_id: Scalars['ID'];
};


export type MutationRemoveSupplierArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type MutationRemoveTopDealsBannersArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID'];
};


export type MutationRemoveVariationArgs = {
  id: Scalars['ID'];
};


export type MutationRequestChangeEmailArgs = {
  input?: InputMaybe<RequestChangeEmailInput>;
};


export type MutationRequestChangePhoneArgs = {
  input?: InputMaybe<RequestChangePhoneInput>;
};


export type MutationRequestEmailVerificationArgs = {
  input?: InputMaybe<RequestEmailVerificationInput>;
};


export type MutationRequestOtpArgs = {
  input?: InputMaybe<RequestOtpInput>;
};


export type MutationRequestPhoneVerificationArgs = {
  input?: InputMaybe<CheckPasswordAvailabilityInput>;
};


export type MutationRequestSupplierEmailVerificationArgs = {
  input?: InputMaybe<RequestEmailVerificationInput>;
};


export type MutationRequestSupplierOtpArgs = {
  input?: InputMaybe<RequestOtpInput>;
};


export type MutationRequestSupplierPhoneVerificationArgs = {
  input?: InputMaybe<RequestSupplierPhoneVerificationInput>;
};


export type MutationResetPasswordArgs = {
  input?: InputMaybe<ResetPasswordInput>;
};


export type MutationResetSupplierPasswordArgs = {
  input?: InputMaybe<SupplierPasswordResetInput>;
};


export type MutationRetryProcessingItemsArgs = {
  country: Scalars['String'];
};


export type MutationReverseProfitArgs = {
  reference: Scalars['String'];
};


export type MutationReverseTransactionArgs = {
  reference: Scalars['String'];
};


export type MutationSendSupplierResetPasswordMailArgs = {
  input?: InputMaybe<SupplierPasswordResetMailInput>;
};


export type MutationSetSupplierPickupLocationArgs = {
  input?: InputMaybe<SetSupplierPickupLocationInput>;
};


export type MutationSetSupplierProductMarkupArgs = {
  input?: InputMaybe<SetSupplierProductMarkupInput>;
};


export type MutationSetupAccountArgs = {
  input?: InputMaybe<SetupAccountInput>;
};


export type MutationSupplierSignInArgs = {
  deviceToken?: InputMaybe<Scalars['String']>;
  emailOrPhone: Scalars['String'];
  password: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};


export type MutationSyncShopifyProductsArgs = {
  input: SyncShopifyProductInput;
};


export type MutationTinggAcknowledgementArgs = {
  data: TinggAcknowledgementRequestDto;
};


export type MutationTinggChargeRequestArgs = {
  data: TinggChargeRequestDto;
};


export type MutationTinggCheckoutChargeArgs = {
  data: TinggCheckoutChargeRequestDto;
};


export type MutationTinggCheckoutRequestArgs = {
  data: InitiateTinggCheckoutRequestDto;
};


export type MutationTinggDirectCardChargeArgs = {
  data: TinggDirectCardRequestDto;
};


export type MutationTinggOnPaymentFailedArgs = {
  data: TinggOnPaymentFailedRequestDto;
};


export type MutationTinggOnPaymentSuccessfulArgs = {
  data: TinggOnPaymentSuccessfulRequestDto;
};


export type MutationTinggPollPaymentStatusArgs = {
  data: TinggPollPaymentStatusRequestDto;
};


export type MutationTinggQueryStatusArgs = {
  data: TinggQueryStatusRequestDto;
};


export type MutationTinggRefundArgs = {
  data: TinggRefundRequestDto;
};


export type MutationTinggWebhookArgs = {
  data: TinggWebhookRequestDto;
};


export type MutationToggleCategoryStateArgs = {
  id: Scalars['ID'];
  state: Scalars['Boolean'];
};


export type MutationToggleFreeDeliveryArgs = {
  id: Scalars['ID'];
};


export type MutationUnshareProductArgs = {
  input: UnshareProductRequestDto;
};


export type MutationUpdateAppBannerArgs = {
  input: AppBannerInput;
};


export type MutationUpdateCampaignArgs = {
  data: UpdateCampaignInput;
  filter?: InputMaybe<CampaignFilter>;
};


export type MutationUpdateCatalogArgs = {
  input?: InputMaybe<CatalogInput>;
};


export type MutationUpdateCollectionConfigArgs = {
  input?: InputMaybe<CatalogConfigInput>;
};


export type MutationUpdateCouponArgs = {
  input: CouponInput;
};


export type MutationUpdateCustomerArgs = {
  input?: InputMaybe<CustomerInput>;
};


export type MutationUpdateDeliveryLocationArgs = {
  input: DeliveryInput;
};


export type MutationUpdateDeliveryZoneArgs = {
  input?: InputMaybe<DeliveryZonesInput>;
};


export type MutationUpdateDiscountArgs = {
  data: UpdateDiscountData;
  filter: DiscountFilter;
};


export type MutationUpdateForexRateArgs = {
  input?: InputMaybe<ForexRateInput>;
};


export type MutationUpdateOrderDetailsOpsArgs = {
  cart_id: Scalars['ID'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  delivery_price: Scalars['Float'];
  order_id: Scalars['ID'];
  quantity: Scalars['Int'];
};


export type MutationUpdateOrderSkuArgs = {
  id: Scalars['ID'];
  sku: Scalars['ID'];
};


export type MutationUpdatePayoutRequestArgs = {
  input?: InputMaybe<UpdatePayoutInput>;
};


export type MutationUpdatePickUpLocationArgs = {
  input: PickUpInput;
};


export type MutationUpdatePluginArgs = {
  data: UpdatePluginRequestDto;
};


export type MutationUpdateProductArgs = {
  input?: InputMaybe<CreateProductInput>;
};


export type MutationUpdateProductCategoriesArgs = {
  input: UpdateProductCategoriesInput;
};


export type MutationUpdateProductCategoryArgs = {
  input?: InputMaybe<ProductCategoryInput>;
};


export type MutationUpdateProductCategoryAndTagsArgs = {
  input?: InputMaybe<ProductCategoryAndTagsInput>;
};


export type MutationUpdateProductCombinationArgs = {
  input?: InputMaybe<ProductCombinationInput>;
};


export type MutationUpdateProductInformationArgs = {
  input?: InputMaybe<ProductInformationInput>;
};


export type MutationUpdateProductInventoryArgs = {
  input?: InputMaybe<ProductInventoryInput>;
};


export type MutationUpdateProductLikeStateArgs = {
  input: EditProductStatInput;
};


export type MutationUpdateProductMediaArgs = {
  input?: InputMaybe<ProductMediaInput>;
};


export type MutationUpdateProductSaveStateArgs = {
  input: EditProductStatInput;
};


export type MutationUpdateProductShipmentArgs = {
  input?: InputMaybe<ProductShipmentInput>;
};


export type MutationUpdateProductStockArgs = {
  input: ProductStockInput;
};


export type MutationUpdatePromoBannerArgs = {
  input?: InputMaybe<PromoBannerInput>;
};


export type MutationUpdateShopCollectionArgs = {
  input?: InputMaybe<ShopCollectionInput>;
};


export type MutationUpdateShopDetailsArgs = {
  data: UpdateShopDetailsRequestDto;
  premium_subscription?: InputMaybe<CustomerSubscriptionInput>;
};


export type MutationUpdateSubscriptionPackageArgs = {
  data?: InputMaybe<UpdateSubscriptionPackageData>;
  filter?: InputMaybe<SubscriptionFilter>;
};


export type MutationUpdateSupplierArgs = {
  input?: InputMaybe<SupplierInput>;
};


export type MutationUpdateSupplierBusinessContactArgs = {
  input?: InputMaybe<UpdateSupplierBusinessContactInput>;
};


export type MutationUpdateSupplierBusinessDetailsArgs = {
  input?: InputMaybe<UpdateSupplierBusinessDetailsInput>;
};


export type MutationUpdateSupplierDetailsArgs = {
  input?: InputMaybe<UpdateSupplierDetailsInput>;
};


export type MutationUpdateSupplierGenericNameArgs = {
  input: VerifySupplierBusinessInput;
};


export type MutationUpdateSupplierPaymentArgs = {
  input?: InputMaybe<UpdateSupplierPaymentInput>;
};


export type MutationUpdateSupplierProfileArgs = {
  input?: InputMaybe<SupplierProfileUpdateInput>;
};


export type MutationUpdateTermArgs = {
  input: TermInput;
};


export type MutationUpdateUserDetailsArgs = {
  input?: InputMaybe<UpdateUserDetailsInput>;
};


export type MutationUpdateVariationArgs = {
  input?: InputMaybe<VariationInput>;
};


export type MutationUserLoginArgs = {
  input?: InputMaybe<UserLoginInput>;
};


export type MutationVerifyAccountBalanceArgs = {
  amount: Scalars['Float'];
  user_id: Scalars['ID'];
};


export type MutationVerifyEmailArgs = {
  input?: InputMaybe<VerifyEmailInput>;
};


export type MutationVerifyOtpArgs = {
  input?: InputMaybe<VerifyOtpInput>;
};


export type MutationVerifyPayoutTransactionArgs = {
  reference: Scalars['String'];
  user_id: Scalars['ID'];
};


export type MutationVerifyProductArgs = {
  input: VerifyProductInput;
};


export type MutationVerifySupplierAccountArgs = {
  input?: InputMaybe<VerifySupplierAccountInput>;
};


export type MutationVerifySupplierBusinessArgs = {
  input: VerifySupplierBusinessInput;
};


export type MutationVerifySupplierOtpArgs = {
  input?: InputMaybe<VerifySupplierOtpInput>;
};

export type NumberOperator = {
  between?: InputMaybe<NumberRange>;
  eq?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
};

export type NumberRange = {
  end: Scalars['Float'];
  start: Scalars['Float'];
};

export type OfflineSaleInput = {
  address?: InputMaybe<AddressInput>;
  address_id?: InputMaybe<Scalars['ID']>;
  customer_id?: InputMaybe<Scalars['ID']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<OrderProductInput>>>;
  payment_type?: InputMaybe<Scalars['String']>;
  shop_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  total_amount?: InputMaybe<Scalars['Float']>;
};

export type OnDiscountUseRequestDto = {
  discount_code: Scalars['String'];
  discount_id: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
};

export type OnPurchaseSharedProductRequestDto = {
  product_id: Scalars['ID'];
  profit_added_by_reseller: Scalars['Int'];
  total_selling_price: Scalars['Int'];
};

export type OnPurchaseSharedProductResponseDto = {
  __typename?: 'OnPurchaseSharedProductResponseDto';
  productId?: Maybe<Scalars['ID']>;
};

export type Order = {
  __typename?: 'Order';
  address?: Maybe<CustomerAddress>;
  cart_number: Scalars['String'];
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['Date']>;
  customer?: Maybe<Customer>;
  customer_address_id?: Maybe<Scalars['ID']>;
  customer_id: Scalars['ID'];
  customer_paid: Scalars['Boolean'];
  delivery?: Maybe<Delivery>;
  delivery_amount?: Maybe<Scalars['Float']>;
  delivery_id?: Maybe<Scalars['ID']>;
  delivery_instructions?: Maybe<Scalars['String']>;
  delivery_type: Scalars['String'];
  discount?: Maybe<Scalars['Float']>;
  free_delivery?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  order_total: Scalars['Float'];
  payment?: Maybe<Payment>;
  payment_id?: Maybe<Scalars['ID']>;
  payment_status?: Maybe<Scalars['String']>;
  payment_type: Scalars['String'];
  reseller?: Maybe<User>;
  security_deposit?: Maybe<Scalars['Float']>;
  security_deposit_paid?: Maybe<Scalars['Boolean']>;
  source: Scalars['String'];
  supplier?: Maybe<Supplier>;
  supplier_id?: Maybe<Scalars['ID']>;
  tracking_code?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};

export type OrderByDto = {
  fields: Array<Scalars['String']>;
  values: Array<Scalars['String']>;
};

export type OrderComment = {
  __typename?: 'OrderComment';
  createdAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  staff_name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export type OrderCreateInput = {
  address_id?: InputMaybe<Scalars['ID']>;
  couponCode?: InputMaybe<Scalars['String']>;
  customer_id: Scalars['ID'];
  customer_paid: Scalars['Boolean'];
  delivery_amount: Scalars['Float'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  delivery_type?: InputMaybe<Scalars['String']>;
  discount: Scalars['Float'];
  estimate_id?: InputMaybe<Scalars['ID']>;
  free_delivery?: InputMaybe<Scalars['Boolean']>;
  hasPreviousOrder?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  payment_id?: InputMaybe<Scalars['String']>;
  payment_status?: InputMaybe<Scalars['String']>;
  payment_type?: InputMaybe<Scalars['String']>;
  products: Array<OrderProductInput>;
  reseller: Scalars['ID'];
  security_deposit?: InputMaybe<Scalars['Float']>;
  source?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  total_amount: Scalars['Float'];
};

export type OrderFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  customer_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  orderId?: InputMaybe<IdOperator>;
  orderNumber?: InputMaybe<StringOperator>;
  payment_id?: InputMaybe<StringOperator>;
  productId?: InputMaybe<IdOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tracking_code?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type OrderGraphData = {
  __typename?: 'OrderGraphData';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type OrderHistory = {
  __typename?: 'OrderHistory';
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  ops_personel?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type OrderInput = {
  cartNumber?: InputMaybe<Scalars['String']>;
  customer_address_id?: InputMaybe<Scalars['ID']>;
  customer_id: Scalars['ID'];
  delivery_id?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  orderTotal: Scalars['Float'];
  supplier_id?: InputMaybe<Scalars['ID']>;
  user_id: Scalars['ID'];
};

export type OrderItem = {
  __typename?: 'OrderItem';
  comments?: Maybe<Array<Maybe<OrderComment>>>;
  createdAt?: Maybe<Scalars['Date']>;
  history?: Maybe<Array<Maybe<OrderHistory>>>;
  id: Scalars['ID'];
  order?: Maybe<Order>;
  orderNumber?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  profitAdded?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  sku: Scalars['ID'];
  source?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
};

export enum OrderKind {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Tendo = 'TENDO'
}

export type OrderProductFilter = {
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  orderId?: InputMaybe<NumberOperator>;
  orderNumber?: InputMaybe<StringOperator>;
  price?: InputMaybe<NumberOperator>;
  profitAdded?: InputMaybe<NumberOperator>;
  quantity?: InputMaybe<NumberOperator>;
  sku?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type OrderProductInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  discount?: InputMaybe<Scalars['Float']>;
  price: Scalars['Float'];
  product_id: Scalars['ID'];
  profitAdded: Scalars['Float'];
  qty: Scalars['Int'];
};

export type OrderReview = {
  __typename?: 'OrderReview';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order_id: Scalars['ID'];
  rating: Scalars['Float'];
};

export type OrderSort = {
  field?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Sort>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  ordersAllTime: Scalars['Int'];
  ordersMonth: Scalars['Int'];
  ordersToday: Scalars['Int'];
  ordersWeek: Scalars['Int'];
  ordersYear: Scalars['Int'];
};

export type OrderStatsStats = {
  __typename?: 'OrderStatsStats';
  totalCancelled: Scalars['Int'];
  totalDelivered: Scalars['Int'];
  totalPending: Scalars['Int'];
  totalSuccessful: Scalars['Int'];
};

export enum OrderStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Delivered = 'DELIVERED',
  Intransit = 'INTRANSIT',
  Paid = 'PAID',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Returned = 'RETURNED'
}

export type OzowGeneratePaymentUrlResponseDto = {
  __typename?: 'OzowGeneratePaymentUrlResponseDto';
  /** Error message generated when validating the request. */
  errorMessage?: Maybe<Scalars['String']>;
  /** Ozow's unique identifier for the payment request. */
  paymentRequestId?: Maybe<Scalars['String']>;
  /**
   * Generated URL that allows payment for the posted variables used to create the payment request.
   * The payment Url you'll receive from the API is dynamic, so please don't hard code it into your integrations as it might change
   */
  url?: Maybe<Scalars['String']>;
};

export type OzowGetTransactionByReferenceRequestDto = {
  /** Defaults to false. Use true only to get results for test requests. */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** The merchant's reference for the transaction */
  transactionReference: Scalars['String'];
};

export type OzowGetTransactionRequestDto = {
  /** Defaults to false. Use true only to get results for test requests. */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** Ozow's reference for the transaction. This would be passed back to the merchant in the redirect and notification responses. */
  transactionId: Scalars['String'];
};

export type OzowPaymentRequestDto = {
  /** Allow user to change the amount passed through before paying. This option needs to also be enabled for the site in the merchant admin portal to be used. Accepted values are true or false. DO NOT include false in the hash check string, just ignore instead. */
  allowVariableAmount?: InputMaybe<Scalars['Boolean']>;
  /** The transaction amount. The amount is in the currency specified by the currency code posted */
  amount: Scalars['Float'];
  /** The name of to be used for the bank account. Only alphanumeric characters and spaces allowed. */
  bankAccountName?: InputMaybe<Scalars['String']>;
  /** The bank account number the payment should be made to. */
  bankAccountNumber?: InputMaybe<Scalars['String']>;
  /**
   * The bank that the payment should be made to. Merchant needs to be enabled to send through banking details (18 - 21) in the post, for most merchants this is setup when creating the merchant account.
   *   Allowed values are:
   *       • ABSA – 3284A0AD-BA78-4838-8C2B-102981286A2B
   *       • Capitec - 913999FA-3A32-4E3D-82F0-A1DF7E9E4F7B
   *       • FNB - 4816019C-3314-4C80-8B6B-B2CD16DCC4EC
   *       • Nedbank - BF0561FD-4203-4A0C-9174-
   *       CB26FCD87A60
   *       • Standard Bank - AD7D8DA4-1723-4066-94BB-
   *       6662D845E483
   *       • Investec - 4B45BE85-B616-4BD1-9027-F8FCF8F9AF7B
   */
  bankId?: InputMaybe<Scalars['String']>;
  /**
   * The reference that will be prepopulated in the "their reference" field in the customers online banking site.
   * This will be the payment reference that appears on the merchant’s bank statement and can be used for recon purposes.
   * Only alphanumeric characters, spaces and dashes are allowed.
   */
  bankReference?: InputMaybe<Scalars['String']>;
  /** The branch code for the bank account */
  branchCode?: InputMaybe<Scalars['String']>;
  /** The URL that we should post the redirect result to if the customer cancels the payment, this will also be the page the customer gets redirect back to. This URL can also be set for the applicable merchant site in the merchant admin section. If a value is set in the merchant admin and sent in the post, the posted value will be redirected to if the payment is cancelled. */
  cancelUrl?: InputMaybe<Scalars['String']>;
  /** Cart details */
  cart?: InputMaybe<Scalars['Any']>;
  /** Email of the customer */
  customerEmail: Scalars['String'];
  /** Full name of the customer */
  customerFullName: Scalars['String'];
  /** Phone number of the customer */
  customerPhone: Scalars['String'];
  /** The URL that we should post the redirect result to if an error occurred while trying to process the payment, this will also be the page the customer gets redirect back to. This URL can also be set for the applicable merchant site in the merchant admin section. . If a value is set in the merchant admin and sent in the post, the posted value will be redirected to if an error occurred while processing the payment. */
  errorUrl?: InputMaybe<Scalars['String']>;
  /** Payment will not be allowed to be made after this date. Date should be UTC and value should be formatted as yyyy-MM-dd HH:mm e.g. 2015-08-11 16:02 */
  expiryDateUtc?: InputMaybe<Scalars['String']>;
  /** Send true to test your request posting and response handling. If set to true you will be redirected to a page where you can select whether you would like a successful or unsuccessful redirect response sent back. Please note that notification responses are not sent for test transactions and the online banking payment is skipped. Accepted values are true or false. */
  isTest?: InputMaybe<Scalars['Boolean']>;
  /** The URL that we should post the notification result to. The result will post regardless of the outcome of the transaction. This URL can also be set for the applicable merchant site in the merchant admin section. If a value is set in the merchant admin and sent in the post, the notification result will be sent to the posted value. Find out more in the notification response section in step 2. */
  notifyUrl?: InputMaybe<Scalars['String']>;
  /** Name shown on the site as the entity being paid (not in banking screens) */
  payeeDisplayName?: InputMaybe<Scalars['String']>;
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** The URL that we should post the redirect result to if the payment was successful, this will also be the page the customer gets redirect back to. This URL can also be set for the applicable merchant site in the merchant admin section. . If a value is set in the merchant admin and sent in the post, the posted value will be redirected to if the payment was successful. Please note that it would not be sufficient to assume the payment was successful just because the customer was redirected back to this page, it highly recommended that you check the response fields and as well as check the transaction status using our check transaction status API call. */
  successUrl?: InputMaybe<Scalars['String']>;
  /** The merchant's reference for the transaction */
  transactionReference?: InputMaybe<Scalars['String']>;
  /** If AllowVariableAmount is passed through as true, this will dictate the highest acceptable amount the user can enter */
  variableAmountMax?: InputMaybe<Scalars['Float']>;
  /** If AllowVariableAmount is passed through as true, this will dictate the lowest acceptable amount the user can enter */
  variableAmountMin?: InputMaybe<Scalars['Float']>;
};

export type OzowPaymentRequestResultDto = {
  __typename?: 'OzowPaymentRequestResultDto';
  htmlResponse?: Maybe<Scalars['String']>;
  referenceCode?: Maybe<Scalars['String']>;
};

export type OzowPaymentResponseDto = {
  __typename?: 'OzowPaymentResponseDto';
  /** The transaction amount. The amount is in the currency specified by the currency code posted. */
  Amount: Scalars['Float'];
  /** The name of the bank the payment was made from. */
  BankName: Scalars['String'];
  /** The transaction currency code sent in the request post. */
  CurrencyCode: Scalars['String'];
  /**
   * SHA512 hash used to ensure that certain fields in the message have not been altered after the hash was generated.
   * Check the generate hash section below for more details on how to validate the response variables using the hash
   */
  Hash: Scalars['String'];
  /** Whether or not the original request was a test request. Possible values are true or false. */
  IsTest: Scalars['Boolean'];
  /**
   * The masked account number the payment was made from.
   * If account number is 12 or more digits then the first and last four digits are unmasked e.g. 1234567898765 will be masked as 1234*****8765
   * If the account number is less than12 digits then the first and last 3 digits are left unmasked e.g. 123456789 will be masked as 123***789
   * This is not available by default and a request by the merchant must be submitted along with the use case for needing this information
   */
  MaskedAccountNumber?: Maybe<Scalars['String']>;
  /** The site code sent to Ozow in the request post. */
  SiteCode: Scalars['String'];
  /**
   *  Some Ozow merchants have requested this information as they use this in their own processes.
   *  The can be ignored unless you have a purpose and application for this information.
   *  The application of these indicators are for the merchant’s discretion and in isolation do not constitute any action to be taken by the merchant.
   * The field will contain a pipe delimited list of the following values if they are applicable e.g. HIGH_VALUE | FIRST_OZOW :
   *     • HIGH_VALUE – If a soft limit is configured on the site and the amount paid is higher or equal to the configured limit.
   *     • FIRST_OZOW – First time a user has paid using Ozow
   *     • FIRST_MERCHANT – First time a user has paid the merchant using Ozow
   *     • NEW_OZOW – User has paid using Ozow for the first time in the past seven days
   *     • NEW_MERCHANT - User has paid the merchant using Ozow for the first time in the past seven days
   */
  SmartIndicators: Scalars['String'];
  /**
   *  The transaction status. Possible values are:
   * • Complete - The payment was successful
   * • Cancelled - The payment was cancelled
   * • Error - An error occurred while processing the payment
   * • Abandoned – The payment was abandoned
   * • PendingInvestigation – An inconclusive result was received by the
   * bank and the payment needs to be verified manually.
   * • Pending – The status cannot be determined as yet but will be
   * reposted to the notification URL as soon as it has been determined.
   * Merchants not using the notification URL will receive a PendingInvestigation status.
   */
  Status: Scalars['String'];
  /**
   * Message regarding the status of the transaction.
   * This field will not always have a value.
   * This is a user friendly message that can be displayed to the user e.g. User cancelled transaction.
   */
  StatusMessage?: Maybe<Scalars['String']>;
  /**
   *  The transaction sub status for failed transactions. The value provides an indication as to why the payment failed.
   * Some examples:
   *     • Unclassified – Failure scenario has not been mapped.
   *     • InsufficientFunds - User did not have sufficient funds available to complete the payment.
   *     There a quite a few other sub statuses and they have not been included here as they are strictly for reporting.
   */
  SubStatus: Scalars['String'];
  /** The transaction identifier generated by Ozow */
  TransactionId: Scalars['String'];
  /** The merchant's transaction reference sent in the request post's TransactionReference variable. */
  TransactionReference: Scalars['String'];
};

export type OzowTransactionResponseDto = {
  __typename?: 'OzowTransactionResponseDto';
  /** The transaction amount. */
  amount: Scalars['Float'];
  /** The masked account number the payment was made from. */
  bankName?: Maybe<Scalars['String']>;
  /** Transaction created date and time */
  createdDate: Scalars['Date'];
  /** The transaction currency code. */
  currencyCode: Scalars['String'];
  /** The name of the bank the payment was made from. */
  maskedAccountNumber?: Maybe<Scalars['String']>;
  /** Unique code assigned to each merchant. */
  merchantCode: Scalars['String'];
  /** Transaction payment date and time */
  paymentDate: Scalars['Date'];
  /** Unique code assigned to each merchant site. */
  siteCode: Scalars['String'];
  /** Refer to SmartIndicators field in notification response */
  smartIndicators?: Maybe<Scalars['String']>;
  /**
   * The transaction status. Possible values are:
   *   • Complete - The payment was successful
   *   • Cancelled - The payment was cancelled
   *   • Error - An error occurred while processing the payment
   *   • Abandoned – The payment was abandoned
   *   • PendingInvestigation – An inconclusive result was received by the
   *   bank and the payment needs to be verified manually.
   *   • Pending – The status cannot be determined as yet but will be
   *   reposted to the notification URL as soon as it has been determined. Merchants not using the notification URL will receive a PendingInvestigation status.
   */
  status: Scalars['String'];
  /** Message regarding the status of the transaction. This field will not always have a value. This is a user friendly message that can be displayed to the user e.g. User cancelled transaction. */
  statusMessage: Scalars['String'];
  /** The transaction sub status for failed transactions. The value provides an indication as to why the payment failed. */
  subStatus?: Maybe<Scalars['String']>;
  /** Ozow's unique reference for the transaction. */
  transactionId: Scalars['String'];
  /** Merchant's transaction reference. */
  transactionReference: Scalars['String'];
};

export enum Psp {
  DukeWallet = 'duke_wallet',
  Ozow = 'ozow',
  Paystack = 'paystack',
  Tingg = 'tingg'
}

export type Pagination = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PastLeaderboardIntervals = {
  __typename?: 'PastLeaderboardIntervals';
  activity_id?: Maybe<Scalars['String']>;
  end_date_time?: Maybe<Scalars['String']>;
  recurrence_type?: Maybe<Scalars['String']>;
  recurrence_type_value?: Maybe<Scalars['Int']>;
  start_date_time?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type PayStackHistory = {
  __typename?: 'PayStackHistory';
  message: Scalars['String'];
  time: Scalars['Int'];
  type: Scalars['String'];
};

export type PayStackLog = {
  __typename?: 'PayStackLog';
  attempts: Scalars['Int'];
  authentication: Scalars['String'];
  authorization: PaystackLogAuthorisation;
  channel: Scalars['String'];
  customer: PaystackLogCustomer;
  errors: Scalars['String'];
  fees: Scalars['String'];
  history: PayStackHistory;
  input?: Maybe<Array<Maybe<Scalars['String']>>>;
  mobile: Scalars['Boolean'];
  plan: Scalars['String'];
  requested_amount: Scalars['Int'];
  success: Scalars['Boolean'];
  time_spent: Scalars['Int'];
};

export type Payment = {
  __typename?: 'Payment';
  amount?: Maybe<Scalars['Float']>;
  cart?: Maybe<Scalars['JSON']>;
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  network?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  paidAt?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  psp?: Maybe<Scalars['String']>;
  reasonForPayment?: Maybe<ReasonForPayment>;
  reference: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PaymentCurrencyDetails = {
  __typename?: 'PaymentCurrencyDetails';
  conversion_rate?: Maybe<Scalars['Int']>;
  converted_amount?: Maybe<Scalars['Int']>;
  converted_currency?: Maybe<Scalars['String']>;
};

export type PaymentFilter = {
  amount?: InputMaybe<NumberOperator>;
  createdAt?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  fullname?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  message?: InputMaybe<StringOperator>;
  network?: InputMaybe<StringOperator>;
  paidAt?: InputMaybe<DateOperator>;
  phone?: InputMaybe<StringOperator>;
  psp?: InputMaybe<StringOperator>;
  reference?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  updatedAt?: InputMaybe<DateOperator>;
};

export type PaymentInput = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  provider: Scalars['String'];
};

export enum PaymentOption {
  Cash = 'Cash',
  Online = 'Online'
}

export type PaymentOptions = {
  __typename?: 'PaymentOptions';
  currency_code?: Maybe<Scalars['String']>;
  instructions?: Maybe<Instructions>;
  maximum_charge_amount?: Maybe<Scalars['Int']>;
  minimum_charge_amount?: Maybe<Scalars['Int']>;
  payment_option_code?: Maybe<Scalars['String']>;
  payment_option_logo?: Maybe<Scalars['String']>;
  payment_option_name?: Maybe<Scalars['String']>;
};

export type PaymentProviderStatusResponseData = {
  __typename?: 'PaymentProviderStatusResponseData';
  page: PaymentProviderStatusResponsePage;
  status: PaymentProviderStatusResponseStatus;
};

export type PaymentProviderStatusResponsePage = {
  __typename?: 'PaymentProviderStatusResponsePage';
  id: Scalars['ID'];
  name: Scalars['String'];
  time_zone: Scalars['String'];
  updated_at: Scalars['String'];
  url: Scalars['String'];
};

export type PaymentProviderStatusResponseStatus = {
  __typename?: 'PaymentProviderStatusResponseStatus';
  description: Scalars['String'];
  indicator: Scalars['String'];
};

export enum PaymentStatus {
  Failed = 'failed',
  Initiated = 'initiated',
  Success = 'success',
  Unknown = 'unknown'
}

export type Payout = {
  __typename?: 'Payout';
  account_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  provider?: Maybe<Scalars['String']>;
  reseller?: Maybe<User>;
  status?: Maybe<Scalars['String']>;
  transaction_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};

export type PayoutFilter = {
  account_name?: InputMaybe<StringOperator>;
  account_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  provider?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  transaction_id?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type PayoutInput = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  amount: Scalars['Float'];
  country: Scalars['String'];
  currency: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  provider: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  supplier_id?: InputMaybe<Scalars['ID']>;
  transaction_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['ID']>;
};

export type PaysTackChargeBank = {
  /** Account number supplied by customer. */
  account_number?: InputMaybe<Scalars['String']>;
  /**
   * Code of the bank. To fetch the list of supported banks, call the paystack list banks operation with the additional filter pay_with_bank=true.
   *
   * The banks can be listed in a dropdown or any other format that allows the user to easily pick their bank of choice.
   */
  code: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  /** If the selected bank is Kuda, you need to make use of phone and token instead of account_number */
  token?: InputMaybe<Scalars['String']>;
};

export type PaysTackChargeEft = {
  provider: EftProviders;
};

export type PaysTackChargeMobileMoney = {
  phone: Scalars['String'];
  /** Allowed values 'mtn', 'tgo', 'vod', 'VOD', 'MTN','TGO', 'AIR' */
  provider: Scalars['String'];
};

export type PaysTackChargeQr = {
  provider: QrProviders;
};

export type PaysTackChargeUssd = {
  type: UssdTypes;
};

export type PaystackBankAccount = {
  __typename?: 'PaystackBankAccount';
  active: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  gateway?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  is_deleted: Scalars['Boolean'];
  longcode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pay_with_bank: Scalars['Boolean'];
  slug?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
};

export type PaystackBankInitialiseChargeRequestDto = {
  /** Amount should be in kobo if currency is NGN, pesewas, if currency is GHS, and cents, if currency is ZAR */
  amount: Scalars['Int'];
  /** Bank details */
  bank: PaysTackChargeBank;
  /** Date in the format YYYY-MM-DD. e.g "1995-12-23" */
  birthday: Scalars['String'];
  /** Customer's email address */
  email: Scalars['String'];
  /** A JSON object */
  metadata?: InputMaybe<PaystackCustomFields>;
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** Unique transaction reference. Only -, .`, = and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
};

export type PaystackBankInitialiseChargeResponseData = {
  __typename?: 'PaystackBankInitialiseChargeResponseData';
  display_text?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  status: Scalars['String'];
};

export type PaystackBankInitialiseChargeResponseDto = {
  __typename?: 'PaystackBankInitialiseChargeResponseDto';
  data: PaystackBankInitialiseChargeResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackBulkCreateTransferRecipientRequestDto = {
  /** A list of transfer recipient object */
  batch: Array<PaystackCreateTransferRecipientRequestDto>;
};

export type PaystackBulkCreateTransferRecipientResponseData = {
  __typename?: 'PaystackBulkCreateTransferRecipientResponseData';
  error?: Maybe<Array<Scalars['JSON']>>;
  success: Array<PaystackTransferRecipient>;
};

export type PaystackBulkCreateTransferRecipientResponseDto = {
  __typename?: 'PaystackBulkCreateTransferRecipientResponseDto';
  data: PaystackBulkCreateTransferRecipientResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackChargeSubmitOtpRequestDto = {
  /** OTP submitted by user */
  otp: Scalars['String'];
  /** Reference for ongoing transaction */
  reference: Scalars['String'];
};

export type PaystackCreateTransferRecipientDetails = {
  __typename?: 'PaystackCreateTransferRecipientDetails';
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  authorization_code?: Maybe<Scalars['String']>;
  bank_code: Scalars['String'];
  bank_name: Scalars['String'];
};

export type PaystackCreateTransferRecipientRequestDto = {
  /** Required if type is nuban or basa */
  account_number?: InputMaybe<Scalars['String']>;
  /** An authorization code from a previous transaction */
  authorization_code?: InputMaybe<Scalars['String']>;
  /** Required if type is nuban or basa. You can get the list of Bank Codes by calling the List Banks endpoint. */
  bank_code?: InputMaybe<Scalars['String']>;
  /** Currency for the account receiving the transfer */
  currency?: InputMaybe<Scalars['String']>;
  /** A description for this recipient */
  description?: InputMaybe<Scalars['String']>;
  /** Store additional information about your recipient in a structured format, JSON */
  metadata?: InputMaybe<Scalars['JSON']>;
  /** A name for the recipient */
  name: Scalars['String'];
  /** Recipient Type. It could be one of: nuban, mobile_money or basa */
  type: Scalars['String'];
};

export type PaystackCreateTransferRecipientResponseDto = {
  __typename?: 'PaystackCreateTransferRecipientResponseDto';
  data: PaystackTransferRecipient;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackCustomField = {
  display_name: Scalars['String'];
  value: Scalars['String'];
  variable_name: Scalars['String'];
};

export type PaystackCustomFields = {
  /** Stringified card object */
  cart?: InputMaybe<Cart>;
  custom_fields: Array<PaystackCustomField>;
  /** This is the name of the customer making the payment. */
  fullname: Scalars['String'];
  reasonForPayment: ReasonForPayment;
};

export type PaystackDeleteTransferRecipientRequestDto = {
  /** An ID or code for the recipient who you want to delete. */
  id_or_code: Scalars['ID'];
};

export type PaystackDeleteTransferRecipientResponseDto = {
  __typename?: 'PaystackDeleteTransferRecipientResponseDto';
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackEftInitialiseChargeRequestDto = {
  /** Amount should be in kobo if currency is NGN, pesewas, if currency is GHS, and cents, if currency is ZAR */
  amount: Scalars['Int'];
  /** The currency code */
  currency: Scalars['String'];
  /** EFT details */
  eft: PaysTackChargeEft;
  /** Customer's email address */
  email: Scalars['String'];
  /** A JSON object */
  metadata?: InputMaybe<PaystackCustomFields>;
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** Unique transaction reference. Only -, .`, = and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
};

export type PaystackEftInitialiseChargeResponseData = {
  __typename?: 'PaystackEFTInitialiseChargeResponseData';
  reference: Scalars['String'];
  status: Scalars['String'];
  url: Scalars['String'];
};

export type PaystackEftInitialiseChargeResponseDto = {
  __typename?: 'PaystackEFTInitialiseChargeResponseDto';
  data: PaystackEftInitialiseChargeResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackFetchTransferData = {
  __typename?: 'PaystackFetchTransferData';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  domain: Scalars['String'];
  failures?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  reason: Scalars['String'];
  recipient: PaystackTransferRecipient;
  source: Scalars['String'];
  source_details?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transfer_code: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PaystackFetchTransferRecipientRequestDto = {
  /** An ID or code for the recipient whose details you want to receive. */
  id_or_code: Scalars['ID'];
};

export type PaystackFetchTransferRecipientResponseDto = {
  __typename?: 'PaystackFetchTransferRecipientResponseDto';
  data: PaystackTransferRecipient;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackFetchTransferRequestDto = {
  /** The transfer ID or code you want to fetch */
  id_or_code: Scalars['ID'];
};

export type PaystackFetchTransferResponseDto = {
  __typename?: 'PaystackFetchTransferResponseDto';
  data: PaystackFetchTransferData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackFinaliseTransferData = {
  __typename?: 'PaystackFinaliseTransferData';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  domain: Scalars['String'];
  failures?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  integration: Scalars['Int'];
  reason: Scalars['String'];
  recipient: Scalars['Int'];
  reference: Scalars['String'];
  source: Scalars['String'];
  source_details?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  titan_code?: Maybe<Scalars['String']>;
  transfer_code: Scalars['String'];
  transferred_at?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PaystackFinaliseTransferRequestDto = {
  /** OTP sent to business phone to verify transfer */
  otp: Scalars['String'];
  /** The transfer code you want to finalize */
  transfer_code: Scalars['String'];
};

export type PaystackFinaliseTransferResponseDto = {
  __typename?: 'PaystackFinaliseTransferResponseDto';
  data: PaystackFinaliseTransferData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackInitiateBulkTransferRequestDto = {
  /** Where should we transfer from? Only `balance` for now */
  source?: InputMaybe<Scalars['String']>;
  transfers: Array<PaystackInitiateTransferObject>;
};

export type PaystackInitiateBulkTransferResponseDto = {
  __typename?: 'PaystackInitiateBulkTransferResponseDto';
  data: Array<PaystackInitiateTransferData>;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackInitiateTransferData = {
  __typename?: 'PaystackInitiateTransferData';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  domain: Scalars['String'];
  id: Scalars['Int'];
  integration: Scalars['String'];
  reason: Scalars['String'];
  recipient: Scalars['Int'];
  source: Scalars['String'];
  status: Scalars['String'];
  transfer_code: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PaystackInitiateTransferObject = {
  /** Amount to transfer in kobo if currency is NGN and pesewas if currency is GHS. */
  amount: Scalars['Int'];
  /** Specify the currency of the transfer. Defaults to NGN */
  currency?: InputMaybe<Scalars['String']>;
  /** The reason for the transfer */
  reason?: InputMaybe<Scalars['String']>;
  /** Code for transfer recipient */
  recipient: Scalars['String'];
  /** If specified, the field should be a unique identifier (in lowercase) for the object. Only -,_ and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
};

export type PaystackInitiateTransferRequestDto = {
  /** Amount to transfer in kobo if currency is NGN and pesewas if currency is GHS. */
  amount: Scalars['Int'];
  /** Specify the currency of the transfer. Defaults to NGN */
  currency?: InputMaybe<Scalars['String']>;
  /** The reason for the transfer */
  reason?: InputMaybe<Scalars['String']>;
  /** Code for transfer recipient */
  recipient: Scalars['String'];
  /** If specified, the field should be a unique identifier (in lowercase) for the object. Only -,_ and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
  /** Where should we transfer from? Only `balance` for now */
  source?: InputMaybe<Scalars['String']>;
};

export type PaystackInitiateTransferResponseDto = {
  __typename?: 'PaystackInitiateTransferResponseDto';
  data: PaystackInitiateTransferData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackListBanksMetadata = {
  __typename?: 'PaystackListBanksMetadata';
  next?: Maybe<Scalars['String']>;
  perPage?: Maybe<Scalars['Int']>;
  previous?: Maybe<Scalars['String']>;
};

export type PaystackListBanksRequestDto = {
  /** The country from which to obtain the list of supported banks. e.g country=ghana or country=nigeria */
  country: Scalars['String'];
  /** Any of NGN, USD, GHS or ZAR */
  currency?: InputMaybe<Scalars['String']>;
  /** The gateway type of the bank. It can be one of these: [emandate, digitalbankmandate] */
  gateway?: InputMaybe<Scalars['String']>;
  /** A cursor that indicates your place in the list. It can be used to fetch the next page of the list */
  next?: InputMaybe<Scalars['String']>;
  /** A flag to filter for available providers as boolean. e.g. false */
  pay_with_bank_transfer: Scalars['String'];
  /** The number of objects to return per page. Defaults to 50, and limited to 100 records per page. */
  perPage: Scalars['Int'];
  /** A cursor that indicates your place in the list. It should be used to fetch the previous page of the list after an intial next request */
  previous?: InputMaybe<Scalars['String']>;
  /** Type of financial channel. For Ghanaian channels, please use either mobile_money for mobile money channels OR ghipps for bank channels */
  type?: InputMaybe<Scalars['String']>;
  /** Flag to enable cursor pagination on the endpoint as boolean string. e.g. "false" */
  use_cursor: Scalars['String'];
};

export type PaystackListBanksResponseDto = {
  __typename?: 'PaystackListBanksResponseDto';
  data?: Maybe<Array<Maybe<PaystackBankAccount>>>;
  message: Scalars['String'];
  meta?: Maybe<PaystackListBanksMetadata>;
  status: Scalars['Boolean'];
};

export type PaystackListTransferRecipientsRequestDto = {
  /** A timestamp from which to start listing transfer recipients e.g. 2016-09-24T00:00:05.000Z, 2016-09-21 */
  from?: InputMaybe<Scalars['String']>;
  /** Specify exactly what page you want to retrieve. If not specified we use a default value of 1. */
  page?: InputMaybe<Scalars['Int']>;
  /** Specify how many records you want to retrieve per page. If not specify we use a default value of 50. */
  perPage?: InputMaybe<Scalars['Int']>;
  /** A timestamp at which to stop listing transfer recipients e.g. 2016-09-24T00:00:05.000Z, 2016-09-21 */
  to?: InputMaybe<Scalars['String']>;
};

export type PaystackListTransferRecipientsResponseDto = {
  __typename?: 'PaystackListTransferRecipientsResponseDto';
  data: Array<Maybe<PaystackTransferRecipient>>;
  message: Scalars['String'];
  meta: PaystackPagination;
  status: Scalars['Boolean'];
};

export type PaystackListTransfersData = {
  __typename?: 'PaystackListTransfersData';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  domain: Scalars['String'];
  failures?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  integration: Scalars['Int'];
  reason: Scalars['String'];
  recipient: PaystackTransferRecipient;
  source: Scalars['String'];
  source_details?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  transfer_code: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PaystackListTransfersRequestDto = {
  /** Filter by customer ID */
  customer: Scalars['String'];
  /** A timestamp from which to start listing transfer e.g. 2016-09-24T00:00:05.000Z, 2016-09-21 */
  from?: InputMaybe<Scalars['String']>;
  /** Specify exactly what transfer you want to page. If not specify we use a default value of 1. */
  page?: InputMaybe<Scalars['Int']>;
  /** Specify how many records you want to retrieve per page. If not specify we use a default value of 50. */
  perPage?: InputMaybe<Scalars['Int']>;
  /** A timestamp at which to stop listing transfer e.g. 2016-09-24T00:00:05.000Z, 2016-09-21 */
  to?: InputMaybe<Scalars['String']>;
};

export type PaystackListTransfersResponseDto = {
  __typename?: 'PaystackListTransfersResponseDto';
  data: Array<Maybe<PaystackListTransfersData>>;
  message: Scalars['String'];
  meta: PaystackPagination;
  status: Scalars['Boolean'];
};

export type PaystackLogAuthorisation = {
  __typename?: 'PaystackLogAuthorisation';
  account_name: Scalars['String'];
  authorization_code: Scalars['String'];
  bank: Scalars['String'];
  bin: Scalars['Int'];
  card_type: Scalars['String'];
  channel: Scalars['String'];
  country_code: Scalars['String'];
  exp_month: Scalars['Int'];
  exp_year: Scalars['Int'];
  last4: Scalars['Int'];
  reusable: Scalars['Boolean'];
  signature: Scalars['String'];
};

export type PaystackLogCustomer = {
  __typename?: 'PaystackLogCustomer';
  customer_code: Scalars['String'];
  email: Scalars['String'];
  first_name: Scalars['String'];
  id: Scalars['ID'];
  last_name: Scalars['String'];
};

export type PaystackMobileMoneyInitialiseChargeRequestDto = {
  /** Amount should be in kobo if currency is NGN, pesewas, if currency is GHS, and cents, if currency is ZAR */
  amount: Scalars['Int'];
  /** Currency code */
  currency: Scalars['String'];
  /** Customer's email address */
  email: Scalars['String'];
  /** A JSON object */
  metadata?: InputMaybe<PaystackCustomFields>;
  /** Mobile details (don't send if charging an authorization code, bank or card) */
  mobile_money: PaysTackChargeMobileMoney;
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** Unique transaction reference. Only -, .`, = and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
};

export type PaystackMobileMoneyInitialiseChargeResponseData = {
  __typename?: 'PaystackMobileMoneyInitialiseChargeResponseData';
  display_text?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  status: Scalars['String'];
};

export type PaystackMobileMoneyInitialiseChargeResponseDto = {
  __typename?: 'PaystackMobileMoneyInitialiseChargeResponseDto';
  data: PaystackMobileMoneyInitialiseChargeResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackMobileMoneyResponseData = {
  __typename?: 'PaystackMobileMoneyResponseData';
  amount: Scalars['Int'];
  channel: Scalars['String'];
  currency: Scalars['String'];
  domain: Scalars['String'];
  gateway_response: Scalars['String'];
  ip_address: Scalars['String'];
  log?: Maybe<PayStackLog>;
  message?: Maybe<Scalars['String']>;
  metadata: Scalars['JSONObject'];
  reference: Scalars['String'];
  status: Scalars['String'];
  transaction_date: Scalars['String'];
};

export type PaystackMobileMoneyResponseDto = {
  __typename?: 'PaystackMobileMoneyResponseDto';
  data: PaystackMobileMoneyResponseData;
  message?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type PaystackPagination = {
  __typename?: 'PaystackPagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  perPage: Scalars['Int'];
  skipped: Scalars['Int'];
  total: Scalars['Int'];
};

export enum PaystackPaymentChannels {
  Bank = 'bank',
  BankTransfer = 'bank_transfer',
  Card = 'card',
  Eft = 'eft',
  MobileMoney = 'mobile_money',
  Qr = 'qr',
  Ussd = 'ussd'
}

export type PaystackQrInitialiseChargeRequestDto = {
  /** Amount should be in kobo if currency is NGN, pesewas, if currency is GHS, and cents, if currency is ZAR */
  amount: Scalars['Int'];
  /** The currency code */
  currency: Scalars['String'];
  /** Customer's email address */
  email: Scalars['String'];
  /** A JSON object */
  metadata?: InputMaybe<PaystackCustomFields>;
  /** QR details */
  qr: PaysTackChargeQr;
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** Unique transaction reference. Only -, .`, = and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
};

export type PaystackQrInitialiseChargeResponseData = {
  __typename?: 'PaystackQRInitialiseChargeResponseData';
  qr_code: Scalars['String'];
  reference: Scalars['String'];
  status: Scalars['String'];
  url: Scalars['String'];
};

export type PaystackQrInitialiseChargeResponseDto = {
  __typename?: 'PaystackQRInitialiseChargeResponseDto';
  data: PaystackQrInitialiseChargeResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackResolveAccountData = {
  __typename?: 'PaystackResolveAccountData';
  account_name: Scalars['String'];
  account_number: Scalars['String'];
};

export type PaystackResolveAccountNumberRequestDto = {
  /** Account Number */
  account_number: Scalars['String'];
  /** You can get the list of bank codes by calling the List Bank endpoint */
  bank_code: Scalars['String'];
};

export type PaystackResolveAccountNumberResponseDto = {
  __typename?: 'PaystackResolveAccountNumberResponseDto';
  data: PaystackResolveAccountData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackResolveCardBinData = {
  __typename?: 'PaystackResolveCardBINData';
  bank: Scalars['String'];
  bin: Scalars['String'];
  brand: Scalars['String'];
  card_type: Scalars['String'];
  country_code: Scalars['String'];
  country_name: Scalars['String'];
  linked_bank_id: Scalars['String'];
  sub_brand: Scalars['String'];
};

export type PaystackResolveCardBinRequestDto = {
  /** First 6 characters of card */
  bin: Scalars['String'];
};

export type PaystackResolveCardBinResponseDto = {
  __typename?: 'PaystackResolveCardBINResponseDto';
  data: PaystackResolveCardBinData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export enum PaystackTransactionBearer {
  Account = 'account',
  Subaccount = 'subaccount'
}

export type PaystackTransactionInitialiseRequestDto = {
  /** Amount should be in kobo if currency is NGN, pesewas, if currency is GHS, and cents, if currency is ZAR */
  amount: Scalars['Int'];
  /** Who bears Paystack charges? account or subaccount (defaults to account). */
  bearer?: InputMaybe<PaystackTransactionBearer>;
  /** Fully qualified url, e.g. https://example.com/ . Use this to override the callback url provided on the dashboard for this transaction */
  callback_url?: InputMaybe<Scalars['String']>;
  /** An array of payment channels to control what channels you want to make available to the user to make a payment with. Available channels include: ["card", "bank", "ussd", "qr", "mobile_money", "bank_transfer", "eft"] */
  channels?: InputMaybe<Array<InputMaybe<PaystackPaymentChannels>>>;
  /** The transaction currency (NGN, GHS, ZAR or USD). Defaults to your integration currency. */
  currency?: InputMaybe<Scalars['String']>;
  /** Customer's email address */
  email: Scalars['String'];
  /** Number of times to charge customer during subscription to plan */
  invoice_limit?: InputMaybe<Scalars['Int']>;
  /** Stringified JSON object of custom data. Kindly check the Paystack Metadata input for more information. */
  metadata?: InputMaybe<PaystackCustomFields>;
  /** If transaction is to create a subscription to a predefined plan, provide plan code here. This would invalidate the value provided in amount */
  plan?: InputMaybe<Scalars['String']>;
  reasonForPayment: ReasonForPayment;
  /** Unique transaction reference. Only -, ., = and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
  /** The split code of the transaction split. e.g. SPL_98WF13Eb3w */
  split_code?: InputMaybe<Scalars['String']>;
  /** The code for the subaccount that owns the payment. e.g. ACCT_8f4s1eq7ml6rlzj */
  subaccount?: InputMaybe<Scalars['String']>;
  /** An amount used to override the split configuration for a single split payment. If set, the amount specified goes to the main account regardless of the split configuration. */
  transaction_charge?: InputMaybe<Scalars['Int']>;
};

export type PaystackTransactionInitialiseResponseData = {
  __typename?: 'PaystackTransactionInitialiseResponseData';
  access_code: Scalars['String'];
  authorization_url: Scalars['String'];
  reference: Scalars['String'];
};

export type PaystackTransactionInitialiseResponseDto = {
  __typename?: 'PaystackTransactionInitialiseResponseDto';
  data: PaystackTransactionInitialiseResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackTransferRecipient = {
  __typename?: 'PaystackTransferRecipient';
  active: Scalars['Boolean'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  details: PaystackCreateTransferRecipientDetails;
  domain: Scalars['String'];
  id: Scalars['Int'];
  integration: Scalars['Int'];
  is_deleted: Scalars['Boolean'];
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  recipient_code: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type PaystackUssdInitialiseChargeRequestDto = {
  /** Amount should be in kobo if currency is NGN, pesewas, if currency is GHS, and cents, if currency is ZAR */
  amount: Scalars['Int'];
  /** Customer's email address */
  email: Scalars['String'];
  /** A JSON object */
  metadata?: InputMaybe<PaystackCustomFields>;
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
  /** Unique transaction reference. Only -, .`, = and alphanumeric characters allowed. */
  reference?: InputMaybe<Scalars['String']>;
  /** USSD details */
  ussd: PaysTackChargeUssd;
};

export type PaystackUssdInitialiseChargeResponseData = {
  __typename?: 'PaystackUSSDInitialiseChargeResponseData';
  display_text?: Maybe<Scalars['String']>;
  reference: Scalars['String'];
  status: Scalars['String'];
  ussd_code: Scalars['String'];
};

export type PaystackUssdInitialiseChargeResponseDto = {
  __typename?: 'PaystackUSSDInitialiseChargeResponseDto';
  data: PaystackUssdInitialiseChargeResponseData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackUpdateTransferRecipientRequestDto = {
  /** Email address of the recipient */
  email?: InputMaybe<Scalars['String']>;
  /** Transfer Recipient's ID or code */
  id_or_code: Scalars['ID'];
  /** A name for the recipient */
  name: Scalars['String'];
};

export type PaystackUpdateTransferRecipientResponseDto = {
  __typename?: 'PaystackUpdateTransferRecipientResponseDto';
  data: PaystackTransferRecipient;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackValidateAccountData = {
  __typename?: 'PaystackValidateAccountData';
  verificationMessage: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type PaystackValidateAccountRequestDto = {
  /** Customer's first and last name registered with their bank */
  account_name: Scalars['String'];
  /** Customer’s account number */
  account_number: Scalars['String'];
  /** This can take one of: [ personal, business ] */
  account_type: Scalars['String'];
  /** The bank code of the customer’s bank. You can fetch the bank codes by using our List Bank endpoint */
  bank_code: Scalars['String'];
  /** The two digit ISO code of the customer’s bank. e.g GH */
  country_code: Scalars['String'];
  /** ID number for specified custmer's mode of identity */
  document_number: Scalars['String'];
  /** Customer’s mode of identity. This could be one of: [ identityNumber, passportNumber, businessRegistrationNumber ] */
  document_type: Scalars['String'];
};

export type PaystackValidateAccountResponseDto = {
  __typename?: 'PaystackValidateAccountResponseDto';
  data: PaystackValidateAccountData;
  message: Scalars['String'];
  status: Scalars['Boolean'];
};

export type PaystackVerifyTransferData = {
  __typename?: 'PaystackVerifyTransferData';
  amount: Scalars['Int'];
  createdAt: Scalars['String'];
  currency: Scalars['String'];
  domain: Scalars['String'];
  failures?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  integration: Scalars['Int'];
  reason: Scalars['String'];
  recipient: PaystackTransferRecipient;
  reference: Scalars['String'];
  source: Scalars['String'];
  source_details?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  titan_code?: Maybe<Scalars['String']>;
  transfer_code: Scalars['String'];
  transferred_at?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
};

export type PaystackVerifyTransferRequestDto = {
  /** Transfer reference */
  reference: Scalars['String'];
};

export type PaystackVerifyTransferResponseDto = {
  __typename?: 'PaystackVerifyTransferResponseDto';
  data: PaystackVerifyTransferData;
  message?: Maybe<Scalars['String']>;
  status: Scalars['Boolean'];
};

export type PhoneVerificationOutPut = {
  __typename?: 'PhoneVerificationOutPut';
  code?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type PickUpInput = {
  google_location: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  latitude: Scalars['String'];
  location: Scalars['String'];
  longitude: Scalars['String'];
  remarks?: InputMaybe<Scalars['String']>;
};

export type Pickup = {
  __typename?: 'Pickup';
  country?: Maybe<Scalars['String']>;
  google_location?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  latitude?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
};

export type Plugin = {
  __typename?: 'Plugin';
  banner_image?: Maybe<Scalars['String']>;
  category: Scalars['String'];
  created_at?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  developer?: Maybe<Scalars['String']>;
  endpoint: Scalars['String'];
  id: Scalars['ID'];
  logo: Scalars['String'];
  name: Scalars['String'];
  updated_at?: Maybe<Scalars['Date']>;
  verified: Scalars['Boolean'];
};

export type PluginFilter = {
  banner_image?: InputMaybe<StringOperator>;
  category?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  description?: InputMaybe<StringOperator>;
  developer?: InputMaybe<StringOperator>;
  endpoint?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  logo?: InputMaybe<StringOperator>;
  name?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type Product = {
  __typename?: 'Product';
  attended_to?: Maybe<Scalars['Boolean']>;
  avatar: Scalars['String'];
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  combination_string?: Maybe<Scalars['String']>;
  combinations?: Maybe<Array<Maybe<ProductCombination>>>;
  comments?: Maybe<Array<Maybe<ProductComment>>>;
  cost_price: Scalars['Float'];
  country?: Maybe<CountryCode>;
  created_at?: Maybe<Scalars['Date']>;
  currency?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  discount?: Maybe<Discount>;
  distributionChannels?: Maybe<Array<Maybe<Scalars['String']>>>;
  extra_information?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  inhouse?: Maybe<Scalars['Boolean']>;
  likesCount?: Maybe<Scalars['Float']>;
  limited_stock?: Maybe<Scalars['Boolean']>;
  main_stock?: Maybe<Scalars['Int']>;
  media?: Maybe<Array<Maybe<ProductAvatar>>>;
  minimumOrderQuantity?: Maybe<Scalars['Int']>;
  overalReview: Scalars['Float'];
  price: Scalars['Float'];
  profit_added?: Maybe<Scalars['Float']>;
  published: Scalars['Boolean'];
  qty?: Maybe<Scalars['Int']>;
  resell: Scalars['Boolean'];
  reviewBreakDown: ReviewBreakDown;
  reviews?: Maybe<Array<Review>>;
  savesCount?: Maybe<Scalars['Float']>;
  sharesCount?: Maybe<Scalars['Float']>;
  shop_id?: Maybe<Scalars['ID']>;
  sku: Scalars['String'];
  supplier?: Maybe<Supplier>;
  supplier_id?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  transit_stock?: Maybe<Scalars['Int']>;
  uuid?: Maybe<Scalars['String']>;
  variations?: Maybe<Array<Maybe<Variation>>>;
  verified?: Maybe<Scalars['Boolean']>;
  weight?: Maybe<Scalars['Float']>;
};

export type ProductAvatar = {
  __typename?: 'ProductAvatar';
  avatar?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  product_id?: Maybe<Scalars['ID']>;
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  avatar?: Maybe<Scalars['String']>;
  children?: Maybe<Array<Maybe<ProductCategory>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isActive?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  parent?: Maybe<Scalars['ID']>;
};

export type ProductCategoryAndTagsInput = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  product_id: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type ProductCategoryFilter = {
  country?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  parent?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']>;
  shop_id?: InputMaybe<IdOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type ProductCategoryInput = {
  avatar?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  parent?: InputMaybe<Scalars['ID']>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  collection?: Maybe<Catalog>;
  id?: Maybe<Scalars['ID']>;
  product?: Maybe<Product>;
};

export type ProductCombination = {
  __typename?: 'ProductCombination';
  available_stock: Scalars['Int'];
  combination_string: Scalars['String'];
  id?: Maybe<Scalars['ID']>;
  price: Scalars['Float'];
  sku: Scalars['String'];
};

export type ProductCombinationFilter = {
  available_stock?: InputMaybe<NumberOperator>;
  combination_string?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  price?: InputMaybe<MoneyOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type ProductCombinationInput = {
  avatar: Scalars['String'];
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  combination_string: Scalars['String'];
  cost_price: Scalars['Float'];
  id?: InputMaybe<Scalars['ID']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  price: Scalars['Float'];
  qty: Scalars['Int'];
  sku: Scalars['String'];
};

export type ProductComment = {
  __typename?: 'ProductComment';
  created_at?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  staff_number?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export enum ProductCondition {
  In = 'IN',
  NotIn = 'NOT_IN'
}

export enum ProductDistinctField {
  AttendedTo = 'attended_to',
  Avatar = 'avatar',
  CombinationString = 'combination_string',
  CostPrice = 'cost_price',
  Country = 'country',
  Currency = 'currency',
  Description = 'description',
  Id = 'id',
  Inhouse = 'inhouse',
  LimitedStock = 'limited_stock',
  Price = 'price',
  Published = 'published',
  Qty = 'qty',
  ShopId = 'shop_id',
  Sku = 'sku',
  Title = 'title',
  Uuid = 'uuid',
  Verified = 'verified',
  Weight = 'weight'
}

export type ProductInformationInput = {
  cost_price?: InputMaybe<Scalars['Float']>;
  country?: InputMaybe<CountryCode>;
  currency?: InputMaybe<CurrencyCode>;
  description?: InputMaybe<Scalars['String']>;
  extra_information?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  product_id: Scalars['ID'];
  sku: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type ProductInventoryInput = {
  limited_stock?: InputMaybe<Scalars['Boolean']>;
  product_id: Scalars['ID'];
  qty?: InputMaybe<Scalars['Int']>;
};

export type ProductMediaInput = {
  avatar?: InputMaybe<Scalars['String']>;
  media?: InputMaybe<Array<Scalars['String']>>;
  product_id: Scalars['ID'];
};

export enum ProductOrigin {
  InHouse = 'IN_HOUSE',
  Shopify = 'SHOPIFY'
}

export enum ProductPolicy {
  Resell = 'RESELL',
  Supplier = 'SUPPLIER'
}

export type ProductRequest = {
  __typename?: 'ProductRequest';
  id: Scalars['ID'];
  product?: Maybe<Product>;
  qty?: Maybe<Scalars['Int']>;
  shop_id?: Maybe<Scalars['ID']>;
  status?: Maybe<ProductRequestStatus>;
};

export enum ProductRequestStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type ProductShipment = {
  __typename?: 'ProductShipment';
  id: Scalars['ID'];
  items?: Maybe<Array<Maybe<ShipmentItem>>>;
  shipmentCode?: Maybe<Scalars['String']>;
  shipmentDescription?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ProductShipmentFilter = {
  id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
};

export type ProductShipmentInput = {
  id?: InputMaybe<Scalars['ID']>;
  items?: InputMaybe<Array<InputMaybe<ShipmentItemItem>>>;
  shipmentCode?: InputMaybe<Scalars['String']>;
  shipmentDescription?: InputMaybe<Scalars['String']>;
};

export enum ProductStat {
  Likes = 'LIKES',
  Saves = 'SAVES'
}

export enum ProductStatEditType {
  Decrement = 'DECREMENT',
  Increment = 'INCREMENT'
}

export type ProductStockInput = {
  id: Scalars['ID'];
  price?: InputMaybe<Scalars['Float']>;
  qty: Scalars['Int'];
};

export type ProductsStats = {
  __typename?: 'ProductsStats';
  total_in_stock: Scalars['Int'];
  total_in_transit: Scalars['Int'];
  total_out_stock: Scalars['Int'];
  total_unique_products: Scalars['Int'];
};

export type ProfitRevenueStats = {
  __typename?: 'ProfitRevenueStats';
  allTimeRevenue?: Maybe<Scalars['Float']>;
  dayRevenue?: Maybe<Scalars['Float']>;
  monthRevenue?: Maybe<Scalars['Float']>;
  weekRevenue?: Maybe<Scalars['Float']>;
  yearRevenue?: Maybe<Scalars['Float']>;
};

export enum ProfitType {
  Amount = 'amount',
  Percent = 'percent'
}

export type PromoBanner = {
  __typename?: 'PromoBanner';
  active: Scalars['Boolean'];
  country: Scalars['String'];
  id: Scalars['ID'];
  screen: Scalars['String'];
  url: Scalars['String'];
};

export type PromoBannerFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export type PromoBannerInput = {
  active: Scalars['Boolean'];
  country: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  screen: Scalars['String'];
  url: Scalars['String'];
};

export enum QrProviders {
  /** Availability: Nigeria */
  Masterpass = 'masterpass',
  /** Availability: South Africa */
  Visa = 'visa'
}

export type Query = {
  __typename?: 'Query';
  appBanner?: Maybe<AppBanner>;
  appBanners?: Maybe<Array<AppBanner>>;
  bobGetCourierRates?: Maybe<BobGetCourierRatesResponseDto>;
  /** Get order fulfillments */
  bobGetOrderFulfillments?: Maybe<BobGetOrderFulfillmentsResponseDto>;
  bobGetOrders?: Maybe<BobGetOrdersResponseDto>;
  bobGetRateRequests?: Maybe<BobGetRateRequestsResponseDto>;
  /** Get rates at checkout */
  bobGetRatesAtCheckout?: Maybe<BobGetRatesAtCheckoutResponseDto>;
  bobGetShipmentWaybill?: Maybe<BobShipmentWaybill>;
  bobGetShipments?: Maybe<BobGetShipmentsResponseDto>;
  bobGetTrackingEvents?: Maybe<Array<Maybe<BobTrackingEvent>>>;
  /** Submit OTP to complete a charge */
  chargeSubmitOTP: PaystackMobileMoneyResponseDto;
  deliveryLocation?: Maybe<Delivery>;
  deliveryLocations?: Maybe<Array<Maybe<Delivery>>>;
  deliveryLocationsLength: Scalars['Int'];
  doesShopDomainExist: SokoWorldDomainExistsResponseDto;
  doesShopExist: DoesShopExistResponseDto;
  featuredCategories?: Maybe<Array<FeaturedCategories>>;
  findDeliveryZone?: Maybe<DeliveryZone>;
  /** This payment method allows you to recieve GHS payments via Mobile Money: flutterwave. */
  flutterwaveCharge: FlutterwaveMobileMoneyInitialiseChargeResponseDto;
  /** This endpoint allows you to carry out background checks on users before you onboard them or grant them access to your applications. */
  flutterwaveCheckUserBackground: FlutterwaveCheckUserBackgroundResponseDto;
  /** This section describes how to get bank branch details for the specified Bank. */
  flutterwaveListBankBranches: FlutterwaveListBankBranchesResponseDto;
  /** This section describes how to get bank details for all Banks in the specified Country. This API returns all the Banks information in a country. To get Bank Branch information, please make use of the /branches endpoint. */
  flutterwaveListBanks: FlutterwaveListBanksResponseDto;
  /** This endpoint helps you to resolve the details of a bank account from an account number. Please note that only Nigerian bank details can be resolved using this endpoint. You can also resolve MPesa details and Flutterwave account details with this endpoint. */
  flutterwaveResolveAccountNumber: FlutterwaveResolveAccountNumberResponseDto;
  /** Bank Verification Number or BVN is a biometric identification widely used by Banks in Nigeria. This endpoint allows you to fetch a user's information from their BVN. It supports only BVNs generated by Nigerian Banks. */
  flutterwaveResolveBVNDetails: FlutterwaveResolveBvnDetailsResponseDto;
  /** This endpoint will help you to resolve issuer information from the card bins on Flutterwave. Card Bins (or Bank Identification Numbers) are usually the first six digits of a card number. */
  flutterwaveResolveCardBIN: FlutterwaveResolveCardBinResponseDto;
  /** Confirm the status of a flutterwave transaction */
  flutterwaveVerifyTransaction: FlutterwaveVerifyTransactionResponseDto;
  getAllDelayedProfitPayoutDeliveredOrders?: Maybe<Array<Maybe<DeliveredOrders>>>;
  getAllTimeActiveUsers?: Maybe<Scalars['Any']>;
  getCampaign?: Maybe<Campaign>;
  getCampaigns?: Maybe<Array<Maybe<Campaign>>>;
  getCart?: Maybe<Order>;
  getCarts?: Maybe<Array<Maybe<Order>>>;
  getCartsLength: Scalars['Int'];
  getCatalog: Catalog;
  getCatalogs?: Maybe<Array<Maybe<Catalog>>>;
  getCatalogsLength: Scalars['Int'];
  getCategoryMedia: Array<Maybe<ProductAvatar>>;
  getCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  getCoupon?: Maybe<Coupon>;
  getCoupons?: Maybe<Array<Coupon>>;
  getCouponsLength: Scalars['Int'];
  getCurentForexRate?: Maybe<ForexRate>;
  getCustomer?: Maybe<Customer>;
  getCustomerSubscription?: Maybe<CustomerSubscription>;
  getCustomerSubscriptions?: Maybe<Array<Maybe<CustomerSubscription>>>;
  getCustomers?: Maybe<Array<Maybe<Customer>>>;
  getCustomersLength: Scalars['Int'];
  getDailyActiveUsers?: Maybe<Scalars['Any']>;
  getDailyOrdersSummary?: Maybe<Scalars['Any']>;
  getDelayedProfitPayouts?: Maybe<Array<Maybe<OrderItem>>>;
  getDelayedProfitPayoutsLength: Scalars['Int'];
  getDeliveredOrders?: Maybe<Array<Maybe<DeliveredOrders>>>;
  getDeliveryPrices?: Maybe<Array<AutogeneratedMainType>>;
  getDeliveryZone?: Maybe<DeliveryZone>;
  getDeliveryZones?: Maybe<Array<DeliveryZone>>;
  getDeliveryZonesLength: Scalars['Int'];
  getDiscount?: Maybe<Discount>;
  getDiscountProductCondition?: Maybe<DiscountProductCondition>;
  getDiscountProductConditions?: Maybe<Array<Maybe<DiscountProductCondition>>>;
  getDiscounts?: Maybe<Array<Maybe<Discount>>>;
  getExpiredCustomerSubscriptions?: Maybe<Array<Maybe<CustomerSubscription>>>;
  getForexRates?: Maybe<Array<ForexRate>>;
  getInAppCart?: Maybe<Array<Maybe<CartItem>>>;
  getMainCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getMonthlyActiveUsers?: Maybe<Scalars['Any']>;
  getNineMonthsActiveUsers?: Maybe<Scalars['Any']>;
  getNumberOfTimesDiscountWasUsed?: Maybe<Scalars['Int']>;
  getOrder?: Maybe<OrderItem>;
  getOrderStatusesStats?: Maybe<OrderStatsStats>;
  getOrders?: Maybe<Array<Maybe<OrderItem>>>;
  getOrdersLength: Scalars['Int'];
  getPayment?: Maybe<Payment>;
  /** Get a single payment record by id */
  getPaymentById: GetPaymentResponseDto;
  /** Get a payment record by the reference used to initialise the payment */
  getPaymentByReference: GetPaymentResponseDto;
  /** Get a list of payment records */
  getPayments?: Maybe<Array<Payment>>;
  getPaymentsLength: Scalars['Int'];
  getPayoutRequests?: Maybe<Array<Maybe<Payout>>>;
  getPayoutRequestsLength?: Maybe<Scalars['Int']>;
  getPickUpLocation?: Maybe<Pickup>;
  getPickUpLocations?: Maybe<Array<Pickup>>;
  getPickUpLocationsLength: Scalars['Int'];
  getPlugin?: Maybe<Plugin>;
  getPlugins?: Maybe<Array<Maybe<Plugin>>>;
  getProduct?: Maybe<Product>;
  getProductAssignedCategories?: Maybe<Array<ProductCategory>>;
  getProductCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getProductCategoriesLength: Scalars['Int'];
  getProductCategory?: Maybe<ProductCategory>;
  getProductCombination: Scalars['Int'];
  getProductCombinations?: Maybe<Array<Maybe<ProductCombination>>>;
  getProductCombinationsLength: Scalars['Int'];
  getProductDiscount?: Maybe<Discount>;
  getProductMargins?: Maybe<Scalars['Any']>;
  getProductRequests?: Maybe<Array<Maybe<ProductRequest>>>;
  getProducts?: Maybe<Array<Maybe<Product>>>;
  getProductsLength?: Maybe<Scalars['Int']>;
  getProductsLikedByUser: Array<Maybe<Product>>;
  getProductsMetrics?: Maybe<ProductsStats>;
  getProductsSavedByUser: Array<Maybe<Product>>;
  getProductsSharedByUser: Array<Maybe<SharedProduct>>;
  getProductsShipments?: Maybe<Array<Maybe<ProductShipment>>>;
  getPromoBanner?: Maybe<PromoBanner>;
  getPromoBanners?: Maybe<Array<Maybe<PromoBanner>>>;
  getPromoBannersLength: Scalars['Int'];
  getRandomProducts?: Maybe<Array<Maybe<Product>>>;
  getRehookLeaderboard?: Maybe<RehookLeaderboard>;
  getResellerWalletSummary?: Maybe<WalletSumary>;
  getRevenueFromProfit?: Maybe<ProfitRevenueStats>;
  getReview: Review;
  getReviews?: Maybe<Array<Maybe<Review>>>;
  getReviewsLength: Scalars['Int'];
  getSales?: Maybe<Array<Maybe<Sales>>>;
  getSelfCheckoutCustomer?: Maybe<Customer>;
  getSelfCheckoutLink?: Maybe<Scalars['String']>;
  getSharedProduct: SharedProduct;
  getSharedProducts?: Maybe<Array<Maybe<SharedProduct>>>;
  getShop?: Maybe<Shop>;
  getShopCollection?: Maybe<ShopCollection>;
  getShopCollectionProducts?: Maybe<Array<Maybe<Product>>>;
  getShopCollections?: Maybe<Array<ShopCollection>>;
  getShopCollectionsLength: Scalars['Int'];
  getShopifyShop?: Maybe<ShopifyShop>;
  getShopifyShops?: Maybe<Array<Maybe<ShopifyShop>>>;
  getShops?: Maybe<Array<Shop>>;
  getShopsLength: Scalars['Int'];
  getSixMonthsActiveUsers?: Maybe<Scalars['Any']>;
  getSubCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  getSubscriptionPackage?: Maybe<SubscriptionPackage>;
  getSubscriptionPackages?: Maybe<Array<Maybe<SubscriptionPackage>>>;
  getSubscriptionPayment?: Maybe<SubscriptionPaymentHistory>;
  getSubscriptionPayments?: Maybe<Array<Maybe<SubscriptionPaymentHistory>>>;
  getSupplier?: Maybe<Supplier>;
  getSupplierBusinessPickupLocations?: Maybe<Array<Maybe<SupplierLocation>>>;
  getSupplierDailyOrdersSummary?: Maybe<Scalars['Any']>;
  getSupplierPickupLocation?: Maybe<SupplierLocation>;
  getSupplierWalletSummary?: Maybe<WalletSumary>;
  getSuppliers?: Maybe<Array<Supplier>>;
  getSuppliersLength: Scalars['Int'];
  getTerm?: Maybe<Terms>;
  getTerms?: Maybe<Array<Terms>>;
  getTermsLength: Scalars['Int'];
  getThreeMonthsActiveUsers?: Maybe<Scalars['Any']>;
  /** This section would return the payment methods for Tingg */
  getTinggPaymentMethods?: Maybe<Array<Maybe<TinggQueryStatusResponsePaymentOptions>>>;
  getTopProducts: TopProductsResponseDto;
  getTopResellersForTheWeek?: Maybe<Array<Maybe<TopReseller>>>;
  getUnverifiedProducts?: Maybe<Array<Maybe<Product>>>;
  getUser?: Maybe<User>;
  getUserCoupons?: Maybe<Array<CouponRedemption>>;
  getUserCouponsLength: Scalars['Int'];
  getUserDelayedOrders?: Maybe<Array<Maybe<OrderItem>>>;
  getUserPaymentDetails?: Maybe<Array<UserPayment>>;
  getUserPlugins?: Maybe<Array<Maybe<UserPlugin>>>;
  getUserReferralsMetrics?: Maybe<UserReferralMetrics>;
  getUsers?: Maybe<Array<Maybe<User>>>;
  getUsersLength: Scalars['Int'];
  getVariation: Scalars['Int'];
  getVariations?: Maybe<Array<Maybe<Variation>>>;
  getVariationsLength: Scalars['Int'];
  getWalletCashRewardsHistory?: Maybe<Array<Maybe<CashRewardHistory>>>;
  getWalletHistory?: Maybe<WalletHistory>;
  getWalletTopupPayments?: Maybe<Array<Maybe<WalletTopupPayment>>>;
  getWeeklyActiveUsers?: Maybe<Scalars['Any']>;
  getWeeklyActiveUsersGraph?: Maybe<Scalars['Any']>;
  getYearActiveUsers?: Maybe<Scalars['Any']>;
  getYesterDayActiveUser?: Maybe<Scalars['Any']>;
  isProductInShop?: Maybe<Scalars['Boolean']>;
  isProductLikedByUser?: Maybe<Scalars['Boolean']>;
  isProductSavedByUser?: Maybe<Scalars['Boolean']>;
  isProductSharedByUser?: Maybe<Scalars['Boolean']>;
  isSkuAvailable?: Maybe<Scalars['Boolean']>;
  loadShopifyProducts?: Maybe<Array<Maybe<ShopifyLoadedProduct>>>;
  me?: Maybe<User>;
  onBoardingCouponExistsAndNotConsumed?: Maybe<Scalars['Boolean']>;
  orderGraphStats?: Maybe<Array<Maybe<OrderGraphData>>>;
  orderStats?: Maybe<OrderStats>;
  /** This payment method allows you to recieve GHS payments via Mobile Money: paystack. */
  paystackCharge: PaystackMobileMoneyInitialiseChargeResponseDto;
  /** Get details of a transfer on your integration. */
  paystackFetchTransfer: PaystackFetchTransferResponseDto;
  /** Fetch the details of a transfer recipient */
  paystackFetchTransferRecipient: PaystackFetchTransferRecipientResponseDto;
  /** Get a list of all supported banks and their properties */
  paystackListBanks: PaystackListBanksResponseDto;
  /** List transfer recipients available on your integration */
  paystackListTransferRecipients: PaystackListTransferRecipientsResponseDto;
  /** List the transfers made on your integration. */
  paystackListTransfers: PaystackListTransfersResponseDto;
  /** Confirm an account belongs to the right customer */
  paystackResolveAccountNumber: PaystackResolveAccountNumberResponseDto;
  /** Get more information about a customer's card */
  paystackResolveCardBIN: PaystackResolveCardBinResponseDto;
  /** Confirm the authenticity of a customer's account number before sending money */
  paystackValidateAccount: PaystackValidateAccountResponseDto;
  /** Confirm the status of a paystack transaction */
  paystackVerifyTransaction: PaystackMobileMoneyResponseDto;
  /** Verify the status of a transfer on your integration. */
  paystackVerifyTransfer: PaystackVerifyTransferResponseDto;
  topDeals?: Maybe<Array<Product>>;
  topDealsBanners?: Maybe<Array<TopDealBanner>>;
  topDealsLength: Scalars['Int'];
  trendingProducts?: Maybe<Array<Product>>;
  user?: Maybe<User>;
  userGraphStats?: Maybe<Array<Maybe<UserGraphData>>>;
  userStats?: Maybe<UserStats>;
  users?: Maybe<Array<Maybe<User>>>;
  verifyAuth: Auth;
  wallet?: Maybe<Wallet>;
  walletHistory?: Maybe<Array<Maybe<WalletHistory>>>;
  walletHistoryLength: Scalars['Int'];
};


export type QueryAppBannerArgs = {
  filter: AppBannerFilter;
};


export type QueryAppBannersArgs = {
  filter?: InputMaybe<AppBannerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryBobGetCourierRatesArgs = {
  data: BobGetCourierRatesRequestDto;
};


export type QueryBobGetOrderFulfillmentsArgs = {
  data: BobGetOrderFulfillmentsRequestDto;
};


export type QueryBobGetOrdersArgs = {
  data: BobGetOrdersRequestDto;
};


export type QueryBobGetRateRequestsArgs = {
  data: BobGetRateRequestsRequestDto;
};


export type QueryBobGetRatesAtCheckoutArgs = {
  data: BobGetRatesAtCheckoutRequestDto;
};


export type QueryBobGetShipmentWaybillArgs = {
  data: BobGetShipmentWaybillRequestDto;
};


export type QueryBobGetShipmentsArgs = {
  data: BobGetShipmentsRequestDto;
};


export type QueryBobGetTrackingEventsArgs = {
  data: BobGetTrackingEventsRequestDto;
};


export type QueryChargeSubmitOtpArgs = {
  data: PaystackChargeSubmitOtpRequestDto;
};


export type QueryDeliveryLocationArgs = {
  filter: DeliveryFilter;
};


export type QueryDeliveryLocationsArgs = {
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryDeliveryLocationsLengthArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryDoesShopDomainExistArgs = {
  data: SokoWorldDomainExistsRequestDto;
};


export type QueryDoesShopExistArgs = {
  filter: ShopFilter;
};


export type QueryFeaturedCategoriesArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
};


export type QueryFindDeliveryZoneArgs = {
  location?: InputMaybe<LatLngInput>;
};


export type QueryFlutterwaveChargeArgs = {
  data: FlutterwaveMobileMoneyInitialiseChargeRequestDto;
};


export type QueryFlutterwaveCheckUserBackgroundArgs = {
  data: FlutterwaveCheckUserBackgroundRequestDto;
};


export type QueryFlutterwaveListBankBranchesArgs = {
  data: FlutterwaveListBankBranchesRequestDto;
};


export type QueryFlutterwaveListBanksArgs = {
  data: FlutterwaveListBanksRequestDto;
};


export type QueryFlutterwaveResolveAccountNumberArgs = {
  data: FlutterwaveResolveAccountNumberRequestDto;
};


export type QueryFlutterwaveResolveBvnDetailsArgs = {
  data: FlutterwaveResolveBvnDetailsRequestDto;
};


export type QueryFlutterwaveResolveCardBinArgs = {
  data: FlutterwaveResolveCardBinRequestDto;
};


export type QueryFlutterwaveVerifyTransactionArgs = {
  data: Scalars['String'];
};


export type QueryGetCampaignArgs = {
  filter?: InputMaybe<CampaignFilter>;
};


export type QueryGetCampaignsArgs = {
  filter?: InputMaybe<CampaignFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCartArgs = {
  filter?: InputMaybe<CartFilter>;
};


export type QueryGetCartsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<CartFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCartsLengthArgs = {
  filter?: InputMaybe<CartFilter>;
};


export type QueryGetCatalogArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCatalogsArgs = {
  filter?: InputMaybe<CatalogFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCatalogsLengthArgs = {
  filter?: InputMaybe<CatalogFilter>;
};


export type QueryGetCategoryMediaArgs = {
  filter: ProductCategoryFilter;
  pagination: Pagination;
};


export type QueryGetCollectionProductsArgs = {
  filter?: InputMaybe<CatalogFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCouponArgs = {
  filter: CouponFilter;
};


export type QueryGetCouponsArgs = {
  filter?: InputMaybe<CouponFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCouponsLengthArgs = {
  filter?: InputMaybe<CouponFilter>;
};


export type QueryGetCustomerArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryGetCustomerSubscriptionArgs = {
  filter?: InputMaybe<CustomerSubscriptionFilter>;
};


export type QueryGetCustomerSubscriptionsArgs = {
  filter?: InputMaybe<CustomerSubscriptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCustomersArgs = {
  filter?: InputMaybe<CustomerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetCustomersLengthArgs = {
  filter?: InputMaybe<CustomerFilter>;
};


export type QueryGetDailyOrdersSummaryArgs = {
  country: Scalars['String'];
  from: Scalars['Date'];
  to: Scalars['Date'];
};


export type QueryGetDelayedProfitPayoutsArgs = {
  country: Scalars['String'];
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDelayedProfitPayoutsLengthArgs = {
  country: Scalars['String'];
};


export type QueryGetDeliveredOrdersArgs = {
  filter?: InputMaybe<DeliveredOrdersFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDeliveryPricesArgs = {
  input?: InputMaybe<DeliveryPricesInput>;
};


export type QueryGetDeliveryZoneArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
};


export type QueryGetDeliveryZonesArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDeliveryZonesLengthArgs = {
  filter?: InputMaybe<DeliveryZonesFilter>;
};


export type QueryGetDiscountArgs = {
  filter: DiscountFilter;
};


export type QueryGetDiscountProductConditionArgs = {
  filter: DiscountProductConditionFilter;
};


export type QueryGetDiscountProductConditionsArgs = {
  filter?: InputMaybe<DiscountProductConditionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetDiscountsArgs = {
  filter?: InputMaybe<DiscountFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetExpiredCustomerSubscriptionsArgs = {
  filter?: InputMaybe<CustomerSubscriptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetForexRatesArgs = {
  filter?: InputMaybe<ForexRateFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetInAppCartArgs = {
  user_id: Scalars['ID'];
};


export type QueryGetMainCategoriesArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetNumberOfTimesDiscountWasUsedArgs = {
  input: DiscountUseFilter;
};


export type QueryGetOrderArgs = {
  filter?: InputMaybe<OrderFilter>;
};


export type QueryGetOrderStatusesStatsArgs = {
  country: Scalars['String'];
};


export type QueryGetOrdersArgs = {
  filter?: InputMaybe<OrderFilter>;
  pagination?: InputMaybe<Pagination>;
  sort?: InputMaybe<OrderSort>;
};


export type QueryGetOrdersLengthArgs = {
  filter?: InputMaybe<OrderFilter>;
};


export type QueryGetPaymentArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type QueryGetPaymentByIdArgs = {
  data: GetPaymentByIdRequestDto;
};


export type QueryGetPaymentByReferenceArgs = {
  data: GetPaymentByReferenceRequestDto;
};


export type QueryGetPaymentsArgs = {
  filter?: InputMaybe<PaymentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPaymentsLengthArgs = {
  filter?: InputMaybe<PaymentFilter>;
};


export type QueryGetPayoutRequestsArgs = {
  filter?: InputMaybe<PayoutFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPayoutRequestsLengthArgs = {
  filter?: InputMaybe<PayoutFilter>;
};


export type QueryGetPickUpLocationArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryGetPickUpLocationsArgs = {
  filter?: InputMaybe<DeliveryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPickUpLocationsLengthArgs = {
  filter?: InputMaybe<DeliveryFilter>;
};


export type QueryGetPluginArgs = {
  filter: PluginFilter;
};


export type QueryGetPluginsArgs = {
  filter?: InputMaybe<PluginFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductAssignedCategoriesArgs = {
  product_id: Scalars['ID'];
};


export type QueryGetProductCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductCategoriesLengthArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
};


export type QueryGetProductCategoryArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
};


export type QueryGetProductCombinationArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
};


export type QueryGetProductCombinationsArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductCombinationsLengthArgs = {
  filter?: InputMaybe<ProductCombinationFilter>;
};


export type QueryGetProductDiscountArgs = {
  productSKU?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductRequestsArgs = {
  filter?: InputMaybe<ProductRequestFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductsArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetProductsLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<ProductFilter>;
};


export type QueryGetProductsLikedByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductsMetricsArgs = {
  country: Scalars['String'];
};


export type QueryGetProductsSavedByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductsSharedByUserArgs = {
  userId: Scalars['ID'];
};


export type QueryGetProductsShipmentsArgs = {
  filter?: InputMaybe<ProductShipmentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPromoBannerArgs = {
  screen: Scalars['String'];
};


export type QueryGetPromoBannersArgs = {
  filter?: InputMaybe<PromoBannerFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetPromoBannersLengthArgs = {
  filter?: InputMaybe<PromoBannerFilter>;
};


export type QueryGetRandomProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetRehookLeaderboardArgs = {
  input: GetRehookLeaderboardInput;
};


export type QueryGetResellerWalletSummaryArgs = {
  supplier_id: Scalars['ID'];
};


export type QueryGetRevenueFromProfitArgs = {
  country: Scalars['String'];
};


export type QueryGetReviewArgs = {
  filter: ReviewFilter;
};


export type QueryGetReviewsArgs = {
  filter?: InputMaybe<ReviewFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetReviewsLengthArgs = {
  filter: ReviewFilter;
};


export type QueryGetSalesArgs = {
  filter?: InputMaybe<SalesFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSelfCheckoutCustomerArgs = {
  input: GetCustomerInput;
};


export type QueryGetSelfCheckoutLinkArgs = {
  shared_product_id: Scalars['ID'];
};


export type QueryGetSharedProductArgs = {
  input: GetSharedProductRequestDto;
};


export type QueryGetSharedProductsArgs = {
  filter?: InputMaybe<SharedProductFilter>;
  pagination?: InputMaybe<Pagination>;
  productFilter?: InputMaybe<ProductFilter>;
};


export type QueryGetShopArgs = {
  filter: ShopFilter;
};


export type QueryGetShopCollectionArgs = {
  filter: ShopCollectionFilter;
};


export type QueryGetShopCollectionProductsArgs = {
  filter: ShopCollectionProductsFilter;
};


export type QueryGetShopCollectionsArgs = {
  filter?: InputMaybe<ShopCollectionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopCollectionsLengthArgs = {
  filter?: InputMaybe<ShopCollectionFilter>;
};


export type QueryGetShopifyShopArgs = {
  input?: InputMaybe<FetchShopifyShopInput>;
};


export type QueryGetShopifyShopsArgs = {
  input?: InputMaybe<FetchShopifyShopsInput>;
};


export type QueryGetShopsArgs = {
  filter?: InputMaybe<ShopFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetShopsLengthArgs = {
  filter?: InputMaybe<ShopFilter>;
};


export type QueryGetSubCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSubscriptionPackageArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
};


export type QueryGetSubscriptionPackagesArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSubscriptionPaymentArgs = {
  filter?: InputMaybe<SubscriptionPaymentFilter>;
};


export type QueryGetSubscriptionPaymentsArgs = {
  filter?: InputMaybe<SubscriptionPaymentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSupplierArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type QueryGetSupplierBusinessPickupLocationsArgs = {
  filter?: InputMaybe<SupplierLocationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSupplierDailyOrdersSummaryArgs = {
  from: Scalars['Date'];
  id: Scalars['ID'];
  to: Scalars['Date'];
};


export type QueryGetSupplierPickupLocationArgs = {
  input?: InputMaybe<GetSupplierPickupLocationInput>;
};


export type QueryGetSupplierWalletSummaryArgs = {
  supplier_id: Scalars['ID'];
};


export type QueryGetSuppliersArgs = {
  filter?: InputMaybe<SupplierFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetSuppliersLengthArgs = {
  filter?: InputMaybe<SupplierFilter>;
};


export type QueryGetTermArgs = {
  filter?: InputMaybe<TermsFilter>;
};


export type QueryGetTermsArgs = {
  filter?: InputMaybe<TermsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetTermsLengthArgs = {
  filter?: InputMaybe<TermsFilter>;
};


export type QueryGetTinggPaymentMethodsArgs = {
  country: Scalars['String'];
  currency: Scalars['String'];
  phone: Scalars['String'];
};


export type QueryGetTopProductsArgs = {
  input: TopProductsRequestDto;
};


export type QueryGetTopResellersForTheWeekArgs = {
  country: Scalars['String'];
};


export type QueryGetUnverifiedProductsArgs = {
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
};


export type QueryGetUserCouponsArgs = {
  filter?: InputMaybe<CouponRedemptionFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserCouponsLengthArgs = {
  filter?: InputMaybe<CouponRedemptionFilter>;
};


export type QueryGetUserDelayedOrdersArgs = {
  user_id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetUserPaymentDetailsArgs = {
  filter?: InputMaybe<UserPaymentFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserPluginsArgs = {
  filter?: InputMaybe<UserPluginFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUserReferralsMetricsArgs = {
  username: Scalars['String'];
};


export type QueryGetUsersArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetUsersLengthArgs = {
  condition?: InputMaybe<Condition>;
  filter?: InputMaybe<UserFilter>;
};


export type QueryGetVariationArgs = {
  filter?: InputMaybe<VariationFilter>;
};


export type QueryGetVariationsArgs = {
  filter?: InputMaybe<VariationFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetVariationsLengthArgs = {
  filter?: InputMaybe<VariationFilter>;
};


export type QueryGetWalletCashRewardsHistoryArgs = {
  filter?: InputMaybe<CashRewardsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryGetWalletHistoryArgs = {
  filter?: InputMaybe<WalletHistoryFilter>;
};


export type QueryGetWalletTopupPaymentsArgs = {
  filter?: InputMaybe<WalletTopupFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryIsProductInShopArgs = {
  product_id: Scalars['ID'];
  shop_id: Scalars['ID'];
};


export type QueryIsProductLikedByUserArgs = {
  input: IsProductLikedByUserInput;
};


export type QueryIsProductSavedByUserArgs = {
  input: IsProductSavedByUserInput;
};


export type QueryIsProductSharedByUserArgs = {
  input: IsProductSharedByUserInput;
};


export type QueryIsSkuAvailableArgs = {
  sku: Scalars['String'];
};


export type QueryLoadShopifyProductsArgs = {
  integrationId: Scalars['ID'];
};


export type QueryOrderStatsArgs = {
  country: Scalars['String'];
};


export type QueryPaystackChargeArgs = {
  data: PaystackMobileMoneyInitialiseChargeRequestDto;
};


export type QueryPaystackFetchTransferArgs = {
  data: PaystackFetchTransferRequestDto;
};


export type QueryPaystackFetchTransferRecipientArgs = {
  data: PaystackFetchTransferRecipientRequestDto;
};


export type QueryPaystackListBanksArgs = {
  data: PaystackListBanksRequestDto;
};


export type QueryPaystackListTransferRecipientsArgs = {
  data: PaystackListTransferRecipientsRequestDto;
};


export type QueryPaystackListTransfersArgs = {
  data: PaystackListTransfersRequestDto;
};


export type QueryPaystackResolveAccountNumberArgs = {
  data: PaystackResolveAccountNumberRequestDto;
};


export type QueryPaystackResolveCardBinArgs = {
  data: PaystackResolveCardBinRequestDto;
};


export type QueryPaystackValidateAccountArgs = {
  data: PaystackValidateAccountRequestDto;
};


export type QueryPaystackVerifyTransactionArgs = {
  data: Scalars['String'];
};


export type QueryPaystackVerifyTransferArgs = {
  data: PaystackVerifyTransferRequestDto;
};


export type QueryTopDealsArgs = {
  filter?: InputMaybe<ProductFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryTopDealsBannersArgs = {
  filter?: InputMaybe<FeaturedCategoriesFilter>;
};


export type QueryTopDealsLengthArgs = {
  filter?: InputMaybe<ProductFilter>;
};


export type QueryTrendingProductsArgs = {
  filter?: InputMaybe<TrendingProductsFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryUserArgs = {
  id: Scalars['ID'];
};


export type QueryUserStatsArgs = {
  country: Scalars['String'];
};


export type QueryUsersArgs = {
  input?: InputMaybe<FetchUserInput>;
};


export type QueryVerifyAuthArgs = {
  input?: InputMaybe<VerifyEmailInput>;
};


export type QueryWalletArgs = {
  filter?: InputMaybe<WalletFilter>;
};


export type QueryWalletHistoryArgs = {
  filter?: InputMaybe<WalletHistoryFilter>;
  pagination?: InputMaybe<Pagination>;
};


export type QueryWalletHistoryLengthArgs = {
  filter?: InputMaybe<WalletHistoryFilter>;
};

export enum ReasonForPayment {
  /** payment record created when a customer makes payment for an order on either the storefront or the self-checkout(future) */
  OrderPurchase = 'order_purchase',
  /** payment record created when a reseller or supplier withdraws money into their physical wallet */
  PayoutWithdrawal = 'payout_withdrawal',
  /** payment record created when supplier makes payment for a plugin to be added to their account */
  PluginPurchase = 'plugin_purchase',
  /** payment record created when reseller makes payment to be credited to their wallet */
  WalletTopup = 'wallet_topup'
}

export enum ReductionType {
  Amount = 'amount',
  Percentage = 'percentage'
}

export enum RefundType {
  FullRefund = 'full_refund',
  PartRefund = 'part_refund'
}

export type RehookLeaderboard = {
  __typename?: 'RehookLeaderboard';
  leaderboard?: Maybe<Array<Maybe<Leaderboard>>>;
  leaderboard_reward_given?: Maybe<Scalars['Boolean']>;
  my_rank?: Maybe<Leaderboard>;
  number_of_participants?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  past_leaderboard_intervals?: Maybe<Array<Maybe<PastLeaderboardIntervals>>>;
  reward_brackets?: Maybe<Array<Maybe<RewardBrackets>>>;
};

export type RequestOtpResponse = {
  __typename?: 'RequestOTPResponse';
  token?: Maybe<Scalars['String']>;
};

export type RequestSupplierOtpResponse = {
  __typename?: 'RequestSupplierOTPResponse';
  token?: Maybe<Scalars['String']>;
};

export type RequestSupplierPhoneVerificationResponse = {
  __typename?: 'RequestSupplierPhoneVerificationResponse';
  code: Scalars['String'];
  token: Scalars['String'];
};

export type Results = {
  __typename?: 'Results';
  account_number?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['Int']>;
  conversion_rate?: Maybe<Scalars['Int']>;
  converted_amount?: Maybe<Scalars['Int']>;
  converted_currency_code?: Maybe<Scalars['String']>;
  currency_code?: Maybe<Scalars['String']>;
  current_country_code?: Maybe<Scalars['String']>;
  failed_payments?: Maybe<Array<Maybe<Scalars['String']>>>;
  gateway_reference_id?: Maybe<Scalars['String']>;
  merchant_transaction_id?: Maybe<Scalars['String']>;
  msisdn?: Maybe<Scalars['Int']>;
  original_country_code?: Maybe<Scalars['String']>;
  original_currency_code?: Maybe<Scalars['String']>;
  overall_status?: Maybe<Scalars['Int']>;
  payment_currency_details?: Maybe<Array<Maybe<PaymentCurrencyDetails>>>;
  payment_options?: Maybe<Array<Maybe<PaymentOptions>>>;
  payments?: Maybe<Array<Maybe<Scalars['String']>>>;
  request_amount?: Maybe<Scalars['Int']>;
  short_url?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type Review = {
  __typename?: 'Review';
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  rating: Scalars['Float'];
  reseller: User;
  user_id: Scalars['ID'];
};

export type ReviewBreakDown = {
  __typename?: 'ReviewBreakDown';
  breakDown: BreakDownItems;
  totalReviews: Scalars['Int'];
};

export type ReviewFilter = {
  id?: InputMaybe<IdOperator>;
  product_id?: InputMaybe<IdOperator>;
};

export type ReviewInput = {
  comment?: InputMaybe<Scalars['String']>;
  product_id: Scalars['ID'];
  rating: Scalars['Int'];
  user_id: Scalars['ID'];
};

export type RewardBrackets = {
  __typename?: 'RewardBrackets';
  is_minimum_value?: Maybe<Scalars['Boolean']>;
  position?: Maybe<Scalars['String']>;
  range?: Maybe<Array<Maybe<Scalars['Int']>>>;
  reward_value?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

export type Root = {
  __typename?: 'Root';
  name: Scalars['String'];
};

export enum Sort {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Sales = {
  __typename?: 'Sales';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  order_date?: Maybe<Scalars['String']>;
  order_id?: Maybe<Scalars['ID']>;
  order_value: Scalars['Int'];
  payment_reference?: Maybe<Scalars['ID']>;
  product_cost: Scalars['Int'];
  product_price?: Maybe<Scalars['Float']>;
  profit_added: Scalars['Int'];
  reseller_id?: Maybe<Scalars['ID']>;
  sku?: Maybe<Scalars['String']>;
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type SalesFilter = {
  country?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<StringOperator>;
  currency?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  order_date?: InputMaybe<StringOperator>;
  order_id?: InputMaybe<IdOperator>;
  order_value?: InputMaybe<NumberOperator>;
  payment_reference?: InputMaybe<IdOperator>;
  product_cost?: InputMaybe<NumberOperator>;
  product_price?: InputMaybe<NumberOperator>;
  profit_added?: InputMaybe<NumberOperator>;
  reseller_id?: InputMaybe<IdOperator>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  updated_at?: InputMaybe<StringOperator>;
};

export type SetSupplierPickupLocationInput = {
  location_id: Scalars['String'];
  supplier_id: Scalars['String'];
};

export type SetSupplierProductMarkupInput = {
  markup_amount: Scalars['Float'];
  markup_value: Scalars['Float'];
  product_id: Scalars['ID'];
  supplier_agreement: SupplierAgreement;
  supplier_id: Scalars['ID'];
};

export enum Settlement {
  Commission = 'Commission',
  Markup = 'Markup'
}

export type SharedProduct = {
  __typename?: 'SharedProduct';
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  long_url: Scalars['String'];
  number_of_times_sold: Scalars['Int'];
  product?: Maybe<Product>;
  product_cost_price: Scalars['Float'];
  product_id: Scalars['ID'];
  profit_added_by_reseller: Scalars['Float'];
  reseller?: Maybe<User>;
  self_checkout_link?: Maybe<Scalars['String']>;
  shared_by: Scalars['ID'];
  short_url: Scalars['String'];
  total_accumulated_profit: Scalars['Float'];
  total_accumulated_sales: Scalars['Float'];
  total_selling_price: Scalars['Float'];
  updated_at?: Maybe<Scalars['Date']>;
};

export type SharedProductFilter = {
  id?: InputMaybe<IdOperator>;
  long_url?: InputMaybe<StringOperator>;
  number_of_times_sold?: InputMaybe<NumberOperator>;
  product_cost_price?: InputMaybe<NumberOperator>;
  product_id?: InputMaybe<IdOperator>;
  profit_added_by_reseller?: InputMaybe<NumberOperator>;
  shared_by?: InputMaybe<IdOperator>;
  short_url?: InputMaybe<StringOperator>;
  total_accumulated_profit?: InputMaybe<NumberOperator>;
  total_accumulated_sales?: InputMaybe<NumberOperator>;
  total_selling_price?: InputMaybe<NumberOperator>;
};

export type ShipmentItem = {
  __typename?: 'ShipmentItem';
  id: Scalars['ID'];
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type ShipmentItemItem = {
  price: Scalars['Float'];
  quantity: Scalars['Int'];
  sku: Scalars['String'];
};

export type Shop = {
  __typename?: 'Shop';
  avatar?: Maybe<Scalars['String']>;
  /** The public-facing contact email address for the shop. Customers will use this email to communicate with the shop owner. */
  contactEmail?: Maybe<Scalars['String']>;
  country?: Maybe<CountryCode>;
  coverImage?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['String']>;
  /** The three letter code for the shop's currency. */
  currency?: Maybe<CurrencyCode>;
  /** Domain(s) the user has linked to their soko.world domain */
  customDomains?: Maybe<Array<Maybe<Scalars['String']>>>;
  deliveryAgent?: Maybe<DeliveryAgent>;
  deliveryOption?: Maybe<DeliveryOption>;
  /** The shop's meta description used in search engine results. */
  description?: Maybe<Scalars['String']>;
  /** The shop owner's email address. Tendo will use this email address to communicate with the shop owner. */
  email?: Maybe<Scalars['String']>;
  /** Indicates whether shop has undergone onboarding and setup */
  hasBeenSetup?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  /** Indicates whether shop is still receiving traffic. Use case: freeing up .tendo.com domain for other users. */
  isActive?: Maybe<Scalars['Boolean']>;
  locations?: Maybe<Array<Maybe<ShopLocationModel>>>;
  /** Full name of the shop */
  name?: Maybe<Scalars['String']>;
  ownerId: Scalars['ID'];
  paymentOptions?: Maybe<Array<PaymentOption>>;
  phone?: Maybe<Scalars['String']>;
  /** The primary domain of the shop's online store. */
  primaryDomain?: Maybe<Scalars['String']>;
  shopId?: Maybe<Scalars['ID']>;
  /** Tags associated with shop to aid shop SEO */
  shopTags?: Maybe<Array<Scalars['String']>>;
  shortUrl?: Maybe<Scalars['String']>;
  /** auto-generated slug. Not to be sent as input payload */
  slug?: Maybe<Scalars['String']>;
  /** The shop's .tendo.com domain name */
  sokoWorldDomain?: Maybe<Scalars['String']>;
  supplierId?: Maybe<Scalars['ID']>;
  updatedAt?: Maybe<Scalars['String']>;
  /** Alias for primary domain */
  url?: Maybe<Scalars['String']>;
};

export type ShopCollection = {
  __typename?: 'ShopCollection';
  banner: Scalars['String'];
  id: Scalars['ID'];
  is_active?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
};

export type ShopCollectionFilter = {
  id?: InputMaybe<IdOperator>;
  shop_id?: InputMaybe<IdOperator>;
};

export type ShopCollectionInput = {
  banner: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  shop_id: Scalars['ID'];
};

export type ShopCollectionProductFilter = {
  collection_id?: InputMaybe<IdOperator>;
};

export type ShopCollectionProductsFilter = {
  collection_id?: InputMaybe<IdOperator>;
};

export type ShopFilter = {
  avatar?: InputMaybe<StringOperator>;
  contactEmail?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  coverImage?: InputMaybe<StringOperator>;
  createdAt?: InputMaybe<DateOperator>;
  currency?: InputMaybe<StringOperator>;
  deliveryAgent?: InputMaybe<StringOperator>;
  deliveryOption?: InputMaybe<StringOperator>;
  description?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  hasBeenSetup?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  isActive?: InputMaybe<BooleanOperator>;
  name?: InputMaybe<StringOperator>;
  ownerId?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  primaryDomain?: InputMaybe<StringOperator>;
  shortUrl?: InputMaybe<StringOperator>;
  slug?: InputMaybe<StringOperator>;
  sokoWorldDomain?: InputMaybe<StringOperator>;
  supplierId?: InputMaybe<IdOperator>;
  updatedAt?: InputMaybe<DateOperator>;
  url?: InputMaybe<StringOperator>;
};

export type ShopLocationModel = {
  __typename?: 'ShopLocationModel';
  createdAt: Scalars['String'];
  id: Scalars['ID'];
  lat: Scalars['Float'];
  long: Scalars['Float'];
  shop: Shop;
  updatedAt?: Maybe<Scalars['String']>;
};

export type ShopLocationRequestDto = {
  lat: Scalars['Float'];
  long: Scalars['Float'];
};

export type ShopProductFilter = {
  shop_id?: InputMaybe<IdOperator>;
};

export type ShopifyImage = {
  __typename?: 'ShopifyImage';
  created_at?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  position?: Maybe<Scalars['Int']>;
  product_id?: Maybe<Scalars['ID']>;
  src?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  variant_ids?: Maybe<Array<Maybe<Scalars['ID']>>>;
  width?: Maybe<Scalars['Int']>;
};

export type ShopifyLoadedProduct = {
  __typename?: 'ShopifyLoadedProduct';
  body_html?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  images?: Maybe<Array<Maybe<ShopifyImage>>>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ShopifyShop = {
  __typename?: 'ShopifyShop';
  access_token?: Maybe<Scalars['String']>;
  country_code?: Maybe<Scalars['String']>;
  country_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  products?: Maybe<Array<Maybe<SyncShopifyProduct>>>;
  redirect_url?: Maybe<Scalars['String']>;
  scope?: Maybe<Scalars['String']>;
  shop: Scalars['String'];
  shop_currency?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type ShopifyShopFilter = {
  id?: InputMaybe<IdOperator>;
  shop?: InputMaybe<StringOperator>;
};

export type SokoWorldDomainExistsRequestDto = {
  /** format should be [domain].com, eg.www.mysoko.shop. Omit http:// or https:// */
  sokoWorldDomain?: InputMaybe<Scalars['String']>;
};

export type SokoWorldDomainExistsResponseDto = {
  __typename?: 'SokoWorldDomainExistsResponseDto';
  domainExists?: Maybe<Scalars['Boolean']>;
};

export enum SortOrder {
  Ascending = 'ascending',
  Descending = 'descending'
}

export type Status = {
  __typename?: 'Status';
  status_code?: Maybe<Scalars['Int']>;
  status_description?: Maybe<Scalars['String']>;
};

export type StringOperator = {
  eq?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  like?: InputMaybe<Scalars['String']>;
  notContains?: InputMaybe<Scalars['String']>;
  notEq?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  regex?: InputMaybe<Scalars['String']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  annual_plan_cost: Scalars['Float'];
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  monthly_plan_cost: Scalars['Float'];
  name: SubscriptionType;
  updated_at?: Maybe<Scalars['Date']>;
};

export type SubscriptionFilter = {
  annual_plan_cost?: InputMaybe<NumberOperator>;
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  monthly_plan_cost?: InputMaybe<NumberOperator>;
  name?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
};

export type SubscriptionInput = {
  annual_plan_cost: Scalars['Float'];
  created_at?: InputMaybe<Scalars['Date']>;
  id: Scalars['ID'];
  monthly_plan_cost: Scalars['Float'];
  name: SubscriptionType;
  updated_at?: InputMaybe<Scalars['Date']>;
};

export type SubscriptionPackage = {
  __typename?: 'SubscriptionPackage';
  annual_plan_cost: Scalars['Float'];
  created_at?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  monthly_plan_cost: Scalars['Float'];
  name: SubscriptionType;
  updated_at?: Maybe<Scalars['Date']>;
};

export type SubscriptionPaymentFilter = {
  amount_paid?: InputMaybe<NumberOperator>;
  created_at?: InputMaybe<DateOperator>;
  customer_subscription_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  payment_reference?: InputMaybe<StringOperator>;
  payment_status?: InputMaybe<StringOperator>;
  refund_deadline?: InputMaybe<DateOperator>;
  refund_request_reason?: InputMaybe<StringOperator>;
  refund_requested?: InputMaybe<BooleanOperator>;
  refunded?: InputMaybe<BooleanOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_email?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type SubscriptionPaymentHistory = {
  __typename?: 'SubscriptionPaymentHistory';
  amount_paid: Scalars['Float'];
  created_at?: Maybe<Scalars['Date']>;
  customer_subscription_id: Scalars['ID'];
  id: Scalars['ID'];
  payment_reference: Scalars['String'];
  payment_status: SubscriptionPaymentStatus;
  refund_deadline: Scalars['Date'];
  refund_request_reason?: Maybe<Scalars['String']>;
  refund_requested?: Maybe<Scalars['Boolean']>;
  refunded?: Maybe<Scalars['Boolean']>;
  updated_at?: Maybe<Scalars['Date']>;
  user_email: Scalars['String'];
  user_id: Scalars['ID'];
};

export type SubscriptionPaymentRefund = {
  __typename?: 'SubscriptionPaymentRefund';
  amount_refunded: Scalars['Float'];
  created_at?: Maybe<Scalars['Date']>;
  customer_subscription_payment_id: Scalars['ID'];
  id: Scalars['ID'];
  refund_type: RefundType;
  refunded_by_user_id: Scalars['ID'];
  updated_at?: Maybe<Scalars['Date']>;
  user_id: Scalars['ID'];
};

export enum SubscriptionPaymentStatus {
  Failed = 'failed',
  Paid = 'paid',
  Pending = 'pending'
}

export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Initialised = 'initialised'
}

export enum SubscriptionType {
  Basic = 'basic',
  Enterprise = 'enterprise',
  Pro = 'pro'
}

export type Supplier = {
  __typename?: 'Supplier';
  agreement_terms?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  business_details?: Maybe<SupplierBusiness>;
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  deletedAt?: Maybe<Scalars['Date']>;
  device_token?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  generic_name?: Maybe<Scalars['String']>;
  has_verified_email: Scalars['Boolean'];
  has_verified_phonenumber: Scalars['Boolean'];
  id: Scalars['ID'];
  name: Scalars['String'];
  payment_details?: Maybe<SupplierPaymentDetails>;
  phone?: Maybe<Scalars['String']>;
  setup_complete: Scalars['Boolean'];
  shop?: Maybe<Shop>;
  social_platform?: Maybe<Scalars['String']>;
  social_platform_token?: Maybe<Scalars['String']>;
};

export type SupplierAddDeviceTokenInput = {
  deviceToken: Scalars['String'];
  id: Scalars['ID'];
};

export enum SupplierAgreement {
  Commission = 'COMMISSION',
  Markup = 'MARKUP'
}

export enum SupplierAgreementTerms {
  Commission = 'COMMISSION',
  Markup = 'MARKUP'
}

export type SupplierAuthPayload = {
  __typename?: 'SupplierAuthPayload';
  supplier?: Maybe<Supplier>;
  token?: Maybe<Scalars['String']>;
};

export type SupplierBusiness = {
  __typename?: 'SupplierBusiness';
  business_address?: Maybe<Scalars['String']>;
  business_name?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  delivery_option?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<SupplierBusinessDocument>>>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  industry?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  registered?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  supplier_business_verified?: Maybe<Scalars['Boolean']>;
  supplier_id?: Maybe<Scalars['ID']>;
};

export type SupplierBusinessDocument = {
  __typename?: 'SupplierBusinessDocument';
  business_id?: Maybe<Scalars['ID']>;
  document?: Maybe<Scalars['String']>;
  document_name?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type SupplierBusinessInput = {
  business_address?: InputMaybe<Scalars['String']>;
  business_name: Scalars['String'];
  city: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  delivery_option?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  industry: Scalars['String'];
  logo?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postal_code?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  registered: Scalars['Boolean'];
  state?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
};

export type SupplierCreationResponse = {
  __typename?: 'SupplierCreationResponse';
  created: Scalars['Boolean'];
  verification_token?: Maybe<Scalars['String']>;
};

export type SupplierEmailChangeInput = {
  id: Scalars['ID'];
  newEmail: Scalars['String'];
};

export type SupplierFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
};

export type SupplierInput = {
  country: Scalars['String'];
  email: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  onboardingType?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type SupplierLocation = {
  __typename?: 'SupplierLocation';
  address: Scalars['String'];
  address_ext?: Maybe<Scalars['String']>;
  business_id: Scalars['ID'];
  city: Scalars['String'];
  created_at?: Maybe<Scalars['Date']>;
  deleted_at?: Maybe<Scalars['Date']>;
  gmap_data: Scalars['String'];
  id?: Maybe<Scalars['Int']>;
  lat: Scalars['String'];
  lng: Scalars['String'];
  name: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  postal_code: Scalars['String'];
  state: Scalars['String'];
  state_code: Scalars['String'];
  supplier_id?: Maybe<Scalars['ID']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type SupplierLocationFilter = {
  business_id?: InputMaybe<IdOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type SupplierPasswordChangeInput = {
  id: Scalars['ID'];
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type SupplierPasswordResetInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type SupplierPasswordResetMailInput = {
  email: Scalars['String'];
};

export type SupplierPaymentDetails = {
  __typename?: 'SupplierPaymentDetails';
  account_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  method?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  supplier_id?: Maybe<Scalars['ID']>;
};

export type SupplierProfileUpdateInput = {
  id: Scalars['ID'];
  key: Scalars['String'];
  value: Scalars['String'];
};

export type SyncShopifyProduct = {
  __typename?: 'SyncShopifyProduct';
  body_html?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['Date']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  image?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['ID']>;
  shop?: Maybe<Scalars['String']>;
  shopify_id?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['Date']>;
};

export type SyncShopifyProductInput = {
  integration_id: Scalars['ID'];
  product_ids?: InputMaybe<Array<Scalars['ID']>>;
};

export type TempCategoryInput = {
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  shop_id: Scalars['ID'];
};

export type TermInput = {
  ShippingLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  cancellationPolicy?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  estimatedDeliveryTime?: InputMaybe<Scalars['Int']>;
  estimatedDeliveryTimeUnit?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  returnPeriod?: InputMaybe<Scalars['Int']>;
  returnPolicy?: InputMaybe<Scalars['String']>;
  settlementCurrency?: InputMaybe<Scalars['String']>;
  settlementPeriod?: InputMaybe<Scalars['Int']>;
  settlementType: Settlement;
  settlementValue: Scalars['Float'];
  shipTo?: InputMaybe<Scalars['String']>;
  shippingPolicy?: InputMaybe<Scalars['String']>;
  supplier_id: Scalars['ID'];
};

export type Terms = {
  __typename?: 'Terms';
  cancellationPolicy?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  estimatedDeliveryTime?: Maybe<Scalars['Int']>;
  estimatedDeliveryTimeUnit?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  returnPeriod?: Maybe<Scalars['Int']>;
  returnPolicy?: Maybe<Scalars['String']>;
  settlementCurrency?: Maybe<Scalars['String']>;
  settlementPeriod?: Maybe<Scalars['Int']>;
  settlementType: Settlement;
  settlementValue: Scalars['Float'];
  shipTo?: Maybe<Scalars['String']>;
  shippingLocations?: Maybe<Array<Maybe<Scalars['String']>>>;
  shippingPolicy?: Maybe<Scalars['String']>;
};

export type TermsFilter = {
  description?: InputMaybe<StringOperator>;
  estimatedDeliveryTime?: InputMaybe<NumberOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  returnPeriod?: InputMaybe<NumberOperator>;
  settlementCurrency?: InputMaybe<StringOperator>;
  settlementPeriod?: InputMaybe<NumberOperator>;
  settlementType?: InputMaybe<Settlement>;
  shipTo?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
};

export type TinggAcknowledgementRequestDto = {
  /** Amount to be acknowledged.Compulsory if type is PARTIAL */
  acknowledgement_amount: Scalars['Float'];
  /** Narration of acknowledgement initiated by a merchant. */
  acknowledgement_narration: Scalars['String'];
  /** Full or Partial */
  acknowledgement_type?: InputMaybe<Scalars['String']>;
  /** Unique identifier for acknowledgement initiated by customer. */
  acknowledgment_reference?: InputMaybe<Scalars['String']>;
  /** 3 letter ISO currency code. */
  currency_code: Scalars['String'];
  /** Unique identifier from the merchant. */
  merchant_transaction_id: Scalars['String'];
  /** The service code assigned to the merchant on the tingg portal */
  service_code?: InputMaybe<Scalars['String']>;
  /**
   * The status code indicating status of the transaction on the merchant’s end
   *  * 180 - Payment rejected by merchant system
   *  * 183 - Payment accepted by the merchant system.
   *  * 188 - Payment delivered by the merchant system
   */
  status_code: TinggAcknowledgementStatusCode;
};

export type TinggAcknowledgementResponseDto = {
  __typename?: 'TinggAcknowledgementResponseDto';
  results: TinggAcknowledgementResponseResults;
  status: TinggResponseStatus;
};

export type TinggAcknowledgementResponsePayment = {
  __typename?: 'TinggAcknowledgementResponsePayment';
  /** Amount customer paid for */
  amount_paid: Scalars['Any'];
  /** ISO Currency code of the payment made */
  currency_code: Scalars['String'];
  /** Unique transaction id on the Cellulant Payment Gateway */
  gateway_transaction_id: Scalars['String'];
  gateway_transaction_status: Scalars['String'];
  /** Unique id the MNO or bank generated for the transaction */
  payer_transaction_id: Scalars['String'];
};

export type TinggAcknowledgementResponseResults = {
  __typename?: 'TinggAcknowledgementResponseResults';
  /** ID of the transaction to be acknowledged */
  checkout_request_id: Scalars['String'];
  /** Unique transaction ID identifying the transaction as given by the merchant. */
  merchant_transaction_id: Scalars['String'];
  payments: Array<Maybe<TinggAcknowledgementResponsePayment>>;
  /** A status indicating the result of payment processing. */
  request_status_code: Scalars['Any'];
};

export enum TinggAcknowledgementStatusCode {
  Accepted = 'ACCEPTED',
  Delivered = 'DELIVERED',
  Rejected = 'REJECTED'
}

export enum TinggAcknowledgementType {
  Full = 'Full',
  Partial = 'Partial'
}

export type TinggAddress = {
  /** Billing address, City. */
  city: Scalars['String'];
  /** Billing address, Country. */
  country_code: Scalars['String'];
};

export type TinggBillingDetails = {
  /** Billing Customer Details. */
  address: TinggAddress;
  /** Billing Address Details. */
  customer: TinggCustomer;
};

export type TinggBrowserDetails = {
  /** This represents the http data format. */
  accept_header?: InputMaybe<Scalars['String']>;
  /** This uniquely identifies the device on the internet. */
  ip_address: Scalars['String'];
  /** This specifies if browser supports java or not. */
  java_enabled?: InputMaybe<Scalars['Boolean']>;
  /** This specifies if browser supports javascript or not. */
  javascript_enabled?: InputMaybe<Scalars['Boolean']>;
  /** This indicates browser language. */
  language?: InputMaybe<Scalars['String']>;
  /** This is the maximum number of colors that can be displayed. */
  screen_color_depth?: InputMaybe<Scalars['String']>;
  /** This is the height value of the browser window layout viewport */
  screen_height?: InputMaybe<Scalars['String']>;
  /** This is the width value of browser window layout viewport. */
  screen_width?: InputMaybe<Scalars['String']>;
  /** This is the browser region where the same standard time is used. */
  timezone: Scalars['String'];
  /** This field contains the exact content of the HTTP User-Agent header. */
  user_agent: Scalars['String'];
};

export type TinggChargeBeneficiary = {
  /** Amount we should settle the service provider above */
  amount: Scalars['Float'];
  /** This is the client who we are to settle to on behalf of the customer. */
  charge_beneficiary_code: Scalars['String'];
};

export type TinggChargeRequestDto = {
  /** Payment the customer wished to pay. */
  charge_amount: Scalars['Float'];
  /** Mobile number used to raise the request */
  charge_msisdn: Scalars['String'];
  /** ISO country code you wish to charge the request in */
  country_code?: InputMaybe<CountryCode>;
  /** ISO Country code to initiate the payment in */
  currency_code?: InputMaybe<CurrencyCode>;
  /** this is customer email */
  customer_email: Scalars['String'];
  /** Customer first name */
  customer_first_name: Scalars['String'];
  /** Customer last name */
  customer_last_name: Scalars['String'];
  /** Initial checkout request transaction id raised by merchant */
  merchant_transaction_id?: InputMaybe<Scalars['String']>;
  /** Actual mode to initiate the payment for e.g. STK_PUSH, INSTRUCTIONS */
  payment_mode_code: Scalars['String'];
  /** The actual payer client code the merchant initiates the request for. */
  payment_option_code: Scalars['String'];
  /** The reason for making payment */
  reasonForPayment: ReasonForPayment;
};

export type TinggChargeResponseDto = {
  __typename?: 'TinggChargeResponseDto';
  results: TinggChargeResults;
  status: TinggResponseStatus;
};

export type TinggChargeResults = {
  __typename?: 'TinggChargeResults';
  /** Amount initiated for the transaction */
  charge_amount: Scalars['Int'];
  /** Mobile number the customer initiates the request for. */
  charge_msisdn: Scalars['String'];
  /** Date is UTC when the charge was initiated. */
  charge_request_date: Scalars['String'];
  /** Unique id tied to the initial payment request. */
  charge_request_id: Scalars['Int'];
  checkout_request_id: Scalars['String'];
  /** Language code you wish to display instructions for payment for. E.g fr - French, en - English, ar - Arabic, pt - Portuguese */
  language_code: Scalars['String'];
  /** Merchant requestid tied to the transaction */
  merchant_transaction_id: Scalars['String'];
  /** Payment option instructions to provide to the customer. */
  payment_instructions: Scalars['String'];
};

export type TinggCheckoutChargeRequestDto = {
  /** Account number for the customer on the merchant system. This is the reference the customer will pay to. */
  account_number?: InputMaybe<Scalars['String']>;
  /** String of the endpoint we are to send the webhook request to. */
  callback_url: Scalars['String'];
  /** 3 digit ISO code of the country you wish to collect payment for */
  country_code?: InputMaybe<Scalars['String']>;
  /** 3 digit ISO code of the currency the merchant is invoicing for. */
  currency_code?: InputMaybe<Scalars['String']>;
  /** Customer email the customer wished to pay for. */
  customer_email: Scalars['String'];
  /** Customer first name */
  customer_first_name: Scalars['String'];
  /** Customer last name */
  customer_last_name: Scalars['String'];
  /** Date when the request expires in UTC.Date format is YYYY-MM-DD HH:mm:ss */
  due_date?: InputMaybe<Scalars['String']>;
  /** Extra Information */
  extra_data?: InputMaybe<Scalars['String']>;
  /** Where we will redirect the customer to when the payment time passed above expires. */
  fail_redirect_url: Scalars['String'];
  /** Merchant's invoice number. */
  invoice_number: Scalars['String'];
  is_offline: Scalars['Boolean'];
  /** Unique Id the merchant raised for the request */
  merchant_transaction_id: Scalars['String'];
  /** Mobile number for the customer. */
  msisdn: Scalars['String'];
  /** Payment option code of the payment options the merchant wishes to collect for */
  payment_option_code?: InputMaybe<Scalars['String']>;
  /** Amount you wish to start collecting for. */
  request_amount: Scalars['Float'];
  /** Shows the description of the item being purchased. */
  request_description: Scalars['String'];
  /** The service code assigned to the merchant on the tingg portal */
  service_code?: InputMaybe<Scalars['String']>;
  /** Where we will redirect the customer to after a successful payment is made. */
  success_redirect_url: Scalars['String'];
};

export type TinggCheckoutResponseDto = {
  __typename?: 'TinggCheckoutResponseDto';
  results?: Maybe<Results>;
  status?: Maybe<Status>;
};

export type TinggCheckoutResponseLang = {
  __typename?: 'TinggCheckoutResponseLang';
  instructions?: Maybe<Scalars['String']>;
  language_code?: Maybe<Scalars['String']>;
  language_id?: Maybe<Scalars['Int']>;
  language_name?: Maybe<Scalars['String']>;
};

export type TinggCustomer = {
  /** This is the customer’s email address that is tied to the card token generated. */
  email_address: Scalars['String'];
  /** This is the customer’s first name. */
  first_name: Scalars['String'];
  /** This is the customer’s mobile number. */
  mobile_number: Scalars['String'];
  /** This is the customer’s last name. */
  surname: Scalars['String'];
};

export type TinggDirectCardRequestDto = {
  /** Billing details. */
  billing_details: TinggBillingDetails;
  /** Browser details. */
  browser_details: TinggBrowserDetails;
  /** 3 digit ISO code of the country you wish to collect payment for. */
  country_code: Scalars['String'];
  /** Extra data */
  extra_data: TinggExtraData;
  is_cvv_less?: InputMaybe<Scalars['Boolean']>;
  /** This is the language used for the transaction. */
  locale?: InputMaybe<Scalars['String']>;
  /** Unique Id the merchant raised for the request. */
  merchant_transaction_id?: InputMaybe<Scalars['String']>;
  /** Order Details. */
  order: TinggOrder;
  /** Payment option code of the payment options the merchant wishes to collect for. */
  payment_option_code?: InputMaybe<Scalars['String']>;
  /** The service code assigned to the merchant on the tingg portal. */
  service_code?: InputMaybe<Scalars['String']>;
  /** Encrypted card details. */
  source_Of_funds: Scalars['String'];
};

export type TinggDirectCardResponseDto = {
  __typename?: 'TinggDirectCardResponseDto';
  merchant_transaction_id: Scalars['String'];
  /** Null when request fails */
  results?: Maybe<TinggDirectCardResults>;
  /** Status Details */
  status?: Maybe<TinggDirectCardStatus>;
};

export type TinggDirectCardResults = {
  __typename?: 'TinggDirectCardResults';
  /** Redirect URL or page to redirect your client for payment authentication by your issuing bank. */
  redirectUrl?: Maybe<Scalars['String']>;
  /** The type of response */
  type?: Maybe<Scalars['String']>;
};

export type TinggDirectCardStatus = {
  __typename?: 'TinggDirectCardStatus';
  /** The response status code */
  status_code?: Maybe<Scalars['Int']>;
  /** Exact description of the status */
  status_description?: Maybe<Scalars['String']>;
};

export type TinggExtraData = {
  checkout_request_id?: InputMaybe<Scalars['String']>;
};

export type TinggOnPaymentFailedRequestDto = {
  currencyCode: CurrencyCode;
  customerEmail: Scalars['String'];
  merchantTransactionId: Scalars['String'];
};

export type TinggOnPaymentSuccessfulRequestDto = {
  currencyCode: CurrencyCode;
  customerEmail: Scalars['String'];
  merchantTransactionId: Scalars['String'];
  reasonForPayment: ReasonForPayment;
};

export type TinggOrder = {
  /** This is the unique reference of the order. */
  account_number?: InputMaybe<Scalars['String']>;
  /** This is the amount to be charged on the card. */
  amount: Scalars['Float'];
  /** This is the currency of the amount being transacted / charged. */
  currency_code: Scalars['String'];
  /** This contains a description of the transaction. */
  description?: InputMaybe<Scalars['String']>;
};

export type TinggPollPaymentStatusRequestDto = {
  merchant_transaction_id: Scalars['String'];
};

export type TinggPollPaymentStatusResponseDto = {
  __typename?: 'TinggPollPaymentStatusResponseDto';
  /** The reason why the payment failed when it fails */
  reasonIfFailed?: Maybe<Scalars['String']>;
  /** The payment reference or merchant_transaction_id */
  reference: Scalars['String'];
  status: PaymentStatus;
};

export type TinggQueryStatusRequestDto = {
  /** Unique identifier from the merchant concerning the request raised to Cellulant. */
  merchant_transaction_id: Scalars['String'];
};

export type TinggQueryStatusResponseDto = {
  __typename?: 'TinggQueryStatusResponseDto';
  results?: Maybe<TinggQueryStatusResult>;
  status?: Maybe<TinggQueryStatusResponseStatus>;
};

export type TinggQueryStatusResponseInstructions = {
  __typename?: 'TinggQueryStatusResponseInstructions';
  en?: Maybe<TinggQueryStatusResponseLang>;
};

export type TinggQueryStatusResponseLang = {
  __typename?: 'TinggQueryStatusResponseLang';
  instructions?: Maybe<Scalars['String']>;
  language_code?: Maybe<Scalars['String']>;
  language_id?: Maybe<Scalars['Int']>;
  language_name?: Maybe<Scalars['String']>;
};

export type TinggQueryStatusResponsePaymentCurrencyDetails = {
  __typename?: 'TinggQueryStatusResponsePaymentCurrencyDetails';
  conversion_rate?: Maybe<Scalars['Int']>;
  converted_amount?: Maybe<Scalars['Int']>;
  converted_currency?: Maybe<Scalars['String']>;
};

export type TinggQueryStatusResponsePaymentOptions = {
  __typename?: 'TinggQueryStatusResponsePaymentOptions';
  currency_code?: Maybe<Scalars['String']>;
  instructions?: Maybe<TinggQueryStatusResponseInstructions>;
  maximum_charge_amount?: Maybe<Scalars['Int']>;
  minimum_charge_amount?: Maybe<Scalars['Int']>;
  payment_option_code?: Maybe<Scalars['String']>;
  payment_option_logo?: Maybe<Scalars['String']>;
  payment_option_mode?: Maybe<Scalars['String']>;
  payment_option_name?: Maybe<Scalars['String']>;
};

export type TinggQueryStatusResponseStatus = {
  __typename?: 'TinggQueryStatusResponseStatus';
  status_code?: Maybe<Scalars['String']>;
  status_description?: Maybe<Scalars['String']>;
};

export type TinggQueryStatusResult = {
  __typename?: 'TinggQueryStatusResult';
  account_number?: Maybe<Scalars['String']>;
  amount_paid?: Maybe<Scalars['Int']>;
  conversion_rate?: Maybe<Scalars['Int']>;
  converted_amount?: Maybe<Scalars['Int']>;
  converted_currency_code?: Maybe<Scalars['String']>;
  currency_code?: Maybe<Scalars['String']>;
  current_country_code?: Maybe<Scalars['String']>;
  failed_payments?: Maybe<Array<Maybe<Scalars['Any']>>>;
  gateway_reference_id?: Maybe<Scalars['String']>;
  merchant_transaction_id?: Maybe<Scalars['String']>;
  msisdn?: Maybe<Scalars['Any']>;
  original_country_code?: Maybe<Scalars['String']>;
  original_currency_code?: Maybe<Scalars['String']>;
  overall_status?: Maybe<Scalars['Int']>;
  payment_currency_details?: Maybe<Array<Maybe<TinggQueryStatusResponsePaymentCurrencyDetails>>>;
  payment_options?: Maybe<Array<Maybe<TinggQueryStatusResponsePaymentOptions>>>;
  payments?: Maybe<Array<Maybe<Scalars['Any']>>>;
  request_amount?: Maybe<Scalars['Int']>;
  short_url?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type TinggRefundRequestDto = {
  /** Amount to be refunded. Compulsory for partial */
  amount: Scalars['Float'];
  /** 3 letter currency code for the transaction */
  currency_code?: InputMaybe<Scalars['String']>;
  /** Unique transaction ID identifying the transaction as given by the merchant. */
  merchant_transaction_id: Scalars['String'];
  /** Unique payment reference on the Cellulant Payment Gateway */
  payment_id: Scalars['String'];
  /** A reason for the refund. */
  refund_narration: Scalars['String'];
  /** Reference number for the transaction. */
  refund_reference: Scalars['String'];
  /** A flag indicating the type of refund to be done; can either be Full or Partial. */
  refund_type: Scalars['String'];
  /** The merchant's service code. */
  service_code: Scalars['String'];
};

export type TinggRefundResponseDto = {
  __typename?: 'TinggRefundResponseDto';
  results: TinggRefundResponseResults;
  status: TinggResponseStatus;
};

export type TinggRefundResponseResults = {
  __typename?: 'TinggRefundResponseResults';
  /** ID of the transaction to be acknowledged */
  checkout_request_id: Scalars['String'];
  /** Unique transaction ID identifying the transaction as given by the merchant. */
  merchant_transaction_id: Scalars['String'];
};

export type TinggResponseStatus = {
  __typename?: 'TinggResponseStatus';
  /** Status of the request initiated during. 200 -- status given for successful payment */
  status_code: Scalars['Int'];
  /** Status description */
  status_description: Scalars['String'];
};

export type TinggWebhookPayment = {
  /** Merchant reference the customer was paying for. */
  account_number: Scalars['String'];
  /** Amount customer paid for */
  amount_paid: Scalars['Float'];
  /** Unique cellulant identity */
  cpg_transaction_id: Scalars['String'];
  /** ISO Currency code of the payment made */
  currency_code: Scalars['String'];
  /** Customer name of person who made the payment */
  customer_name: Scalars['String'];
  /** When the payment was made and received */
  date_payment_received: Scalars['String'];
  /** The overall status of the payment made as described on the status code table below */
  hub_overall_status: Scalars['String'];
  /** Mobile number customer is paying for */
  msisdn: Scalars['String'];
  /** Payment option customer paid with e.g. Airtel */
  payer_client_code: Scalars['String'];
  /** Payment option customer name */
  payer_client_name: Scalars['String'];
  /** Payment description given by MNO, bank or card acquirer. */
  payer_narration: Scalars['String'];
  /** Unique id the MNO or bank generated for the transaction */
  payer_transaction_id: Scalars['String'];
  /** Code of service paid to */
  service_code: Scalars['String'];
};

export type TinggWebhookRequestDto = {
  /** Merchant reference the customer was paying for. */
  account_number: Scalars['String'];
  /** Amount the customer paid for the request. */
  amount_paid: Scalars['Float'];
  /** Unique identifier on Cellulant’s end. */
  checkout_request_id: Scalars['Int'];
  /** Abbreveiation of the country */
  country_abbrv: Scalars['String'];
  /** ISO Currency code of the payment made */
  currency_code: Scalars['String'];
  /** meta data. */
  extra_data: Scalars['String'];
  /** Array of any payment initiated but was not successfully authorized. */
  failed_payments: Array<InputMaybe<TinggWebhookPayment>>;
  /** Unique Id the merchant raised for the request */
  merchant_transaction_id: Scalars['String'];
  /** Mobile number the person came with from the merchant site. */
  msisdn: Scalars['String'];
  /** Original request amount raised by the merchant in the invoice currency */
  original_request_amount: Scalars['Float'];
  /** ISO Code of the currency code the merchant raised the request in. */
  original_request_currency_code: Scalars['String'];
  /** Array of successful payments made to the request. */
  payments: Array<InputMaybe<TinggWebhookPayment>>;
  /** Converted amount for the request raised by the merchant. */
  request_amount: Scalars['Float'];
  /** Converted currency for the request the customer made the payment in. */
  request_currency_code: Scalars['String'];
  /** Date when the request was raised in. */
  request_date: Scalars['String'];
  /**
   * Overall request code indicating whether a service was successful or paid for..
   * 177 - partially paid requests
   * 178 - indicating request was fully paid for and
   * 179 - indicating the request was partially paid for but expired.
   * 129 - Request expired without payments.
   * 180 - Request rejected by merchant
   * 183 - Request accepted by merchant we can settle the funds
   * 188 - Request received by merchant.
   */
  request_status_code: Scalars['String'];
  /** Description of the status given back on webhook request. */
  request_status_description: Scalars['String'];
  /** Charges added to the service for the request initiated. */
  service_charge_amount: Scalars['Float'];
  /** Unique service code identifying service the payment request was raised for. */
  service_code: Scalars['String'];
};

export type TinggWebhookResponseDto = {
  __typename?: 'TinggWebhookResponseDto';
  /** the unique cellulant ID on the database */
  checkout_request_id: Scalars['Int'];
  /** Unique Id the merchant raised for the request */
  merchant_transaction_id: Scalars['String'];
  /** Unique identifier of the acknowledgement response given back. */
  receipt_number: Scalars['String'];
  /** Status code to indicate if a request is received successfully, failed or accepted */
  status_code: Scalars['String'];
  /**
   *   Status code explanation.
   * 183 means successful
   * 180 means payment rejected.
   * 188 means payment received.
   */
  status_description: Scalars['String'];
};

export type TopDealBanner = {
  __typename?: 'TopDealBanner';
  id: Scalars['ID'];
  url?: Maybe<Scalars['String']>;
};

export type TopProduct = {
  __typename?: 'TopProduct';
  numberOfTimesOrdered?: Maybe<Scalars['Float']>;
  orderValue?: Maybe<Scalars['Float']>;
  product?: Maybe<Product>;
  productSKU: Scalars['String'];
  totalQuantityOrdered?: Maybe<Scalars['Float']>;
};

export type TopProductsOrderFilter = {
  cart_number?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  created_at?: InputMaybe<DateOperator>;
  customer_address_id?: InputMaybe<NumberOperator>;
  customer_id?: InputMaybe<NumberOperator>;
  delivery_id?: InputMaybe<NumberOperator>;
  delivery_instructions?: InputMaybe<StringOperator>;
  delivery_type?: InputMaybe<StringOperator>;
  discount?: InputMaybe<NumberOperator>;
  free_delivery?: InputMaybe<BooleanOperator>;
  id?: InputMaybe<IdOperator>;
  order_total?: InputMaybe<NumberOperator>;
  payment_id?: InputMaybe<StringOperator>;
  payment_method?: InputMaybe<StringOperator>;
  payment_status?: InputMaybe<StringOperator>;
  source?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<NumberOperator>;
  updated_at?: InputMaybe<DateOperator>;
  user_id?: InputMaybe<NumberOperator>;
};

export type TopProductsRequestDto = {
  /** The top (x) number of products to fetch */
  limit?: InputMaybe<Scalars['Int']>;
  /** Additional filters for orders */
  orderFilter?: InputMaybe<TopProductsOrderFilter>;
  /** Additional filters for order products */
  productFilter?: InputMaybe<OrderProductFilter>;
};

export type TopProductsResponseDto = {
  __typename?: 'TopProductsResponseDto';
  products?: Maybe<Array<Maybe<TopProduct>>>;
  totalOrderValue?: Maybe<Scalars['Float']>;
};

export type TopReseller = {
  __typename?: 'TopReseller';
  highest_amount: Scalars['Float'];
  order_count: Scalars['Int'];
  reseller?: Maybe<User>;
  total_amount: Scalars['Float'];
  user_id: Scalars['ID'];
  week?: Maybe<Scalars['String']>;
};

export type TrendingProductsFilter = {
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
};

export enum UssdTypes {
  GuarantyTrustBank = 'guaranty_trust_bank',
  SterlingBank = 'sterling_bank',
  UnitedBankOfAfrica = 'united_bank_of_africa',
  ZenithBank = 'zenith_bank'
}

export type UnshareProductRequestDto = {
  product_id: Scalars['ID'];
  shared_by: Scalars['ID'];
};

export type UpdateCampaignInput = {
  campaign_count?: InputMaybe<Scalars['Int']>;
  campaign_image_url?: InputMaybe<Scalars['String']>;
  campaign_text?: InputMaybe<Scalars['String']>;
  campaign_type?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  code_redemption_is_unlimited?: InputMaybe<Scalars['Boolean']>;
  customer_count?: InputMaybe<Scalars['Int']>;
  days?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  draft?: InputMaybe<Scalars['Boolean']>;
  end_time?: InputMaybe<Scalars['Date']>;
  expiration_date?: InputMaybe<Scalars['Date']>;
  has_advance_time?: InputMaybe<Scalars['Boolean']>;
  leader_board_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  per_customer_per_day?: InputMaybe<Scalars['Int']>;
  per_customer_per_month?: InputMaybe<Scalars['Int']>;
  per_customer_total_limit?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['Date']>;
  start_time?: InputMaybe<Scalars['Date']>;
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateDiscountData = {
  amount?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  created_by?: InputMaybe<UserType>;
  description?: InputMaybe<Scalars['String']>;
  expiry_date?: InputMaybe<Scalars['String']>;
  fixed_amount_allocation?: InputMaybe<FixedAmountAllocation>;
  is_draft?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  percentage?: InputMaybe<Scalars['Float']>;
  redemptions_limit?: InputMaybe<Scalars['Int']>;
  start_date?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<DiscountType>;
  user_id?: InputMaybe<Scalars['ID']>;
  valid_country?: InputMaybe<Scalars['String']>;
};

export type UpdateDiscountProductConditionRequestDto = {
  condition?: InputMaybe<ProductCondition>;
  id: Scalars['ID'];
  product_sku?: InputMaybe<Scalars['String']>;
};

export type UpdatePayoutInput = {
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
};

export type UpdatePluginRequestDto = {
  banner_image?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  developer?: InputMaybe<Scalars['String']>;
  endpoint?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  verified?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateProductCategoriesInput = {
  categories?: InputMaybe<Array<Scalars['ID']>>;
  product_id: Scalars['ID'];
};

export type UpdateShopDetailsRequestDto = {
  avatar?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCode>;
  coverImage?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<CurrencyCode>;
  customDomains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  deliveryAgent?: InputMaybe<DeliveryAgent>;
  deliveryOption?: InputMaybe<DeliveryOption>;
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<ShopLocationRequestDto>;
  name?: InputMaybe<Scalars['String']>;
  paymentOptions?: InputMaybe<Array<InputMaybe<PaymentOption>>>;
  phone?: InputMaybe<Scalars['String']>;
  primaryDomain?: InputMaybe<Scalars['String']>;
  shopId: Scalars['ID'];
  shopTags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sokoWorldDomain?: InputMaybe<Scalars['String']>;
};

export type UpdateShopDetailsResponseDto = {
  __typename?: 'UpdateShopDetailsResponseDto';
  shopId?: Maybe<Scalars['ID']>;
};

export type UpdateSubscriptionPackageData = {
  annual_plan_cost?: InputMaybe<Scalars['Float']>;
  monthly_plan_cost?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<SubscriptionType>;
};

export type UpdateSupplierBusinessContactInput = {
  input: UpdateSupplierBusinessContactInputOption;
  supplier_id: Scalars['ID'];
};

export type UpdateSupplierBusinessContactInputOption = {
  business_address?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierBusinessDetailsInput = {
  input: UpdateSupplierBusinessDetailsInputOptions;
  supplier_id: Scalars['ID'];
};

export type UpdateSupplierBusinessDetailsInputOptions = {
  description?: InputMaybe<Scalars['String']>;
  logo?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierDetailsData = {
  avatar?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateSupplierDetailsInput = {
  data?: InputMaybe<UpdateSupplierDetailsData>;
  id?: InputMaybe<Scalars['ID']>;
};

export type UpdateSupplierPaymentInput = {
  input: UpdateSupplierPaymentInputOptions;
  supplier_id: Scalars['ID'];
};

export type UpdateSupplierPaymentInputOptions = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  method: Scalars['String'];
  provider: Scalars['String'];
};

export type User = {
  __typename?: 'User';
  country: Scalars['String'];
  customers?: Maybe<Array<Maybe<UserCustomers>>>;
  details?: Maybe<UserDetails>;
  deviceToken?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  facebook_id?: Maybe<Scalars['String']>;
  first_order_created: Scalars['Boolean'];
  google_id?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  paymentDetails?: Maybe<UserPayment>;
  phone: Scalars['String'];
  premium_subscription?: Maybe<CustomerSubscription>;
  shop?: Maybe<Shop>;
  supplier_shop_id?: Maybe<Scalars['ID']>;
  twitter_id?: Maybe<Scalars['String']>;
  user_type?: Maybe<UserAccountType>;
  username: Scalars['String'];
  verified: Scalars['Boolean'];
  verifiedDetails?: Maybe<VerifiedDetails>;
};

export enum UserAccountType {
  Customer = 'CUSTOMER',
  Manager = 'MANAGER',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type UserCustomers = {
  __typename?: 'UserCustomers';
  address?: Maybe<Address>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  dob?: Maybe<Scalars['Date']>;
  email_verified?: Maybe<Scalars['Boolean']>;
  gender?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  phone_verified?: Maybe<Scalars['Boolean']>;
  referred_by?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UserFilter = {
  country?: InputMaybe<StringOperator>;
  email?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  name?: InputMaybe<StringOperator>;
  phone?: InputMaybe<StringOperator>;
  referred_by?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_type?: InputMaybe<StringOperator>;
  username?: InputMaybe<StringOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type UserGraphData = {
  __typename?: 'UserGraphData';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['String']>;
  month?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Int']>;
};

export type UserPayment = {
  __typename?: 'UserPayment';
  account_name?: Maybe<Scalars['String']>;
  account_number?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  method?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type UserPaymentFilter = {
  account_name?: InputMaybe<StringOperator>;
  account_number?: InputMaybe<StringOperator>;
  method?: InputMaybe<StringOperator>;
  provider?: InputMaybe<StringOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type UserPaymentInput = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  method: Scalars['String'];
  provider: Scalars['String'];
  user_id: Scalars['ID'];
};

export type UserPlugin = {
  __typename?: 'UserPlugin';
  id: Scalars['ID'];
  plugin_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type UserPluginFilter = {
  id?: InputMaybe<IdOperator>;
  plugin_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type UserReferralMetrics = {
  __typename?: 'UserReferralMetrics';
  total_referrals: Scalars['Int'];
  total_succesful_referrals: Scalars['Int'];
};

export type UserStats = {
  __typename?: 'UserStats';
  usersAllTime: Scalars['Int'];
  usersMonth: Scalars['Int'];
  usersToday: Scalars['Int'];
  usersWeek: Scalars['Int'];
  usersYear: Scalars['Int'];
};

export enum UserType {
  InHouse = 'IN_HOUSE',
  Reseller = 'RESELLER',
  Supplier = 'SUPPLIER'
}

export type Variation = {
  __typename?: 'Variation';
  id?: Maybe<Scalars['ID']>;
  variation_name: Scalars['String'];
  variation_options: Array<Maybe<VariationOption>>;
};

export type VariationFilter = {
  id?: InputMaybe<IdOperator>;
};

export type VariationInput = {
  id?: InputMaybe<Scalars['ID']>;
  variation_name: Scalars['String'];
  variation_options?: InputMaybe<Array<InputMaybe<VariationOptionInput>>>;
};

export type VariationOption = {
  __typename?: 'VariationOption';
  id?: Maybe<Scalars['ID']>;
  variation_value?: Maybe<Scalars['String']>;
};

export type VariationOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  variation_value?: InputMaybe<Scalars['String']>;
};

export type VerifiedDetails = {
  __typename?: 'VerifiedDetails';
  has_verified_email?: Maybe<Scalars['Boolean']>;
  has_verified_phonenumber?: Maybe<Scalars['Boolean']>;
  setup_complete?: Maybe<Scalars['Boolean']>;
};

export type VerifyPaymentInput = {
  reference: Scalars['String'];
};

export type VerifyProductInput = {
  id: Scalars['ID'];
  markup_amount?: InputMaybe<Scalars['Float']>;
  markup_value?: InputMaybe<Scalars['Float']>;
  supplier_agreement: SupplierAgreement;
  supplier_id?: InputMaybe<Scalars['ID']>;
};

export type Wallet = {
  __typename?: 'Wallet';
  balance: Scalars['Float'];
  deliveries: Scalars['Int'];
  history?: Maybe<Array<WalletHistory>>;
  id: Scalars['ID'];
  points: Scalars['Float'];
  supplier_id?: Maybe<Scalars['ID']>;
  user_id?: Maybe<Scalars['ID']>;
};

export type WalletFilter = {
  id?: InputMaybe<IdOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
};

export type WalletHistory = {
  __typename?: 'WalletHistory';
  amount: Scalars['Float'];
  created_at: Scalars['Date'];
  id: Scalars['ID'];
  previous_balance: Scalars['Float'];
  reference: Scalars['String'];
  status: Scalars['String'];
  transaction_type: Scalars['String'];
};

export type WalletHistoryFilter = {
  amount?: InputMaybe<MoneyOperator>;
  id?: InputMaybe<IdOperator>;
  reference?: InputMaybe<StringOperator>;
  status?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  user_id?: InputMaybe<IdOperator>;
  wallet_id?: InputMaybe<IdOperator>;
};

export type WalletSumary = {
  __typename?: 'WalletSumary';
  balance: Scalars['Float'];
  pendingPayoutRequests: Scalars['Int'];
  points: Scalars['Float'];
  totalRevenueGenerated: Scalars['Float'];
};

export type WalletTopupFilter = {
  created_at?: InputMaybe<DateOperator>;
  id?: InputMaybe<IdOperator>;
  message?: InputMaybe<StringOperator>;
  paymentReference?: InputMaybe<StringOperator>;
  updated_at?: InputMaybe<DateOperator>;
  walletTopUpStatus?: InputMaybe<StringOperator>;
};

export type WalletTopupPayment = {
  __typename?: 'WalletTopupPayment';
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  payment?: Maybe<Payment>;
  paymentReference: Scalars['String'];
  walletTopUpStatus: WalletTopupStatus;
};

export enum WalletTopupStatus {
  Failed = 'failed',
  Initiated = 'initiated',
  Success = 'success'
}

export type AccountRegisterInput = {
  country: Scalars['String'];
  details?: InputMaybe<Details>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referred_by?: InputMaybe<Scalars['String']>;
  social_login?: InputMaybe<Scalars['Boolean']>;
  supplier_shop_id?: InputMaybe<Scalars['ID']>;
};

export type AddBusinessDocumentInput = {
  business_id?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<DocumentInput>>;
};

export type AddCommentInput = {
  id: Scalars['ID'];
  message: Scalars['String'];
  staff_name: Scalars['String'];
  title: Scalars['String'];
};

export type AddCommentsToProductInput = {
  message: Scalars['String'];
  product_id: Scalars['ID'];
  staff_number: Scalars['String'];
};

export type AddSupplierPaymentInput = {
  account_name: Scalars['String'];
  account_number: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  method: Scalars['String'];
  provider: Scalars['String'];
  supplier_id: Scalars['ID'];
};

export type AuthenticateWithTokenInput = {
  token: Scalars['String'];
};

export type ChangePasswordInput = {
  confirmPassword?: InputMaybe<Scalars['String']>;
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type CheckPasswordAvailabilityInput = {
  channel?: InputMaybe<ChannelType>;
  phone: Scalars['String'];
};

export type CreateProductInput = {
  avatar: Scalars['String'];
  catalog_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  combination_string?: InputMaybe<Scalars['String']>;
  combinations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
  cost_price: Scalars['Float'];
  country: CountryCode;
  currency: CurrencyCode;
  description: Scalars['String'];
  distributionChannels?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  extra_information?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  inhouse?: InputMaybe<Scalars['Boolean']>;
  limited_stock?: InputMaybe<Scalars['Boolean']>;
  media: Array<Scalars['String']>;
  minimumOrderQuantity?: InputMaybe<Scalars['Int']>;
  price: Scalars['Float'];
  product_origin?: InputMaybe<ProductOrigin>;
  published: Scalars['Boolean'];
  qty?: InputMaybe<Scalars['Int']>;
  shop_id?: InputMaybe<Scalars['ID']>;
  sku: Scalars['String'];
  supplier_id?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['String'];
  variations?: InputMaybe<Array<InputMaybe<VariationInput>>>;
  verified: Scalars['Boolean'];
  weight?: InputMaybe<Scalars['Float']>;
};

export type DocumentInput = {
  file?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type EditProductStatInput = {
  editType: ProductStatEditType;
  product_id: Scalars['ID'];
  stat: ProductStat;
  user_id: Scalars['ID'];
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type IsProductLikedByUserInput = {
  product_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type IsProductSavedByUserInput = {
  product_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type IsProductSharedByUserInput = {
  product_id: Scalars['ID'];
  user_id: Scalars['ID'];
};

export type MakeRequestForProduct = {
  product_id: Scalars['ID'];
  qty: Scalars['Int'];
  shop_id: Scalars['ID'];
};

export type MigrationUserCreateInput = {
  country: Scalars['String'];
  details?: InputMaybe<Details>;
  email: Scalars['String'];
  name: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
  referred_by?: InputMaybe<Scalars['String']>;
  social_login?: InputMaybe<Scalars['Boolean']>;
  username?: InputMaybe<Scalars['String']>;
};

export type ProductFilter = {
  attended_to?: InputMaybe<BooleanOperator>;
  catalog?: InputMaybe<CatalogFilter>;
  category?: InputMaybe<ProductCategoryFilter>;
  combination_string?: InputMaybe<StringOperator>;
  country?: InputMaybe<StringOperator>;
  id?: InputMaybe<IdOperator>;
  inhouse?: InputMaybe<BooleanOperator>;
  main_stock?: InputMaybe<NumberOperator>;
  price?: InputMaybe<MoneyOperator>;
  published?: InputMaybe<BooleanOperator>;
  qty?: InputMaybe<NumberOperator>;
  random?: InputMaybe<Scalars['Boolean']>;
  shop?: InputMaybe<ShopProductFilter>;
  shopCollection?: InputMaybe<ShopCollectionProductFilter>;
  sku?: InputMaybe<StringOperator>;
  supplier_id?: InputMaybe<IdOperator>;
  tags?: InputMaybe<StringOperator>;
  title?: InputMaybe<StringOperator>;
  transit_stock?: InputMaybe<NumberOperator>;
  uuid?: InputMaybe<StringOperator>;
  verified?: InputMaybe<BooleanOperator>;
};

export type ProductRequestFilter = {
  product?: InputMaybe<ProductFilter>;
  qty?: InputMaybe<NumberOperator>;
  shop_id?: InputMaybe<IdOperator>;
};

export type RequestChangeEmailInput = {
  email: Scalars['String'];
  newEmail: Scalars['String'];
};

export type RequestChangePhoneInput = {
  newPhone: Scalars['String'];
  phone: Scalars['String'];
};

export type RequestEmailVerificationInput = {
  email: Scalars['String'];
};

export type RequestOtpInput = {
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

export type RequestSupplierEmailVerificationInput = {
  email: Scalars['String'];
};

export type RequestSupplierPhoneVerificationInput = {
  phone: Scalars['String'];
};

export type ResetPasswordInput = {
  password: Scalars['String'];
  token: Scalars['String'];
};

export type SetupAccountInput = {
  confirm_password: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  phone: Scalars['String'];
};

export type TempCreateProductInput = {
  avatar: Scalars['String'];
  catalog_id?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  categories?: InputMaybe<Array<InputMaybe<TempCategoryInput>>>;
  combination_string?: InputMaybe<Scalars['String']>;
  combinations?: InputMaybe<Array<InputMaybe<ProductCombinationInput>>>;
  cost_price: Scalars['Float'];
  country: CountryCode;
  currency: CurrencyCode;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  inhouse?: InputMaybe<Scalars['Boolean']>;
  limited_stock?: InputMaybe<Scalars['Boolean']>;
  media: Array<Scalars['String']>;
  price: Scalars['Float'];
  published: Scalars['Boolean'];
  qty?: InputMaybe<Scalars['Int']>;
  shop_id: Scalars['ID'];
  sku: Scalars['String'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  title: Scalars['String'];
  user_id?: InputMaybe<Scalars['ID']>;
  uuid: Scalars['String'];
  variations?: InputMaybe<Array<InputMaybe<VariationInput>>>;
  weight?: InputMaybe<Scalars['Float']>;
};

export type UpdateUserDetailsInput = {
  dob?: InputMaybe<Scalars['Date']>;
  gender?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  referred_by?: InputMaybe<Scalars['String']>;
  user_id: Scalars['Int'];
};

export type UserLoginInput = {
  deviceToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type VerifyEmailInput = {
  token: Scalars['String'];
};

export type VerifyOtpInput = {
  code: Scalars['String'];
  medium: Scalars['String'];
  token: Scalars['String'];
  update?: InputMaybe<Scalars['Boolean']>;
};

export type VerifySupplierAccountInput = {
  action: Scalars['String'];
  token: Scalars['String'];
};

export type VerifySupplierBusinessInput = {
  agreed_term?: InputMaybe<SupplierAgreementTerms>;
  genericName: Scalars['String'];
  supplier_id: Scalars['ID'];
};

export type VerifySupplierEmailInput = {
  token: Scalars['String'];
};

export type VerifySupplierOtpInput = {
  code: Scalars['String'];
  medium: Scalars['String'];
  token: Scalars['String'];
  update?: InputMaybe<Scalars['Boolean']>;
};
